// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from '@hey-api/client-axios';
import { queryOptions, type UseMutationOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { PostApiAdminBulkReplaceSpecialistData, PostApiAdminBulkReplaceSpecialistError, PostApiAdminBulkReplaceSpecialistResponse, PostApiBankingAssociationAcceptAssociationTermsData, PostApiBankingAssociationAcceptAssociationTermsError, PostApiBankingAssociationAcceptAssociationTermsResponse, PostApiBankingAssociationResetAssociationTermsError, PostApiBankingAssociationResetAssociationTermsResponse, PostApiBankingAssociationConnectLenderToBankingAssociationData, PostApiBankingAssociationConnectLenderToBankingAssociationError, PostApiBankingAssociationConnectLenderToBankingAssociationResponse, PostApiBankingAssociationRemoveLenderFromBankingAssociationData, PostApiBankingAssociationRemoveLenderFromBankingAssociationError, PostApiBankingAssociationRemoveLenderFromBankingAssociationResponse, PostApiBankingAssociationAddUserToBankingAssociationData, PostApiBankingAssociationAddUserToBankingAssociationError, PostApiBankingAssociationAddUserToBankingAssociationResponse, GetApiBankingAssociationSupervisorListLendersData, GetApiBankingAssociationSupervisorListUsersData, PostApiBankingAssociationRemoveUserFromAssociationData, PostApiBankingAssociationRemoveUserFromAssociationError, PostApiBankingAssociationRemoveUserFromAssociationResponse, PostApiBankingAssociationCreateNewBankingAssociationData, PostApiBankingAssociationCreateNewBankingAssociationError, PostApiBankingAssociationCreateNewBankingAssociationResponse, PostApiBankingAssociationSetActiveBankingAssociationData, PostApiBankingAssociationSetActiveBankingAssociationError, PostApiBankingAssociationSetActiveBankingAssociationResponse, PostApiBankingAssociationSupervisorUpdateAssociationRoleData, PostApiBankingAssociationSupervisorUpdateAssociationRoleError, PostApiBankingAssociationSupervisorUpdateAssociationRoleResponse, PostApiBorrowersStartQuickbooksLinkError, PostApiBorrowersStartQuickbooksLinkResponse, PostApiBorrowersRunQuickbooksReportError, PostApiBorrowersRunQuickbooksReportResponse, GetApiBorrowersAccountingReportSheetData, GetApiBorrowersAccountingProfitLossReportSheetData, PostApiBorrowersSyncAccountingBalanceSheetMetricsError, PostApiBorrowersSyncAccountingBalanceSheetMetricsResponse, PostApiBorrowersSyncAccountingProfitLossMetricsError, PostApiBorrowersSyncAccountingProfitLossMetricsResponse, GetApiBorrowersAccountingReportData, PostApiBorrowersDisconnectQuickbooksError, PostApiBorrowersDisconnectQuickbooksResponse, PostApiBorrowersDisconnectPlaidError, PostApiBorrowersDisconnectPlaidResponse, PostApiBorrowersFinishQuickbooksLinkData, PostApiBorrowersFinishQuickbooksLinkError, PostApiBorrowersFinishQuickbooksLinkResponse, PostApiBorrowersAnalyzeBankStatementsError, PostApiBorrowersAnalyzeBankStatementsResponse, PostApiBorrowersExchangePlaidTokenData, PostApiBorrowersExchangePlaidTokenError, PostApiBorrowersExchangePlaidTokenResponse, PostApiBorrowersRemoveUserData, PostApiBorrowersRemoveUserError, PostApiBorrowersRemoveUserResponse, PostApiBorrowersChangeUserAccessData, PostApiBorrowersChangeUserAccessError, PostApiBorrowersChangeUserAccessResponse, GetApiBorrowersGetEvaluationResultsData, PostApiBorrowersLandingPageApplyData, PostApiBorrowersLandingPageApplyError, PostApiBorrowersLandingPageApplyResponse, PostApiBorrowersUpdateIsSignatoryData, PostApiBorrowersUpdateIsSignatoryError, PostApiBorrowersUpdateIsSignatoryResponse, GetApiBorrowersGetBorrowerUsersData, PostApiBorrowersSetActiveBorrowerData, PostApiBorrowersSetActiveBorrowerError, PostApiBorrowersSetActiveBorrowerResponse, PostApiBorrowersAcceptTermsData, PostApiBorrowersAcceptTermsError, PostApiBorrowersAcceptTermsResponse, PostApiBorrowersEvaluateLandingData, PostApiBorrowersEvaluateLandingError, PostApiBorrowersEvaluateLandingResponse, GetApiBorrowersEvaluateFundingOptionsData, PostApiBorrowersEvaluateFundingOptionsData, PostApiBorrowersEvaluateFundingOptionsError, PostApiBorrowersEvaluateFundingOptionsResponse, GetApiBorrowersEvaluateBorrowerFundingOptionsData, GetApiBorrowersEvaluateData, PostApiBorrowersAdminAddBorrowerUserData, PostApiBorrowersAdminAddBorrowerUserError, PostApiBorrowersAdminAddBorrowerUserResponse, GetApiBorrowersCashBasedProfitLossReportData, GetApiBorrowersActiveCashBasedProfitLossReportData, GetApiBorrowersGetBorrowerAdditionalFilesData, PostApiBorrowersMoveProfileFileData, PostApiBorrowersMoveProfileFileError, PostApiBorrowersMoveProfileFileResponse, PostApiBorrowersUploadBorrowerProfileFileData, PostApiBorrowersUploadBorrowerProfileFileError, PostApiBorrowersUploadBorrowerProfileFileResponse, PostApiBorrowersRenameProfileFileData, PostApiBorrowersRenameProfileFileError, PostApiBorrowersRenameProfileFileResponse, PostApiBorrowersApproveAdditionalFileData, PostApiBorrowersApproveAdditionalFileError, PostApiBorrowersApproveAdditionalFileResponse, PostApiBorrowersRenameAdditionalFileData, PostApiBorrowersRenameAdditionalFileError, PostApiBorrowersRenameAdditionalFileResponse, PostApiBorrowersUploadBorrowerAdditionalFileData, PostApiBorrowersUploadBorrowerAdditionalFileError, PostApiBorrowersUploadBorrowerAdditionalFileResponse, PostApiBorrowersDeleteBorrowerData, PostApiBorrowersDeleteBorrowerError, PostApiBorrowersDeleteBorrowerResponse, PostApiBorrowersDeleteBorrowerAdditionalFileData, PostApiBorrowersDeleteBorrowerAdditionalFileError, PostApiBorrowersDeleteBorrowerAdditionalFileResponse, PostApiBorrowersDeleteBorrowerProfileFileData, PostApiBorrowersDeleteBorrowerProfileFileError, PostApiBorrowersDeleteBorrowerProfileFileResponse, GetApiBorrowersDownloadAdditionalFileData, GetApiBorrowersDownloadProfileFileData, PostApiBorrowersCreateAdditionalBorrowerError, PostApiBorrowersCreateAdditionalBorrowerResponse, PostApiBorrowersOnboardAdditionalBorrowerData, PostApiBorrowersOnboardAdditionalBorrowerError, PostApiBorrowersOnboardAdditionalBorrowerResponse, PostApiBorrowersOnboardBorrowerData, PostApiBorrowersOnboardBorrowerError, PostApiBorrowersOnboardBorrowerResponse, PostApiBorrowersUpdateCompanyNameData, PostApiBorrowersUpdateCompanyNameError, PostApiBorrowersUpdateCompanyNameResponse, PostApiBorrowersUpdateBorrowerProfileData, PostApiBorrowersUpdateBorrowerProfileError, PostApiBorrowersUpdateBorrowerProfileResponse, PostApiCmsSyncBorrowerData, PostApiCmsSyncBorrowerError, PostApiCmsSyncBorrowerResponse, PostApiCmsSyncLenderData, PostApiCmsSyncLenderError, PostApiCmsSyncLenderResponse, PostApiCmsSyncAssociationData, PostApiCmsSyncAssociationError, PostApiCmsSyncAssociationResponse, PostApiCmsSyncLoanData, PostApiCmsSyncLoanError, PostApiCmsSyncLoanResponse, PostApiCmsSyncUserData, PostApiCmsSyncUserError, PostApiCmsSyncUserResponse, GetApiLendersGroupLendersData, PostApiLendersCreateLenderGroupData, PostApiLendersCreateLenderGroupError, PostApiLendersCreateLenderGroupResponse, GetApiLendersLoansForLenderGroupData, PostApiLendersInviteChildLenderData, PostApiLendersInviteChildLenderError, PostApiLendersInviteChildLenderResponse, PostApiLendersUpdateOnboardingStateData, PostApiLendersUpdateOnboardingStateError, PostApiLendersUpdateOnboardingStateResponse, PostApiLendersRemoveLenderFromGroupData, PostApiLendersRemoveLenderFromGroupError, PostApiLendersRemoveLenderFromGroupResponse, PostApiLendersAssignLenderToGroupData, PostApiLendersAssignLenderToGroupError, PostApiLendersAssignLenderToGroupResponse, GetApiLendersProfileFilesData, PostApiLendersRemoveLenderUserData, PostApiLendersRemoveLenderUserError, PostApiLendersRemoveLenderUserResponse, PostApiLendersUpdateLenderGroupData, PostApiLendersUpdateLenderGroupError, PostApiLendersUpdateLenderGroupResponse, PostApiLendersUpdateLenderUserData, PostApiLendersUpdateLenderUserError, PostApiLendersUpdateLenderUserResponse, PostApiLendersUploadLenderProfileFileData, PostApiLendersUploadLenderProfileFileError, PostApiLendersUploadLenderProfileFileResponse, PostApiLendersRenameLenderProfileFileData, PostApiLendersRenameLenderProfileFileError, PostApiLendersRenameLenderProfileFileResponse, PostApiLendersDeleteLenderProfileFileData, PostApiLendersDeleteLenderProfileFileError, PostApiLendersDeleteLenderProfileFileResponse, PostApiLendersDownloadLenderTermsFileData, PostApiLendersDownloadLenderTermsFileError, PostApiLendersDownloadLenderTermsFileResponse, PostApiLendersDownloadLenderProfileFileData, PostApiLendersDownloadLenderProfileFileError, PostApiLendersDownloadLenderProfileFileResponse, PostApiLendersSpecialistRemoveLenderUserData, PostApiLendersSpecialistRemoveLenderUserError, PostApiLendersSpecialistRemoveLenderUserResponse, PostApiLendersSpecialistAddLenderUserData, PostApiLendersSpecialistAddLenderUserError, PostApiLendersSpecialistAddLenderUserResponse, GetApiLendersGetLenderUsersData, PostApiLendersSetMatchingEnabledData, PostApiLendersSetMatchingEnabledError, PostApiLendersSetMatchingEnabledResponse, GetApiLendersSpecialistReadLenderProfileData, GetApiLendersSpecialistGetLenderProfileData, PostApiLendersDeleteLenderData, PostApiLendersDeleteLenderError, PostApiLendersDeleteLenderResponse, PostApiLendersUpdateConnectedBrandData, PostApiLendersUpdateConnectedBrandError, PostApiLendersUpdateConnectedBrandResponse, PostApiLendersCreateNewLenderData, PostApiLendersCreateNewLenderError, PostApiLendersCreateNewLenderResponse, PostApiLendersCreateCollateralData, PostApiLendersCreateCollateralError, PostApiLendersCreateCollateralResponse, PostApiLendersSetActiveLenderData, PostApiLendersSetActiveLenderError, PostApiLendersSetActiveLenderResponse, PostApiLendersReferBorrowerData, PostApiLendersReferBorrowerError, PostApiLendersReferBorrowerResponse, PostApiLendersCreateCovenantData, PostApiLendersCreateCovenantError, PostApiLendersCreateCovenantResponse, GetApiLendersGetLenderCriteriaData, PostApiLendersUpdateLenderAdminData, PostApiLendersUpdateLenderAdminError, PostApiLendersUpdateLenderAdminResponse, PostApiLendersAssignUserToDepartmentData, PostApiLendersAssignUserToDepartmentError, PostApiLendersAssignUserToDepartmentResponse, PostApiLendersUpdateLoanAccessUsersData, PostApiLendersUpdateLoanAccessUsersError, PostApiLendersUpdateLoanAccessUsersResponse, PostApiLendersDeleteDepartmentData, PostApiLendersDeleteDepartmentError, PostApiLendersDeleteDepartmentResponse, PostApiLendersCreateDepartmentData, PostApiLendersCreateDepartmentError, PostApiLendersCreateDepartmentResponse, GetApiLendersLoanAccessUsersData, GetApiLendersLenderProfileNotesData, GetApiLendersDepartmentLoansData, GetApiLendersGetLenderLoansData, PostApiLendersAddLenderProfileNoteData, PostApiLendersAddLenderProfileNoteError, PostApiLendersAddLenderProfileNoteResponse, PostApiLendersSpecialistUpdateLenderProfileData, PostApiLendersSpecialistUpdateLenderProfileError, PostApiLendersSpecialistUpdateLenderProfileResponse, PostApiLendersUpdateLenderRegionProfileData, PostApiLendersUpdateLenderRegionProfileError, PostApiLendersUpdateLenderRegionProfileResponse, PostApiLendersUpdateLenderProfileData, PostApiLendersUpdateLenderProfileError, PostApiLendersUpdateLenderProfileResponse, PostApiLendersAdminResetLenderTermsData, PostApiLendersAdminResetLenderTermsError, PostApiLendersAdminResetLenderTermsResponse, PostApiLendersAcceptLenderTermsData, PostApiLendersAcceptLenderTermsError, PostApiLendersAcceptLenderTermsResponse, PostApiLendersUpdateLenderCriteriaData, PostApiLendersUpdateLenderCriteriaError, PostApiLendersUpdateLenderCriteriaResponse, PostApiLenderApplicationsExpressInterestData, PostApiLenderApplicationsExpressInterestError, PostApiLenderApplicationsExpressInterestResponse, PostApiLenderApplicationsSpecialistUpdateUnderwritingStateData, PostApiLenderApplicationsSpecialistUpdateUnderwritingStateError, PostApiLenderApplicationsSpecialistUpdateUnderwritingStateResponse, PostApiLenderApplicationsSpecialistExpressInterestData, PostApiLenderApplicationsSpecialistExpressInterestError, PostApiLenderApplicationsSpecialistExpressInterestResponse, PostApiLenderApplicationsAddLenderApplicationNoteData, PostApiLenderApplicationsAddLenderApplicationNoteError, PostApiLenderApplicationsAddLenderApplicationNoteResponse, GetApiLenderApplicationsGetLenderApplicationNotesData, GetApiLenderApplicationsGetLenderAppAuditLogData, PostApiLoanApplicationsRefreshBorrowerProfileData, PostApiLoanApplicationsRefreshBorrowerProfileError, PostApiLoanApplicationsRefreshBorrowerProfileResponse, GetApiLoanApplicationsImportantAuditData, PostApiLoanApplicationsCompleteTriageData, PostApiLoanApplicationsCompleteTriageError, PostApiLoanApplicationsCompleteTriageResponse, PostApiLoanApplicationsForceCloseLoanData, PostApiLoanApplicationsForceCloseLoanError, PostApiLoanApplicationsForceCloseLoanResponse, GetApiLoanApplicationsGetLoanAuditLogData, GetApiLoanApplicationsGetAllLoansData, PostApiLoanApplicationsAdminOverrideStatusData, PostApiLoanApplicationsAdminOverrideStatusError, PostApiLoanApplicationsAdminOverrideStatusResponse, PostApiLoanApplicationsCancelLoanData, PostApiLoanApplicationsCancelLoanError, PostApiLoanApplicationsCancelLoanResponse, PostApiLoanApplicationsSubmitSignedClosingFilesData, PostApiLoanApplicationsSubmitSignedClosingFilesError, PostApiLoanApplicationsSubmitSignedClosingFilesResponse, PostApiLoanApplicationsSubmitClosingFilesData, PostApiLoanApplicationsSubmitClosingFilesError, PostApiLoanApplicationsSubmitClosingFilesResponse, PostApiLoanApplicationsSubmitFinalClosingFilesData, PostApiLoanApplicationsSubmitFinalClosingFilesError, PostApiLoanApplicationsSubmitFinalClosingFilesResponse, GetApiLoanApplicationsOutgoingLenderApplicationsData, PostApiLoanApplicationsSpecialistDeclineLoanData, PostApiLoanApplicationsSpecialistDeclineLoanError, PostApiLoanApplicationsSpecialistDeclineLoanResponse, PostApiLoanApplicationsApproveSignedClosingData, PostApiLoanApplicationsApproveSignedClosingError, PostApiLoanApplicationsApproveSignedClosingResponse, PostApiLoanApplicationsDeclineLoanData, PostApiLoanApplicationsDeclineLoanError, PostApiLoanApplicationsDeclineLoanResponse, PostApiLoanApplicationsDeclineSignedClosingData, PostApiLoanApplicationsDeclineSignedClosingError, PostApiLoanApplicationsDeclineSignedClosingResponse, PostApiLoanApplicationsApproveClosingData, PostApiLoanApplicationsApproveClosingError, PostApiLoanApplicationsApproveClosingResponse, PostApiLoanApplicationsDeclineClosingData, PostApiLoanApplicationsDeclineClosingError, PostApiLoanApplicationsDeclineClosingResponse, PostApiLoanApplicationsApproveFinalClosingDocsData, PostApiLoanApplicationsApproveFinalClosingDocsError, PostApiLoanApplicationsApproveFinalClosingDocsResponse, PostApiLoanApplicationsConfirmFundingData, PostApiLoanApplicationsConfirmFundingError, PostApiLoanApplicationsConfirmFundingResponse, PostApiLoanApplicationsMarkLoanNotFundedData, PostApiLoanApplicationsMarkLoanNotFundedError, PostApiLoanApplicationsMarkLoanNotFundedResponse, PostApiLoanApplicationsCloseLoanData, PostApiLoanApplicationsCloseLoanError, PostApiLoanApplicationsCloseLoanResponse, PostApiLoanApplicationsApproveSignedBindingData, PostApiLoanApplicationsApproveSignedBindingError, PostApiLoanApplicationsApproveSignedBindingResponse, PostApiLoanApplicationsWithdrawLenderFromLoanData, PostApiLoanApplicationsWithdrawLenderFromLoanError, PostApiLoanApplicationsWithdrawLenderFromLoanResponse, PostApiLoanApplicationsDeclineSignedBindingData, PostApiLoanApplicationsDeclineSignedBindingError, PostApiLoanApplicationsDeclineSignedBindingResponse, PostApiLoanApplicationsSpecialistUpdateLoanAskData, PostApiLoanApplicationsSpecialistUpdateLoanAskError, PostApiLoanApplicationsSpecialistUpdateLoanAskResponse, PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteData, PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteError, PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteResponse, GetApiLoanApplicationsGetAdditionalFilesData, PostApiLoanApplicationsUpdateLoanApplicationOnHoldData, PostApiLoanApplicationsUpdateLoanApplicationOnHoldError, PostApiLoanApplicationsUpdateLoanApplicationOnHoldResponse, PostApiLoanApplicationsRevertTermSheetData, PostApiLoanApplicationsRevertTermSheetError, PostApiLoanApplicationsRevertTermSheetResponse, PostApiLoanApplicationsUpdateOfferDeadlineData, PostApiLoanApplicationsUpdateOfferDeadlineError, PostApiLoanApplicationsUpdateOfferDeadlineResponse, GetApiLoanApplicationsGetLenderLoanAuditData, GetApiLoanApplicationsGetBorrowerReviewFilesData, PostApiLoanApplicationsDeleteBorrowerReviewFileData, PostApiLoanApplicationsDeleteBorrowerReviewFileError, PostApiLoanApplicationsDeleteBorrowerReviewFileResponse, PostApiLoanApplicationsUploadBorrowerReviewFilesData, PostApiLoanApplicationsUploadBorrowerReviewFilesError, PostApiLoanApplicationsUploadBorrowerReviewFilesResponse, PostApiLoanApplicationsRequestLenderSubmissionData, PostApiLoanApplicationsRequestLenderSubmissionError, PostApiLoanApplicationsRequestLenderSubmissionResponse, PostApiLoanApplicationsUploadAdditionalFileData, PostApiLoanApplicationsUploadAdditionalFileError, PostApiLoanApplicationsUploadAdditionalFileResponse, PostApiLoanApplicationsDeleteAdditionalFileData, PostApiLoanApplicationsDeleteAdditionalFileError, PostApiLoanApplicationsDeleteAdditionalFileResponse, GetApiLoanApplicationsGetAcceptedOffersData, GetApiLoanApplicationsDownloadAdditionalFileData, GetApiLoanApplicationsGetBorrowerTemplateExportData, PostApiLoanApplicationsGetBorrowerPackageExportData, PostApiLoanApplicationsGetBorrowerPackageExportError, PostApiLoanApplicationsGetBorrowerPackageExportResponse, PostApiLoanApplicationsGenerateLenderSummaryData, PostApiLoanApplicationsGenerateLenderSummaryError, PostApiLoanApplicationsGenerateLenderSummaryResponse, PostApiLoanApplicationsGenerateLoanPreviewData, PostApiLoanApplicationsGenerateLoanPreviewError, PostApiLoanApplicationsGenerateLoanPreviewResponse, PostApiLoanApplicationsUpdateLoanPreviewData, PostApiLoanApplicationsUpdateLoanPreviewError, PostApiLoanApplicationsUpdateLoanPreviewResponse, GetApiLoanApplicationsDownloadFinancialExportData, GetApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsData, PostApiLoanApplicationsSetExpectedCloseDateData, PostApiLoanApplicationsSetExpectedCloseDateError, PostApiLoanApplicationsSetExpectedCloseDateResponse, PostApiLoanApplicationsSetExpectedFundsDateData, PostApiLoanApplicationsSetExpectedFundsDateError, PostApiLoanApplicationsSetExpectedFundsDateResponse, PostApiLoanApplicationsRevertAttestationData, PostApiLoanApplicationsRevertAttestationError, PostApiLoanApplicationsRevertAttestationResponse, PostApiLoanApplicationsReviewSubmissionData, PostApiLoanApplicationsReviewSubmissionError, PostApiLoanApplicationsReviewSubmissionResponse, PostApiLoanApplicationsUpdateLoanApplicationData, PostApiLoanApplicationsUpdateLoanApplicationError, PostApiLoanApplicationsUpdateLoanApplicationResponse, PostApiLoanApplicationsAttestLoanApplicationData, PostApiLoanApplicationsAttestLoanApplicationError, PostApiLoanApplicationsAttestLoanApplicationResponse, PostApiLoanApplicationsCompleteOnboardingData, PostApiLoanApplicationsCompleteOnboardingError, PostApiLoanApplicationsCompleteOnboardingResponse, PostApiLoanApplicationsCompleteManualStepData, PostApiLoanApplicationsCompleteManualStepError, PostApiLoanApplicationsCompleteManualStepResponse, GetApiLoanApplicationsGetEngagedLendersData, PostApiLoanApplicationsApproveAdditionalFileData, PostApiLoanApplicationsApproveAdditionalFileError, PostApiLoanApplicationsApproveAdditionalFileResponse, PostApiLoanApplicationsRenameAdditionalFileData, PostApiLoanApplicationsRenameAdditionalFileError, PostApiLoanApplicationsRenameAdditionalFileResponse, GetApiLoanApplicationsGetApplicationNotesData, PostApiLoanApplicationsUpdateApplicationNoteData, PostApiLoanApplicationsUpdateApplicationNoteError, PostApiLoanApplicationsUpdateApplicationNoteResponse, PostApiLoanApplicationsDeleteApplicationNoteData, PostApiLoanApplicationsDeleteApplicationNoteError, PostApiLoanApplicationsDeleteApplicationNoteResponse, PostApiLoanApplicationsAddApplicationNoteData, PostApiLoanApplicationsAddApplicationNoteError, PostApiLoanApplicationsAddApplicationNoteResponse, PostApiLoanApplicationsAddLenderProfileNoteData, PostApiLoanApplicationsAddLenderProfileNoteError, PostApiLoanApplicationsAddLenderProfileNoteResponse, GetApiLoanApplicationsParticipatingLoanApplicationData, GetApiLoanApplicationsGetProfileFilesData, GetApiLoanApplicationsGetLoanApplicationPreviewData, GetApiLoanApplicationsGetLoanApplicationData, PostApiLoanApplicationsUpdateLenderSummaryData, PostApiLoanApplicationsUpdateLenderSummaryError, PostApiLoanApplicationsUpdateLenderSummaryResponse, PostApiLoanApplicationsUpdateLoanCommentaryData, PostApiLoanApplicationsUpdateLoanCommentaryError, PostApiLoanApplicationsUpdateLoanCommentaryResponse, PostApiLoanApplicationsUpdateLoanObjectiveData, PostApiLoanApplicationsUpdateLoanObjectiveError, PostApiLoanApplicationsUpdateLoanObjectiveResponse, PostApiLoanApplicationsUpdateProbabilityOfCloseData, PostApiLoanApplicationsUpdateProbabilityOfCloseError, PostApiLoanApplicationsUpdateProbabilityOfCloseResponse, PostApiLoanApplicationsCreateLoanApplicationData, PostApiLoanApplicationsCreateLoanApplicationError, PostApiLoanApplicationsCreateLoanApplicationResponse, PostApiLoanApplicationsUpdateDiligenceStatusData, PostApiLoanApplicationsUpdateDiligenceStatusError, PostApiLoanApplicationsUpdateDiligenceStatusResponse, PostApiLoanApplicationsApproveLoanData, PostApiLoanApplicationsApproveLoanError, PostApiLoanApplicationsApproveLoanResponse, GetApiLoanApplicationsDownloadBorrowerReviewFileData, GetApiLoanApplicationsGetCalculatedMatchedLendersData, GetApiLoanApplicationsEngageableLendersData, PostApiLoanApplicationsAssignSpecialistData, PostApiLoanApplicationsAssignSpecialistError, PostApiLoanApplicationsAssignSpecialistResponse, PostApiLoanApplicationsAssignAdditionalLenderData, PostApiLoanApplicationsAssignAdditionalLenderError, PostApiLoanApplicationsAssignAdditionalLenderResponse, PostApiLoanApplicationsAssignAdditionalLendersData, PostApiLoanApplicationsAssignAdditionalLendersError, PostApiLoanApplicationsAssignAdditionalLendersResponse, PostApiLoanApplicationsWithdrawUnsubmittedLendersData, PostApiLoanApplicationsWithdrawUnsubmittedLendersError, PostApiLoanApplicationsWithdrawUnsubmittedLendersResponse, GetApiLoanApplicationsAccessLoanApplicationData, GetApiLoanApplicationsGetTermSheetsData, GetApiOffersGetOffersForReviewData, PostApiOffersReturnOffersToLendersData, PostApiOffersReturnOffersToLendersError, PostApiOffersReturnOffersToLendersResponse, PostApiOffersRenameOfferFileData, PostApiOffersRenameOfferFileError, PostApiOffersRenameOfferFileResponse, GetApiOffersDownloadOfferFileData, PostApiOffersDeleteOfferFileData, PostApiOffersDeleteOfferFileError, PostApiOffersDeleteOfferFileResponse, GetApiOffersGetOfferFilesData, PostApiOffersApproveOffersData, PostApiOffersApproveOffersError, PostApiOffersApproveOffersResponse, PostApiOffersUploadOfferFileData, PostApiOffersUploadOfferFileError, PostApiOffersUploadOfferFileResponse, PostApiOffersSubmitNonBindingOfferData, PostApiOffersSubmitNonBindingOfferError, PostApiOffersSubmitNonBindingOfferResponse, PostApiOffersSubmitBindingOfferData, PostApiOffersSubmitBindingOfferError, PostApiOffersSubmitBindingOfferResponse, PostApiOffersAcceptLoanOfferData, PostApiOffersAcceptLoanOfferError, PostApiOffersAcceptLoanOfferResponse, PostApiOffersDeclineLoanOfferData, PostApiOffersDeclineLoanOfferError, PostApiOffersDeclineLoanOfferResponse, GetApiOffersDownloadOfferPackageData, PostApiMessagesUploadMessageFileAttachmentsError, PostApiMessagesUploadMessageFileAttachmentsResponse, GetApiMessagesDownloadLoanAppMessageAttachmentData, GetApiMessagesGetLoanAppMessagesData, PostApiMessagesSendLoanAppMessageData, PostApiMessagesSendLoanAppMessageError, PostApiMessagesSendLoanAppMessageResponse, PostApiPartnersSetActivePartnerData, PostApiPartnersSetActivePartnerError, PostApiPartnersSetActivePartnerResponse, PostApiPartnersUploadPartnerFileData, PostApiPartnersUploadPartnerFileError, PostApiPartnersUploadPartnerFileResponse, PostApiPartnersDeletePartnerFileData, PostApiPartnersDeletePartnerFileError, PostApiPartnersDeletePartnerFileResponse, PostApiPartnersDownloadPartnerFileData, PostApiPartnersDownloadPartnerFileError, PostApiPartnersDownloadPartnerFileResponse, GetApiPartnersPartnerFilesData, PostApiPartnersDeleteDepartmentData, PostApiPartnersDeleteDepartmentError, PostApiPartnersDeleteDepartmentResponse, PostApiPartnersDeletePartnerLoanData, PostApiPartnersDeletePartnerLoanError, PostApiPartnersDeletePartnerLoanResponse, PostApiPartnersUpdatePartnerLoanData, PostApiPartnersUpdatePartnerLoanError, PostApiPartnersUpdatePartnerLoanResponse, PostApiPartnersAssignUserToDepartmentData, PostApiPartnersAssignUserToDepartmentError, PostApiPartnersAssignUserToDepartmentResponse, PostApiPartnersUpdateUserRoleData, PostApiPartnersUpdateUserRoleError, PostApiPartnersUpdateUserRoleResponse, PostApiPartnersAssignLoanToPartnerUserData, PostApiPartnersAssignLoanToPartnerUserError, PostApiPartnersAssignLoanToPartnerUserResponse, PostApiPartnersUpdatePartnerUserData, PostApiPartnersUpdatePartnerUserError, PostApiPartnersUpdatePartnerUserResponse, GetApiPartnersDepartmentLoansData, GetApiPartnersUserLoansData, PostApiPartnersInvitePartnerUserData, PostApiPartnersInvitePartnerUserError, PostApiPartnersInvitePartnerUserResponse, PostApiPartnersCreateDepartmentData, PostApiPartnersCreateDepartmentError, PostApiPartnersCreateDepartmentResponse, PostApiPartnersReferBorrowerData, PostApiPartnersReferBorrowerError, PostApiPartnersReferBorrowerResponse, GetApiPartnersSupervisorListLoansData, PostApiPartnersSupervisorUpdatePartnerRoleData, PostApiPartnersSupervisorUpdatePartnerRoleError, PostApiPartnersSupervisorUpdatePartnerRoleResponse, GetApiPartnersSupervisorListBorrowersData, GetApiPartnersSupervisorListUsersData, GetApiPartnersListGroupLoansData, PostApiPartnersDeleteData, PostApiPartnersDeleteError, PostApiPartnersDeleteResponse, PostApiPartnersUpdateData, PostApiPartnersUpdateError, PostApiPartnersUpdateResponse, PostApiPartnersCreateData, PostApiPartnersCreateError, PostApiPartnersCreateResponse, PostApiPartnersAddUserToPartnerData, PostApiPartnersAddUserToPartnerError, PostApiPartnersAddUserToPartnerResponse, PostApiPartnersRemoveUserFromPartnerData, PostApiPartnersRemoveUserFromPartnerError, PostApiPartnersRemoveUserFromPartnerResponse, PostApiPartnersSupervisorAddLoanToPartnerData, PostApiPartnersSupervisorAddLoanToPartnerError, PostApiPartnersSupervisorAddLoanToPartnerResponse, PostApiPartnersSupervisorRemoveLoanFromPartnerData, PostApiPartnersSupervisorRemoveLoanFromPartnerError, PostApiPartnersSupervisorRemoveLoanFromPartnerResponse, PostApiPartnersSupervisorAddBorrowerData, PostApiPartnersSupervisorAddBorrowerError, PostApiPartnersSupervisorAddBorrowerResponse, PostApiPartnersSupervisorRemoveBorrowerFromPartnerData, PostApiPartnersSupervisorRemoveBorrowerFromPartnerError, PostApiPartnersSupervisorRemoveBorrowerFromPartnerResponse, PostApiPartnersCreatePartnerGroupData, PostApiPartnersCreatePartnerGroupError, PostApiPartnersCreatePartnerGroupResponse, PostApiPartnersUpdatePartnerGroupData, PostApiPartnersUpdatePartnerGroupError, PostApiPartnersUpdatePartnerGroupResponse, PostApiPartnersDeletePartnerGroupData, PostApiPartnersDeletePartnerGroupError, PostApiPartnersDeletePartnerGroupResponse, PostApiPartnersAssignPartnerToGroupData, PostApiPartnersAssignPartnerToGroupError, PostApiPartnersAssignPartnerToGroupResponse, GetApiPartnersGetPartnerGroupData, PostApiReferralsUploadReferralFilesError, PostApiReferralsUploadReferralFilesResponse, GetApiReferralsDownloadReferralPackageData, PostApiReferralsSpecialistSubmitReferralData, PostApiReferralsSpecialistSubmitReferralError, PostApiReferralsSpecialistSubmitReferralResponse, PostApiReferralsSubmitReferralData, PostApiReferralsSubmitReferralError, PostApiReferralsSubmitReferralResponse, PostApiReferralsSetLoanAppReferralData, PostApiReferralsSetLoanAppReferralError, PostApiReferralsSetLoanAppReferralResponse, PostApiReferralsUpdateReferralStateData, PostApiReferralsUpdateReferralStateError, PostApiReferralsUpdateReferralStateResponse, PostApiReferralsUpdateReferralData, PostApiReferralsUpdateReferralError, PostApiReferralsUpdateReferralResponse, PostApiReferralsUpdateReferralDashboardNoteData, PostApiReferralsUpdateReferralDashboardNoteError, PostApiReferralsUpdateReferralDashboardNoteResponse, GetApiTemplatesEvaluateWithDefaultTemplateData, PostApiTemplatesRecommendGenericLoanTypeData, PostApiTemplatesRecommendGenericLoanTypeError, PostApiTemplatesRecommendGenericLoanTypeResponse, GetApiTemplatesEvaluateWithTemplateData, PostApiTemplatesValidateCustomMetricFormulaData, PostApiTemplatesValidateCustomMetricFormulaError, PostApiTemplatesValidateCustomMetricFormulaResponse, PostApiTemplatesCreateCustomMetricData, PostApiTemplatesCreateCustomMetricError, PostApiTemplatesCreateCustomMetricResponse, PostApiTemplatesUpdateCustomMetricData, PostApiTemplatesUpdateCustomMetricError, PostApiTemplatesUpdateCustomMetricResponse, PostApiTemplatesDeleteCustomMetricData, PostApiTemplatesDeleteCustomMetricError, PostApiTemplatesDeleteCustomMetricResponse, PostApiTemplatesCreateData, PostApiTemplatesCreateError, PostApiTemplatesCreateResponse, PostApiTemplatesUpdateData, PostApiTemplatesUpdateError, PostApiTemplatesUpdateResponse, PostApiTemplatesDeleteData, PostApiTemplatesDeleteError, PostApiTemplatesDeleteResponse, PostApiUsersStartResetPasswordData, PostApiUsersStartResetPasswordError, PostApiUsersStartResetPasswordResponse, GetApiUsersCheckPasswordResetTokenData, PostApiUsersResetPasswordData, PostApiUsersResetPasswordError, PostApiUsersResetPasswordResponse, GetApiUsersNotificationsData, PostApiUsersDismissAllNotificationsData, PostApiUsersDismissAllNotificationsError, PostApiUsersDismissAllNotificationsResponse, GetApiUsersUserHistoryData, GetApiUsersUserLendersData, GetApiUsersUserBackgroundCheckData, PostApiUsersUserUpdateBackgroundCheckData, PostApiUsersUserUpdateBackgroundCheckError, PostApiUsersUserUpdateBackgroundCheckResponse, GetApiUsersUserBorrowersData, PostApiUsersUpdateProfileData, PostApiUsersUpdateProfileError, PostApiUsersUpdateProfileResponse, GetApiUsersUserActivityData, PostApiUsersInviteData, PostApiUsersInviteError, PostApiUsersInviteResponse } from '../types.gen';
import type { AxiosError } from 'axios';
import { client, postApiAdminBulkReplaceSpecialist, postApiBankingAssociationAcceptAssociationTerms, postApiBankingAssociationResetAssociationTerms, postApiBankingAssociationConnectLenderToBankingAssociation, getApiBankingAssociationListReferredLoans, getApiBankingAssociationListLenderLoans, getApiBankingAssociationListHubspotLenderAssociations, postApiBankingAssociationRemoveLenderFromBankingAssociation, postApiBankingAssociationAddUserToBankingAssociation, getApiBankingAssociationSupervisorListLenders, getApiBankingAssociationSupervisorListUsers, postApiBankingAssociationRemoveUserFromAssociation, getApiBankingAssociationList, postApiBankingAssociationCreateNewBankingAssociation, postApiBankingAssociationSetActiveBankingAssociation, postApiBankingAssociationSupervisorUpdateAssociationRole, getApiBankingAssociationBankAssociationContext, getApiBorrowersPlaidLink, postApiBorrowersStartQuickbooksLink, postApiBorrowersRunQuickbooksReport, getApiBorrowersAccountingReportSheet, getApiBorrowersAccountingProfitLossReportSheet, postApiBorrowersSyncAccountingBalanceSheetMetrics, postApiBorrowersSyncAccountingProfitLossMetrics, getApiBorrowersAccountingReport, postApiBorrowersDisconnectQuickbooks, postApiBorrowersDisconnectPlaid, postApiBorrowersFinishQuickbooksLink, getApiBorrowersListTransactions, postApiBorrowersAnalyzeBankStatements, postApiBorrowersExchangePlaidToken, getApiBorrowersUsers, postApiBorrowersRemoveUser, postApiBorrowersChangeUserAccess, getApiBorrowersGetAll, getApiBorrowersGetBorrowers, getApiBorrowersGetRsgDashboardViewmodel, getApiBorrowersGetEvaluationResults, postApiBorrowersLandingPageApply, postApiBorrowersUpdateIsSignatory, getApiBorrowersGetBorrowerUsers, postApiBorrowersSetActiveBorrower, getApiBorrowersGetGlossary, postApiBorrowersAcceptTerms, postApiBorrowersEvaluateLanding, getApiBorrowersEvaluateFundingOptions, postApiBorrowersEvaluateFundingOptions, getApiBorrowersEvaluateBorrowerFundingOptions, getApiBorrowersEvaluate, postApiBorrowersAdminAddBorrowerUser, getApiBorrowersCashBasedProfitLossReport, getApiBorrowersActiveCashBasedProfitLossReport, getApiBorrowersBorrowerDetails, getApiBorrowersGetBorrowerAdditionalFiles, getApiBorrowersGetBorrowerProfileFiles, postApiBorrowersMoveProfileFile, postApiBorrowersUploadBorrowerProfileFile, postApiBorrowersRenameProfileFile, postApiBorrowersApproveAdditionalFile, postApiBorrowersRenameAdditionalFile, postApiBorrowersUploadBorrowerAdditionalFile, postApiBorrowersDeleteBorrower, postApiBorrowersDeleteBorrowerAdditionalFile, postApiBorrowersDeleteBorrowerProfileFile, getApiBorrowersDownloadAdditionalFile, getApiBorrowersDownloadProfileFile, postApiBorrowersCreateAdditionalBorrower, postApiBorrowersOnboardAdditionalBorrower, postApiBorrowersOnboardBorrower, postApiBorrowersUpdateCompanyName, postApiBorrowersUpdateBorrowerProfile, postApiCmsSyncBorrower, postApiCmsSyncLender, postApiCmsSyncAssociation, postApiCmsSyncLoan, postApiCmsSyncUser, getApiEvaluationLoanSimulatorHistory, getApiLendersGetLenderTypeHierarchy, getApiLendersLenderGroups, getApiLendersGroupLenders, postApiLendersCreateLenderGroup, getApiLendersLoansForLenderGroup, postApiLendersInviteChildLender, postApiLendersUpdateOnboardingState, postApiLendersRemoveLenderFromGroup, postApiLendersAssignLenderToGroup, getApiLendersProfileFiles, postApiLendersRemoveLenderUser, postApiLendersUpdateLenderGroup, postApiLendersUpdateLenderUser, postApiLendersUploadLenderProfileFile, postApiLendersRenameLenderProfileFile, postApiLendersDeleteLenderProfileFile, postApiLendersDownloadLenderTermsFile, postApiLendersDownloadLenderProfileFile, postApiLendersSpecialistRemoveLenderUser, postApiLendersSpecialistAddLenderUser, getApiLendersGetLenderUsers, postApiLendersSetMatchingEnabled, getApiLendersSpecialistReadLenderProfile, getApiLendersGetCurrentLenderUsers, getApiLendersSpecialistGetLenderProfile, getApiLendersGetLenderProfile, getApiLendersGetFullLenderExport, getApiLendersGetLoanHistoryExport, getApiLendersGetWidgetHistoryExport, postApiLendersDeleteLender, postApiLendersUpdateConnectedBrand, getApiLendersAll, getApiLendersGetCovenants, getApiLendersGetCollaterals, postApiLendersCreateNewLender, postApiLendersCreateCollateral, postApiLendersSetActiveLender, getApiLendersListReferrals, postApiLendersReferBorrower, postApiLendersCreateCovenant, getApiLendersGetLenderCriteria, getApiLendersLenderAdmin, getApiLendersListDepartments, postApiLendersUpdateLenderAdmin, postApiLendersAssignUserToDepartment, postApiLendersUpdateLoanAccessUsers, postApiLendersDeleteDepartment, postApiLendersCreateDepartment, getApiLendersCriteriaCompletion, getApiLendersProfileCompletion, getApiLendersLoanAccessUsers, getApiLendersCurrentRates, getApiLendersLenderProfileNotes, getApiLendersDepartmentLoans, getApiLendersLenderCriteriaReport, getApiLendersGetLenderLoans, postApiLendersAddLenderProfileNote, postApiLendersSpecialistUpdateLenderProfile, postApiLendersUpdateLenderRegionProfile, postApiLendersUpdateLenderProfile, postApiLendersAdminResetLenderTerms, postApiLendersAcceptLenderTerms, postApiLendersUpdateLenderCriteria, postApiLenderApplicationsExpressInterest, postApiLenderApplicationsSpecialistUpdateUnderwritingState, postApiLenderApplicationsSpecialistExpressInterest, postApiLenderApplicationsAddLenderApplicationNote, getApiLenderApplicationsGetLenderApplicationNotes, getApiLenderApplicationsGetLenderAppAuditLog, postApiLoanApplicationsRefreshBorrowerProfile, getApiLoanApplicationsImportantAudit, postApiLoanApplicationsCompleteTriage, postApiLoanApplicationsForceCloseLoan, getApiLoanApplicationsTriageLoans, getApiLoanApplicationsSkippedLoans, getApiLoanApplicationsSupervisorLoans, getApiLoanApplicationsGetLoanAuditLog, getApiLoanApplicationsGetAllLoans, getApiLoanApplicationsActiveLoans, postApiLoanApplicationsAdminOverrideStatus, postApiLoanApplicationsCancelLoan, postApiLoanApplicationsSubmitSignedClosingFiles, postApiLoanApplicationsSubmitClosingFiles, postApiLoanApplicationsSubmitFinalClosingFiles, getApiLoanApplicationsOutgoingLenderApplications, postApiLoanApplicationsSpecialistDeclineLoan, postApiLoanApplicationsApproveSignedClosing, postApiLoanApplicationsDeclineLoan, postApiLoanApplicationsDeclineSignedClosing, postApiLoanApplicationsApproveClosing, postApiLoanApplicationsDeclineClosing, postApiLoanApplicationsApproveFinalClosingDocs, postApiLoanApplicationsConfirmFunding, postApiLoanApplicationsMarkLoanNotFunded, postApiLoanApplicationsCloseLoan, postApiLoanApplicationsApproveSignedBinding, postApiLoanApplicationsWithdrawLenderFromLoan, postApiLoanApplicationsDeclineSignedBinding, postApiLoanApplicationsSpecialistUpdateLoanAsk, postApiLoanApplicationsUpdateLoanApplicationDashboardNote, getApiLoanApplicationsGetAdditionalFiles, postApiLoanApplicationsUpdateLoanApplicationOnHold, getApiLoanApplicationsChartLoanData, getApiLoanApplicationsChartTermSheetData, postApiLoanApplicationsRevertTermSheet, postApiLoanApplicationsUpdateOfferDeadline, getApiLoanApplicationsGetLenderLoanAudit, getApiLoanApplicationsGetBorrowerReviewFiles, postApiLoanApplicationsDeleteBorrowerReviewFile, postApiLoanApplicationsUploadBorrowerReviewFiles, postApiLoanApplicationsRequestLenderSubmission, postApiLoanApplicationsUploadAdditionalFile, postApiLoanApplicationsDeleteAdditionalFile, getApiLoanApplicationsGetAcceptedOffers, getApiLoanApplicationsDownloadAdditionalFile, getApiLoanApplicationsGetBorrowerTemplateExport, postApiLoanApplicationsGetBorrowerPackageExport, getApiLoanApplicationsLenderReferredLoans, postApiLoanApplicationsGenerateLenderSummary, postApiLoanApplicationsGenerateLoanPreview, postApiLoanApplicationsUpdateLoanPreview, getApiLoanApplicationsDownloadFinancialExport, getApiLoanApplicationsGetLoanApplications, getApiLoanApplicationsSpecialistGetBorrowerLoanApplications, postApiLoanApplicationsSetExpectedCloseDate, postApiLoanApplicationsSetExpectedFundsDate, postApiLoanApplicationsRevertAttestation, postApiLoanApplicationsReviewSubmission, postApiLoanApplicationsUpdateLoanApplication, postApiLoanApplicationsAttestLoanApplication, postApiLoanApplicationsCompleteOnboarding, postApiLoanApplicationsCompleteManualStep, getApiLoanApplicationsGetEngagedLenders, postApiLoanApplicationsApproveAdditionalFile, postApiLoanApplicationsRenameAdditionalFile, getApiLoanApplicationsGetApplicationNotes, postApiLoanApplicationsUpdateApplicationNote, postApiLoanApplicationsDeleteApplicationNote, postApiLoanApplicationsAddApplicationNote, postApiLoanApplicationsAddLenderProfileNote, getApiLoanApplicationsParticipatingLoanApplication, getApiLoanApplicationsGetProfileFiles, getApiLoanApplicationsGetLoanApplicationPreview, getApiLoanApplicationsGetLoanApplication, postApiLoanApplicationsUpdateLenderSummary, postApiLoanApplicationsUpdateLoanCommentary, postApiLoanApplicationsUpdateLoanObjective, postApiLoanApplicationsUpdateProbabilityOfClose, postApiLoanApplicationsCreateLoanApplication, postApiLoanApplicationsUpdateDiligenceStatus, postApiLoanApplicationsApproveLoan, getApiLoanApplicationsDownloadBorrowerReviewFile, getApiLoanApplicationsGetCalculatedMatchedLenders, getApiLoanApplicationsEngageableLenders, postApiLoanApplicationsAssignSpecialist, postApiLoanApplicationsAssignAdditionalLender, postApiLoanApplicationsAssignAdditionalLenders, postApiLoanApplicationsWithdrawUnsubmittedLenders, getApiLoanApplicationsAccessLoanApplication, getApiLoanApplicationsGetTermSheets, getApiOffersGetOffersForReview, postApiOffersReturnOffersToLenders, postApiOffersRenameOfferFile, getApiOffersDownloadOfferFile, postApiOffersDeleteOfferFile, getApiOffersGetOfferFiles, postApiOffersApproveOffers, postApiOffersUploadOfferFile, postApiOffersSubmitNonBindingOffer, postApiOffersSubmitBindingOffer, postApiOffersAcceptLoanOffer, postApiOffersDeclineLoanOffer, getApiOffersDownloadOfferPackage, postApiMessagesUploadMessageFileAttachments, getApiMessagesDownloadLoanAppMessageAttachment, getApiMessagesGetLoanAppMessages, postApiMessagesSendLoanAppMessage, postApiPartnersSetActivePartner, postApiPartnersUploadPartnerFile, postApiPartnersDeletePartnerFile, postApiPartnersDownloadPartnerFile, getApiPartnersPartnerFiles, getApiPartnersList, postApiPartnersDeleteDepartment, getApiPartnersListDepartments, getApiPartnersListUsers, postApiPartnersDeletePartnerLoan, postApiPartnersUpdatePartnerLoan, getApiPartnersCapitalSimulatorHistory, postApiPartnersAssignUserToDepartment, postApiPartnersUpdateUserRole, postApiPartnersAssignLoanToPartnerUser, postApiPartnersUpdatePartnerUser, getApiPartnersDepartmentLoans, getApiPartnersUserLoans, postApiPartnersInvitePartnerUser, postApiPartnersCreateDepartment, postApiPartnersReferBorrower, getApiPartnersBorrowers, getApiPartnersLoanPartners, getApiPartnersLoans, getApiPartnersSupervisorListLoans, postApiPartnersSupervisorUpdatePartnerRole, getApiPartnersSupervisorListBorrowers, getApiPartnersSupervisorListUsers, getApiPartnersListGroupLoans, postApiPartnersDelete, postApiPartnersUpdate, postApiPartnersCreate, postApiPartnersAddUserToPartner, postApiPartnersRemoveUserFromPartner, postApiPartnersSupervisorAddLoanToPartner, postApiPartnersSupervisorRemoveLoanFromPartner, postApiPartnersSupervisorAddBorrower, postApiPartnersSupervisorRemoveBorrowerFromPartner, postApiPartnersCreatePartnerGroup, postApiPartnersUpdatePartnerGroup, postApiPartnersDeletePartnerGroup, postApiPartnersAssignPartnerToGroup, getApiPartnersGetPartnerGroups, getApiPartnersGetPartnerGroup, postApiReferralsUploadReferralFiles, getApiReferralsDownloadReferralPackage, postApiReferralsSpecialistSubmitReferral, postApiReferralsSubmitReferral, postApiReferralsSetLoanAppReferral, postApiReferralsUpdateReferralState, postApiReferralsUpdateReferral, postApiReferralsUpdateReferralDashboardNote, getApiReferralsGetAllReferrals, getApiReferralsGetReferralsForLender, getApiTemplatesEvaluateWithDefaultTemplate, postApiTemplatesRecommendGenericLoanType, getApiTemplatesEvaluateRsgDashboard, getApiTemplatesEvaluateWithTemplate, getApiTemplatesList, getApiTemplatesTemplateMap, postApiTemplatesValidateCustomMetricFormula, getApiTemplatesCustomMetrics, postApiTemplatesCreateCustomMetric, postApiTemplatesUpdateCustomMetric, postApiTemplatesDeleteCustomMetric, postApiTemplatesCreate, postApiTemplatesUpdate, postApiTemplatesDelete, getApiUsersAll, postApiUsersStartResetPassword, getApiUsersCheckPasswordResetToken, postApiUsersResetPassword, getApiUsersNotifications, postApiUsersDismissAllNotifications, getApiUsersUserHistory, getApiUsersGetFullAuditExport, getApiUsersUserLenders, getApiUsersUserBackgroundCheck, postApiUsersUserUpdateBackgroundCheck, getApiUsersUserBorrowers, getApiUsersPartnerContext, getApiUsersLenderContext, getApiUsersBorrowerContext, getApiUsersMe, postApiUsersUpdateProfile, getApiUsersGetSpecialistUsers, getApiUsersUserActivity, postApiUsersInvite } from '../services.gen';

type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): QueryKey<TOptions>[0] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: client.getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return params;
};

export const postApiAdminBulkReplaceSpecialistQueryKey = (options?: Options<PostApiAdminBulkReplaceSpecialistData>) => [
    createQueryKey("postApiAdminBulkReplaceSpecialist", options)
];

export const postApiAdminBulkReplaceSpecialistOptions = (options?: Options<PostApiAdminBulkReplaceSpecialistData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiAdminBulkReplaceSpecialist({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiAdminBulkReplaceSpecialistQueryKey(options)
}); };

export const postApiAdminBulkReplaceSpecialistMutation = () => { const mutationOptions: UseMutationOptions<PostApiAdminBulkReplaceSpecialistResponse, AxiosError<PostApiAdminBulkReplaceSpecialistError>, Options<PostApiAdminBulkReplaceSpecialistData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiAdminBulkReplaceSpecialist({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBankingAssociationAcceptAssociationTermsQueryKey = (options?: Options<PostApiBankingAssociationAcceptAssociationTermsData>) => [
    createQueryKey("postApiBankingAssociationAcceptAssociationTerms", options)
];

export const postApiBankingAssociationAcceptAssociationTermsOptions = (options?: Options<PostApiBankingAssociationAcceptAssociationTermsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationAcceptAssociationTerms({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationAcceptAssociationTermsQueryKey(options)
}); };

export const postApiBankingAssociationAcceptAssociationTermsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationAcceptAssociationTermsResponse, AxiosError<PostApiBankingAssociationAcceptAssociationTermsError>, Options<PostApiBankingAssociationAcceptAssociationTermsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationAcceptAssociationTerms({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBankingAssociationResetAssociationTermsQueryKey = (options?: Options) => [
    createQueryKey("postApiBankingAssociationResetAssociationTerms", options)
];

export const postApiBankingAssociationResetAssociationTermsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationResetAssociationTerms({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationResetAssociationTermsQueryKey(options)
}); };

export const postApiBankingAssociationResetAssociationTermsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationResetAssociationTermsResponse, AxiosError<PostApiBankingAssociationResetAssociationTermsError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationResetAssociationTerms({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBankingAssociationConnectLenderToBankingAssociationQueryKey = (options?: Options<PostApiBankingAssociationConnectLenderToBankingAssociationData>) => [
    createQueryKey("postApiBankingAssociationConnectLenderToBankingAssociation", options)
];

export const postApiBankingAssociationConnectLenderToBankingAssociationOptions = (options?: Options<PostApiBankingAssociationConnectLenderToBankingAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationConnectLenderToBankingAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationConnectLenderToBankingAssociationQueryKey(options)
}); };

export const postApiBankingAssociationConnectLenderToBankingAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationConnectLenderToBankingAssociationResponse, AxiosError<PostApiBankingAssociationConnectLenderToBankingAssociationError>, Options<PostApiBankingAssociationConnectLenderToBankingAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationConnectLenderToBankingAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBankingAssociationListReferredLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiBankingAssociationListReferredLoans", options)
];

export const getApiBankingAssociationListReferredLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationListReferredLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationListReferredLoansQueryKey(options)
}); };

export const getApiBankingAssociationListLenderLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiBankingAssociationListLenderLoans", options)
];

export const getApiBankingAssociationListLenderLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationListLenderLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationListLenderLoansQueryKey(options)
}); };

export const getApiBankingAssociationListHubspotLenderAssociationsQueryKey = (options?: Options) => [
    createQueryKey("getApiBankingAssociationListHubspotLenderAssociations", options)
];

export const getApiBankingAssociationListHubspotLenderAssociationsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationListHubspotLenderAssociations({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationListHubspotLenderAssociationsQueryKey(options)
}); };

export const postApiBankingAssociationRemoveLenderFromBankingAssociationQueryKey = (options?: Options<PostApiBankingAssociationRemoveLenderFromBankingAssociationData>) => [
    createQueryKey("postApiBankingAssociationRemoveLenderFromBankingAssociation", options)
];

export const postApiBankingAssociationRemoveLenderFromBankingAssociationOptions = (options?: Options<PostApiBankingAssociationRemoveLenderFromBankingAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationRemoveLenderFromBankingAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationRemoveLenderFromBankingAssociationQueryKey(options)
}); };

export const postApiBankingAssociationRemoveLenderFromBankingAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationRemoveLenderFromBankingAssociationResponse, AxiosError<PostApiBankingAssociationRemoveLenderFromBankingAssociationError>, Options<PostApiBankingAssociationRemoveLenderFromBankingAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationRemoveLenderFromBankingAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBankingAssociationAddUserToBankingAssociationQueryKey = (options?: Options<PostApiBankingAssociationAddUserToBankingAssociationData>) => [
    createQueryKey("postApiBankingAssociationAddUserToBankingAssociation", options)
];

export const postApiBankingAssociationAddUserToBankingAssociationOptions = (options?: Options<PostApiBankingAssociationAddUserToBankingAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationAddUserToBankingAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationAddUserToBankingAssociationQueryKey(options)
}); };

export const postApiBankingAssociationAddUserToBankingAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationAddUserToBankingAssociationResponse, AxiosError<PostApiBankingAssociationAddUserToBankingAssociationError>, Options<PostApiBankingAssociationAddUserToBankingAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationAddUserToBankingAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBankingAssociationSupervisorListLendersQueryKey = (options?: Options<GetApiBankingAssociationSupervisorListLendersData>) => [
    createQueryKey("getApiBankingAssociationSupervisorListLenders", options)
];

export const getApiBankingAssociationSupervisorListLendersOptions = (options?: Options<GetApiBankingAssociationSupervisorListLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationSupervisorListLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationSupervisorListLendersQueryKey(options)
}); };

export const getApiBankingAssociationSupervisorListUsersQueryKey = (options?: Options<GetApiBankingAssociationSupervisorListUsersData>) => [
    createQueryKey("getApiBankingAssociationSupervisorListUsers", options)
];

export const getApiBankingAssociationSupervisorListUsersOptions = (options?: Options<GetApiBankingAssociationSupervisorListUsersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationSupervisorListUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationSupervisorListUsersQueryKey(options)
}); };

export const postApiBankingAssociationRemoveUserFromAssociationQueryKey = (options?: Options<PostApiBankingAssociationRemoveUserFromAssociationData>) => [
    createQueryKey("postApiBankingAssociationRemoveUserFromAssociation", options)
];

export const postApiBankingAssociationRemoveUserFromAssociationOptions = (options?: Options<PostApiBankingAssociationRemoveUserFromAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationRemoveUserFromAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationRemoveUserFromAssociationQueryKey(options)
}); };

export const postApiBankingAssociationRemoveUserFromAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationRemoveUserFromAssociationResponse, AxiosError<PostApiBankingAssociationRemoveUserFromAssociationError>, Options<PostApiBankingAssociationRemoveUserFromAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationRemoveUserFromAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBankingAssociationListQueryKey = (options?: Options) => [
    createQueryKey("getApiBankingAssociationList", options)
];

export const getApiBankingAssociationListOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationList({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationListQueryKey(options)
}); };

export const postApiBankingAssociationCreateNewBankingAssociationQueryKey = (options?: Options<PostApiBankingAssociationCreateNewBankingAssociationData>) => [
    createQueryKey("postApiBankingAssociationCreateNewBankingAssociation", options)
];

export const postApiBankingAssociationCreateNewBankingAssociationOptions = (options?: Options<PostApiBankingAssociationCreateNewBankingAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationCreateNewBankingAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationCreateNewBankingAssociationQueryKey(options)
}); };

export const postApiBankingAssociationCreateNewBankingAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationCreateNewBankingAssociationResponse, AxiosError<PostApiBankingAssociationCreateNewBankingAssociationError>, Options<PostApiBankingAssociationCreateNewBankingAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationCreateNewBankingAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBankingAssociationSetActiveBankingAssociationQueryKey = (options?: Options<PostApiBankingAssociationSetActiveBankingAssociationData>) => [
    createQueryKey("postApiBankingAssociationSetActiveBankingAssociation", options)
];

export const postApiBankingAssociationSetActiveBankingAssociationOptions = (options?: Options<PostApiBankingAssociationSetActiveBankingAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationSetActiveBankingAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationSetActiveBankingAssociationQueryKey(options)
}); };

export const postApiBankingAssociationSetActiveBankingAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationSetActiveBankingAssociationResponse, AxiosError<PostApiBankingAssociationSetActiveBankingAssociationError>, Options<PostApiBankingAssociationSetActiveBankingAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationSetActiveBankingAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBankingAssociationSupervisorUpdateAssociationRoleQueryKey = (options?: Options<PostApiBankingAssociationSupervisorUpdateAssociationRoleData>) => [
    createQueryKey("postApiBankingAssociationSupervisorUpdateAssociationRole", options)
];

export const postApiBankingAssociationSupervisorUpdateAssociationRoleOptions = (options?: Options<PostApiBankingAssociationSupervisorUpdateAssociationRoleData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBankingAssociationSupervisorUpdateAssociationRole({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBankingAssociationSupervisorUpdateAssociationRoleQueryKey(options)
}); };

export const postApiBankingAssociationSupervisorUpdateAssociationRoleMutation = () => { const mutationOptions: UseMutationOptions<PostApiBankingAssociationSupervisorUpdateAssociationRoleResponse, AxiosError<PostApiBankingAssociationSupervisorUpdateAssociationRoleError>, Options<PostApiBankingAssociationSupervisorUpdateAssociationRoleData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBankingAssociationSupervisorUpdateAssociationRole({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBankingAssociationBankAssociationContextQueryKey = (options?: Options) => [
    createQueryKey("getApiBankingAssociationBankAssociationContext", options)
];

export const getApiBankingAssociationBankAssociationContextOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBankingAssociationBankAssociationContext({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBankingAssociationBankAssociationContextQueryKey(options)
}); };

export const getApiBorrowersPlaidLinkQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersPlaidLink", options)
];

export const getApiBorrowersPlaidLinkOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersPlaidLink({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersPlaidLinkQueryKey(options)
}); };

export const postApiBorrowersStartQuickbooksLinkQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersStartQuickbooksLink", options)
];

export const postApiBorrowersStartQuickbooksLinkOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersStartQuickbooksLink({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersStartQuickbooksLinkQueryKey(options)
}); };

export const postApiBorrowersStartQuickbooksLinkMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersStartQuickbooksLinkResponse, AxiosError<PostApiBorrowersStartQuickbooksLinkError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersStartQuickbooksLink({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersRunQuickbooksReportQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersRunQuickbooksReport", options)
];

export const postApiBorrowersRunQuickbooksReportOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersRunQuickbooksReport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersRunQuickbooksReportQueryKey(options)
}); };

export const postApiBorrowersRunQuickbooksReportMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersRunQuickbooksReportResponse, AxiosError<PostApiBorrowersRunQuickbooksReportError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersRunQuickbooksReport({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersAccountingReportSheetQueryKey = (options?: Options<GetApiBorrowersAccountingReportSheetData>) => [
    createQueryKey("getApiBorrowersAccountingReportSheet", options)
];

export const getApiBorrowersAccountingReportSheetOptions = (options?: Options<GetApiBorrowersAccountingReportSheetData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersAccountingReportSheet({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersAccountingReportSheetQueryKey(options)
}); };

export const getApiBorrowersAccountingProfitLossReportSheetQueryKey = (options?: Options<GetApiBorrowersAccountingProfitLossReportSheetData>) => [
    createQueryKey("getApiBorrowersAccountingProfitLossReportSheet", options)
];

export const getApiBorrowersAccountingProfitLossReportSheetOptions = (options?: Options<GetApiBorrowersAccountingProfitLossReportSheetData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersAccountingProfitLossReportSheet({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersAccountingProfitLossReportSheetQueryKey(options)
}); };

export const postApiBorrowersSyncAccountingBalanceSheetMetricsQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersSyncAccountingBalanceSheetMetrics", options)
];

export const postApiBorrowersSyncAccountingBalanceSheetMetricsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersSyncAccountingBalanceSheetMetrics({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersSyncAccountingBalanceSheetMetricsQueryKey(options)
}); };

export const postApiBorrowersSyncAccountingBalanceSheetMetricsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersSyncAccountingBalanceSheetMetricsResponse, AxiosError<PostApiBorrowersSyncAccountingBalanceSheetMetricsError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersSyncAccountingBalanceSheetMetrics({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersSyncAccountingProfitLossMetricsQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersSyncAccountingProfitLossMetrics", options)
];

export const postApiBorrowersSyncAccountingProfitLossMetricsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersSyncAccountingProfitLossMetrics({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersSyncAccountingProfitLossMetricsQueryKey(options)
}); };

export const postApiBorrowersSyncAccountingProfitLossMetricsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersSyncAccountingProfitLossMetricsResponse, AxiosError<PostApiBorrowersSyncAccountingProfitLossMetricsError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersSyncAccountingProfitLossMetrics({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersAccountingReportQueryKey = (options?: Options<GetApiBorrowersAccountingReportData>) => [
    createQueryKey("getApiBorrowersAccountingReport", options)
];

export const getApiBorrowersAccountingReportOptions = (options?: Options<GetApiBorrowersAccountingReportData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersAccountingReport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersAccountingReportQueryKey(options)
}); };

export const postApiBorrowersDisconnectQuickbooksQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersDisconnectQuickbooks", options)
];

export const postApiBorrowersDisconnectQuickbooksOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersDisconnectQuickbooks({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersDisconnectQuickbooksQueryKey(options)
}); };

export const postApiBorrowersDisconnectQuickbooksMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersDisconnectQuickbooksResponse, AxiosError<PostApiBorrowersDisconnectQuickbooksError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersDisconnectQuickbooks({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersDisconnectPlaidQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersDisconnectPlaid", options)
];

export const postApiBorrowersDisconnectPlaidOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersDisconnectPlaid({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersDisconnectPlaidQueryKey(options)
}); };

export const postApiBorrowersDisconnectPlaidMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersDisconnectPlaidResponse, AxiosError<PostApiBorrowersDisconnectPlaidError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersDisconnectPlaid({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersFinishQuickbooksLinkQueryKey = (options?: Options<PostApiBorrowersFinishQuickbooksLinkData>) => [
    createQueryKey("postApiBorrowersFinishQuickbooksLink", options)
];

export const postApiBorrowersFinishQuickbooksLinkOptions = (options?: Options<PostApiBorrowersFinishQuickbooksLinkData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersFinishQuickbooksLink({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersFinishQuickbooksLinkQueryKey(options)
}); };

export const postApiBorrowersFinishQuickbooksLinkMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersFinishQuickbooksLinkResponse, AxiosError<PostApiBorrowersFinishQuickbooksLinkError>, Options<PostApiBorrowersFinishQuickbooksLinkData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersFinishQuickbooksLink({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersListTransactionsQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersListTransactions", options)
];

export const getApiBorrowersListTransactionsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersListTransactions({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersListTransactionsQueryKey(options)
}); };

export const postApiBorrowersAnalyzeBankStatementsQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersAnalyzeBankStatements", options)
];

export const postApiBorrowersAnalyzeBankStatementsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersAnalyzeBankStatements({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersAnalyzeBankStatementsQueryKey(options)
}); };

export const postApiBorrowersAnalyzeBankStatementsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersAnalyzeBankStatementsResponse, AxiosError<PostApiBorrowersAnalyzeBankStatementsError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersAnalyzeBankStatements({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersExchangePlaidTokenQueryKey = (options?: Options<PostApiBorrowersExchangePlaidTokenData>) => [
    createQueryKey("postApiBorrowersExchangePlaidToken", options)
];

export const postApiBorrowersExchangePlaidTokenOptions = (options?: Options<PostApiBorrowersExchangePlaidTokenData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersExchangePlaidToken({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersExchangePlaidTokenQueryKey(options)
}); };

export const postApiBorrowersExchangePlaidTokenMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersExchangePlaidTokenResponse, AxiosError<PostApiBorrowersExchangePlaidTokenError>, Options<PostApiBorrowersExchangePlaidTokenData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersExchangePlaidToken({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersUsersQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersUsers", options)
];

export const getApiBorrowersUsersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersUsersQueryKey(options)
}); };

export const postApiBorrowersRemoveUserQueryKey = (options?: Options<PostApiBorrowersRemoveUserData>) => [
    createQueryKey("postApiBorrowersRemoveUser", options)
];

export const postApiBorrowersRemoveUserOptions = (options?: Options<PostApiBorrowersRemoveUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersRemoveUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersRemoveUserQueryKey(options)
}); };

export const postApiBorrowersRemoveUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersRemoveUserResponse, AxiosError<PostApiBorrowersRemoveUserError>, Options<PostApiBorrowersRemoveUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersRemoveUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersChangeUserAccessQueryKey = (options?: Options<PostApiBorrowersChangeUserAccessData>) => [
    createQueryKey("postApiBorrowersChangeUserAccess", options)
];

export const postApiBorrowersChangeUserAccessOptions = (options?: Options<PostApiBorrowersChangeUserAccessData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersChangeUserAccess({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersChangeUserAccessQueryKey(options)
}); };

export const postApiBorrowersChangeUserAccessMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersChangeUserAccessResponse, AxiosError<PostApiBorrowersChangeUserAccessError>, Options<PostApiBorrowersChangeUserAccessData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersChangeUserAccess({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersGetAllQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersGetAll", options)
];

export const getApiBorrowersGetAllOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetAll({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetAllQueryKey(options)
}); };

export const getApiBorrowersGetBorrowersQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersGetBorrowers", options)
];

export const getApiBorrowersGetBorrowersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetBorrowers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetBorrowersQueryKey(options)
}); };

export const getApiBorrowersGetRsgDashboardViewmodelQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersGetRsgDashboardViewmodel", options)
];

export const getApiBorrowersGetRsgDashboardViewmodelOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetRsgDashboardViewmodel({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetRsgDashboardViewmodelQueryKey(options)
}); };

export const getApiBorrowersGetEvaluationResultsQueryKey = (options?: Options<GetApiBorrowersGetEvaluationResultsData>) => [
    createQueryKey("getApiBorrowersGetEvaluationResults", options)
];

export const getApiBorrowersGetEvaluationResultsOptions = (options?: Options<GetApiBorrowersGetEvaluationResultsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetEvaluationResults({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetEvaluationResultsQueryKey(options)
}); };

export const postApiBorrowersLandingPageApplyQueryKey = (options?: Options<PostApiBorrowersLandingPageApplyData>) => [
    createQueryKey("postApiBorrowersLandingPageApply", options)
];

export const postApiBorrowersLandingPageApplyOptions = (options?: Options<PostApiBorrowersLandingPageApplyData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersLandingPageApply({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersLandingPageApplyQueryKey(options)
}); };

export const postApiBorrowersLandingPageApplyMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersLandingPageApplyResponse, AxiosError<PostApiBorrowersLandingPageApplyError>, Options<PostApiBorrowersLandingPageApplyData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersLandingPageApply({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersUpdateIsSignatoryQueryKey = (options?: Options<PostApiBorrowersUpdateIsSignatoryData>) => [
    createQueryKey("postApiBorrowersUpdateIsSignatory", options)
];

export const postApiBorrowersUpdateIsSignatoryOptions = (options?: Options<PostApiBorrowersUpdateIsSignatoryData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersUpdateIsSignatory({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersUpdateIsSignatoryQueryKey(options)
}); };

export const postApiBorrowersUpdateIsSignatoryMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersUpdateIsSignatoryResponse, AxiosError<PostApiBorrowersUpdateIsSignatoryError>, Options<PostApiBorrowersUpdateIsSignatoryData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersUpdateIsSignatory({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersGetBorrowerUsersQueryKey = (options?: Options<GetApiBorrowersGetBorrowerUsersData>) => [
    createQueryKey("getApiBorrowersGetBorrowerUsers", options)
];

export const getApiBorrowersGetBorrowerUsersOptions = (options?: Options<GetApiBorrowersGetBorrowerUsersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetBorrowerUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetBorrowerUsersQueryKey(options)
}); };

export const postApiBorrowersSetActiveBorrowerQueryKey = (options?: Options<PostApiBorrowersSetActiveBorrowerData>) => [
    createQueryKey("postApiBorrowersSetActiveBorrower", options)
];

export const postApiBorrowersSetActiveBorrowerOptions = (options?: Options<PostApiBorrowersSetActiveBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersSetActiveBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersSetActiveBorrowerQueryKey(options)
}); };

export const postApiBorrowersSetActiveBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersSetActiveBorrowerResponse, AxiosError<PostApiBorrowersSetActiveBorrowerError>, Options<PostApiBorrowersSetActiveBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersSetActiveBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersGetGlossaryQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersGetGlossary", options)
];

export const getApiBorrowersGetGlossaryOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetGlossary({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetGlossaryQueryKey(options)
}); };

export const postApiBorrowersAcceptTermsQueryKey = (options?: Options<PostApiBorrowersAcceptTermsData>) => [
    createQueryKey("postApiBorrowersAcceptTerms", options)
];

export const postApiBorrowersAcceptTermsOptions = (options?: Options<PostApiBorrowersAcceptTermsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersAcceptTerms({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersAcceptTermsQueryKey(options)
}); };

export const postApiBorrowersAcceptTermsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersAcceptTermsResponse, AxiosError<PostApiBorrowersAcceptTermsError>, Options<PostApiBorrowersAcceptTermsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersAcceptTerms({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersEvaluateLandingQueryKey = (options?: Options<PostApiBorrowersEvaluateLandingData>) => [
    createQueryKey("postApiBorrowersEvaluateLanding", options)
];

export const postApiBorrowersEvaluateLandingOptions = (options?: Options<PostApiBorrowersEvaluateLandingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersEvaluateLanding({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersEvaluateLandingQueryKey(options)
}); };

export const postApiBorrowersEvaluateLandingMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersEvaluateLandingResponse, AxiosError<PostApiBorrowersEvaluateLandingError>, Options<PostApiBorrowersEvaluateLandingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersEvaluateLanding({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersEvaluateFundingOptionsQueryKey = (options?: Options<GetApiBorrowersEvaluateFundingOptionsData>) => [
    createQueryKey("getApiBorrowersEvaluateFundingOptions", options)
];

export const getApiBorrowersEvaluateFundingOptionsOptions = (options?: Options<GetApiBorrowersEvaluateFundingOptionsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersEvaluateFundingOptions({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersEvaluateFundingOptionsQueryKey(options)
}); };

export const postApiBorrowersEvaluateFundingOptionsQueryKey = (options?: Options<PostApiBorrowersEvaluateFundingOptionsData>) => [
    createQueryKey("postApiBorrowersEvaluateFundingOptions", options)
];

export const postApiBorrowersEvaluateFundingOptionsOptions = (options?: Options<PostApiBorrowersEvaluateFundingOptionsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersEvaluateFundingOptions({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersEvaluateFundingOptionsQueryKey(options)
}); };

export const postApiBorrowersEvaluateFundingOptionsMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersEvaluateFundingOptionsResponse, AxiosError<PostApiBorrowersEvaluateFundingOptionsError>, Options<PostApiBorrowersEvaluateFundingOptionsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersEvaluateFundingOptions({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersEvaluateBorrowerFundingOptionsQueryKey = (options?: Options<GetApiBorrowersEvaluateBorrowerFundingOptionsData>) => [
    createQueryKey("getApiBorrowersEvaluateBorrowerFundingOptions", options)
];

export const getApiBorrowersEvaluateBorrowerFundingOptionsOptions = (options?: Options<GetApiBorrowersEvaluateBorrowerFundingOptionsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersEvaluateBorrowerFundingOptions({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersEvaluateBorrowerFundingOptionsQueryKey(options)
}); };

export const getApiBorrowersEvaluateQueryKey = (options?: Options<GetApiBorrowersEvaluateData>) => [
    createQueryKey("getApiBorrowersEvaluate", options)
];

export const getApiBorrowersEvaluateOptions = (options?: Options<GetApiBorrowersEvaluateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersEvaluate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersEvaluateQueryKey(options)
}); };

export const postApiBorrowersAdminAddBorrowerUserQueryKey = (options?: Options<PostApiBorrowersAdminAddBorrowerUserData>) => [
    createQueryKey("postApiBorrowersAdminAddBorrowerUser", options)
];

export const postApiBorrowersAdminAddBorrowerUserOptions = (options?: Options<PostApiBorrowersAdminAddBorrowerUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersAdminAddBorrowerUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersAdminAddBorrowerUserQueryKey(options)
}); };

export const postApiBorrowersAdminAddBorrowerUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersAdminAddBorrowerUserResponse, AxiosError<PostApiBorrowersAdminAddBorrowerUserError>, Options<PostApiBorrowersAdminAddBorrowerUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersAdminAddBorrowerUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersCashBasedProfitLossReportQueryKey = (options?: Options<GetApiBorrowersCashBasedProfitLossReportData>) => [
    createQueryKey("getApiBorrowersCashBasedProfitLossReport", options)
];

export const getApiBorrowersCashBasedProfitLossReportOptions = (options?: Options<GetApiBorrowersCashBasedProfitLossReportData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersCashBasedProfitLossReport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersCashBasedProfitLossReportQueryKey(options)
}); };

export const getApiBorrowersActiveCashBasedProfitLossReportQueryKey = (options?: Options<GetApiBorrowersActiveCashBasedProfitLossReportData>) => [
    createQueryKey("getApiBorrowersActiveCashBasedProfitLossReport", options)
];

export const getApiBorrowersActiveCashBasedProfitLossReportOptions = (options?: Options<GetApiBorrowersActiveCashBasedProfitLossReportData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersActiveCashBasedProfitLossReport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersActiveCashBasedProfitLossReportQueryKey(options)
}); };

export const getApiBorrowersBorrowerDetailsQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersBorrowerDetails", options)
];

export const getApiBorrowersBorrowerDetailsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersBorrowerDetails({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersBorrowerDetailsQueryKey(options)
}); };

export const getApiBorrowersGetBorrowerAdditionalFilesQueryKey = (options?: Options<GetApiBorrowersGetBorrowerAdditionalFilesData>) => [
    createQueryKey("getApiBorrowersGetBorrowerAdditionalFiles", options)
];

export const getApiBorrowersGetBorrowerAdditionalFilesOptions = (options?: Options<GetApiBorrowersGetBorrowerAdditionalFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetBorrowerAdditionalFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetBorrowerAdditionalFilesQueryKey(options)
}); };

export const getApiBorrowersGetBorrowerProfileFilesQueryKey = (options?: Options) => [
    createQueryKey("getApiBorrowersGetBorrowerProfileFiles", options)
];

export const getApiBorrowersGetBorrowerProfileFilesOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersGetBorrowerProfileFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersGetBorrowerProfileFilesQueryKey(options)
}); };

export const postApiBorrowersMoveProfileFileQueryKey = (options?: Options<PostApiBorrowersMoveProfileFileData>) => [
    createQueryKey("postApiBorrowersMoveProfileFile", options)
];

export const postApiBorrowersMoveProfileFileOptions = (options?: Options<PostApiBorrowersMoveProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersMoveProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersMoveProfileFileQueryKey(options)
}); };

export const postApiBorrowersMoveProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersMoveProfileFileResponse, AxiosError<PostApiBorrowersMoveProfileFileError>, Options<PostApiBorrowersMoveProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersMoveProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersUploadBorrowerProfileFileQueryKey = (options?: Options<PostApiBorrowersUploadBorrowerProfileFileData>) => [
    createQueryKey("postApiBorrowersUploadBorrowerProfileFile", options)
];

export const postApiBorrowersUploadBorrowerProfileFileOptions = (options?: Options<PostApiBorrowersUploadBorrowerProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersUploadBorrowerProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersUploadBorrowerProfileFileQueryKey(options)
}); };

export const postApiBorrowersUploadBorrowerProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersUploadBorrowerProfileFileResponse, AxiosError<PostApiBorrowersUploadBorrowerProfileFileError>, Options<PostApiBorrowersUploadBorrowerProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersUploadBorrowerProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersRenameProfileFileQueryKey = (options?: Options<PostApiBorrowersRenameProfileFileData>) => [
    createQueryKey("postApiBorrowersRenameProfileFile", options)
];

export const postApiBorrowersRenameProfileFileOptions = (options?: Options<PostApiBorrowersRenameProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersRenameProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersRenameProfileFileQueryKey(options)
}); };

export const postApiBorrowersRenameProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersRenameProfileFileResponse, AxiosError<PostApiBorrowersRenameProfileFileError>, Options<PostApiBorrowersRenameProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersRenameProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersApproveAdditionalFileQueryKey = (options?: Options<PostApiBorrowersApproveAdditionalFileData>) => [
    createQueryKey("postApiBorrowersApproveAdditionalFile", options)
];

export const postApiBorrowersApproveAdditionalFileOptions = (options?: Options<PostApiBorrowersApproveAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersApproveAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersApproveAdditionalFileQueryKey(options)
}); };

export const postApiBorrowersApproveAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersApproveAdditionalFileResponse, AxiosError<PostApiBorrowersApproveAdditionalFileError>, Options<PostApiBorrowersApproveAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersApproveAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersRenameAdditionalFileQueryKey = (options?: Options<PostApiBorrowersRenameAdditionalFileData>) => [
    createQueryKey("postApiBorrowersRenameAdditionalFile", options)
];

export const postApiBorrowersRenameAdditionalFileOptions = (options?: Options<PostApiBorrowersRenameAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersRenameAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersRenameAdditionalFileQueryKey(options)
}); };

export const postApiBorrowersRenameAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersRenameAdditionalFileResponse, AxiosError<PostApiBorrowersRenameAdditionalFileError>, Options<PostApiBorrowersRenameAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersRenameAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersUploadBorrowerAdditionalFileQueryKey = (options?: Options<PostApiBorrowersUploadBorrowerAdditionalFileData>) => [
    createQueryKey("postApiBorrowersUploadBorrowerAdditionalFile", options)
];

export const postApiBorrowersUploadBorrowerAdditionalFileOptions = (options?: Options<PostApiBorrowersUploadBorrowerAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersUploadBorrowerAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersUploadBorrowerAdditionalFileQueryKey(options)
}); };

export const postApiBorrowersUploadBorrowerAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersUploadBorrowerAdditionalFileResponse, AxiosError<PostApiBorrowersUploadBorrowerAdditionalFileError>, Options<PostApiBorrowersUploadBorrowerAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersUploadBorrowerAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersDeleteBorrowerQueryKey = (options?: Options<PostApiBorrowersDeleteBorrowerData>) => [
    createQueryKey("postApiBorrowersDeleteBorrower", options)
];

export const postApiBorrowersDeleteBorrowerOptions = (options?: Options<PostApiBorrowersDeleteBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersDeleteBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersDeleteBorrowerQueryKey(options)
}); };

export const postApiBorrowersDeleteBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersDeleteBorrowerResponse, AxiosError<PostApiBorrowersDeleteBorrowerError>, Options<PostApiBorrowersDeleteBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersDeleteBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersDeleteBorrowerAdditionalFileQueryKey = (options?: Options<PostApiBorrowersDeleteBorrowerAdditionalFileData>) => [
    createQueryKey("postApiBorrowersDeleteBorrowerAdditionalFile", options)
];

export const postApiBorrowersDeleteBorrowerAdditionalFileOptions = (options?: Options<PostApiBorrowersDeleteBorrowerAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersDeleteBorrowerAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersDeleteBorrowerAdditionalFileQueryKey(options)
}); };

export const postApiBorrowersDeleteBorrowerAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersDeleteBorrowerAdditionalFileResponse, AxiosError<PostApiBorrowersDeleteBorrowerAdditionalFileError>, Options<PostApiBorrowersDeleteBorrowerAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersDeleteBorrowerAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersDeleteBorrowerProfileFileQueryKey = (options?: Options<PostApiBorrowersDeleteBorrowerProfileFileData>) => [
    createQueryKey("postApiBorrowersDeleteBorrowerProfileFile", options)
];

export const postApiBorrowersDeleteBorrowerProfileFileOptions = (options?: Options<PostApiBorrowersDeleteBorrowerProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersDeleteBorrowerProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersDeleteBorrowerProfileFileQueryKey(options)
}); };

export const postApiBorrowersDeleteBorrowerProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersDeleteBorrowerProfileFileResponse, AxiosError<PostApiBorrowersDeleteBorrowerProfileFileError>, Options<PostApiBorrowersDeleteBorrowerProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersDeleteBorrowerProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiBorrowersDownloadAdditionalFileQueryKey = (options?: Options<GetApiBorrowersDownloadAdditionalFileData>) => [
    createQueryKey("getApiBorrowersDownloadAdditionalFile", options)
];

export const getApiBorrowersDownloadAdditionalFileOptions = (options?: Options<GetApiBorrowersDownloadAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersDownloadAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersDownloadAdditionalFileQueryKey(options)
}); };

export const getApiBorrowersDownloadProfileFileQueryKey = (options?: Options<GetApiBorrowersDownloadProfileFileData>) => [
    createQueryKey("getApiBorrowersDownloadProfileFile", options)
];

export const getApiBorrowersDownloadProfileFileOptions = (options?: Options<GetApiBorrowersDownloadProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiBorrowersDownloadProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiBorrowersDownloadProfileFileQueryKey(options)
}); };

export const postApiBorrowersCreateAdditionalBorrowerQueryKey = (options?: Options) => [
    createQueryKey("postApiBorrowersCreateAdditionalBorrower", options)
];

export const postApiBorrowersCreateAdditionalBorrowerOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersCreateAdditionalBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersCreateAdditionalBorrowerQueryKey(options)
}); };

export const postApiBorrowersCreateAdditionalBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersCreateAdditionalBorrowerResponse, AxiosError<PostApiBorrowersCreateAdditionalBorrowerError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersCreateAdditionalBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersOnboardAdditionalBorrowerQueryKey = (options?: Options<PostApiBorrowersOnboardAdditionalBorrowerData>) => [
    createQueryKey("postApiBorrowersOnboardAdditionalBorrower", options)
];

export const postApiBorrowersOnboardAdditionalBorrowerOptions = (options?: Options<PostApiBorrowersOnboardAdditionalBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersOnboardAdditionalBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersOnboardAdditionalBorrowerQueryKey(options)
}); };

export const postApiBorrowersOnboardAdditionalBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersOnboardAdditionalBorrowerResponse, AxiosError<PostApiBorrowersOnboardAdditionalBorrowerError>, Options<PostApiBorrowersOnboardAdditionalBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersOnboardAdditionalBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersOnboardBorrowerQueryKey = (options?: Options<PostApiBorrowersOnboardBorrowerData>) => [
    createQueryKey("postApiBorrowersOnboardBorrower", options)
];

export const postApiBorrowersOnboardBorrowerOptions = (options?: Options<PostApiBorrowersOnboardBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersOnboardBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersOnboardBorrowerQueryKey(options)
}); };

export const postApiBorrowersOnboardBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersOnboardBorrowerResponse, AxiosError<PostApiBorrowersOnboardBorrowerError>, Options<PostApiBorrowersOnboardBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersOnboardBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersUpdateCompanyNameQueryKey = (options?: Options<PostApiBorrowersUpdateCompanyNameData>) => [
    createQueryKey("postApiBorrowersUpdateCompanyName", options)
];

export const postApiBorrowersUpdateCompanyNameOptions = (options?: Options<PostApiBorrowersUpdateCompanyNameData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersUpdateCompanyName({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersUpdateCompanyNameQueryKey(options)
}); };

export const postApiBorrowersUpdateCompanyNameMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersUpdateCompanyNameResponse, AxiosError<PostApiBorrowersUpdateCompanyNameError>, Options<PostApiBorrowersUpdateCompanyNameData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersUpdateCompanyName({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiBorrowersUpdateBorrowerProfileQueryKey = (options?: Options<PostApiBorrowersUpdateBorrowerProfileData>) => [
    createQueryKey("postApiBorrowersUpdateBorrowerProfile", options)
];

export const postApiBorrowersUpdateBorrowerProfileOptions = (options?: Options<PostApiBorrowersUpdateBorrowerProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiBorrowersUpdateBorrowerProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiBorrowersUpdateBorrowerProfileQueryKey(options)
}); };

export const postApiBorrowersUpdateBorrowerProfileMutation = () => { const mutationOptions: UseMutationOptions<PostApiBorrowersUpdateBorrowerProfileResponse, AxiosError<PostApiBorrowersUpdateBorrowerProfileError>, Options<PostApiBorrowersUpdateBorrowerProfileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiBorrowersUpdateBorrowerProfile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiCmsSyncBorrowerQueryKey = (options?: Options<PostApiCmsSyncBorrowerData>) => [
    createQueryKey("postApiCmsSyncBorrower", options)
];

export const postApiCmsSyncBorrowerOptions = (options?: Options<PostApiCmsSyncBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiCmsSyncBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiCmsSyncBorrowerQueryKey(options)
}); };

export const postApiCmsSyncBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiCmsSyncBorrowerResponse, AxiosError<PostApiCmsSyncBorrowerError>, Options<PostApiCmsSyncBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiCmsSyncBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiCmsSyncLenderQueryKey = (options?: Options<PostApiCmsSyncLenderData>) => [
    createQueryKey("postApiCmsSyncLender", options)
];

export const postApiCmsSyncLenderOptions = (options?: Options<PostApiCmsSyncLenderData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiCmsSyncLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiCmsSyncLenderQueryKey(options)
}); };

export const postApiCmsSyncLenderMutation = () => { const mutationOptions: UseMutationOptions<PostApiCmsSyncLenderResponse, AxiosError<PostApiCmsSyncLenderError>, Options<PostApiCmsSyncLenderData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiCmsSyncLender({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiCmsSyncAssociationQueryKey = (options?: Options<PostApiCmsSyncAssociationData>) => [
    createQueryKey("postApiCmsSyncAssociation", options)
];

export const postApiCmsSyncAssociationOptions = (options?: Options<PostApiCmsSyncAssociationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiCmsSyncAssociation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiCmsSyncAssociationQueryKey(options)
}); };

export const postApiCmsSyncAssociationMutation = () => { const mutationOptions: UseMutationOptions<PostApiCmsSyncAssociationResponse, AxiosError<PostApiCmsSyncAssociationError>, Options<PostApiCmsSyncAssociationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiCmsSyncAssociation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiCmsSyncLoanQueryKey = (options?: Options<PostApiCmsSyncLoanData>) => [
    createQueryKey("postApiCmsSyncLoan", options)
];

export const postApiCmsSyncLoanOptions = (options?: Options<PostApiCmsSyncLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiCmsSyncLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiCmsSyncLoanQueryKey(options)
}); };

export const postApiCmsSyncLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiCmsSyncLoanResponse, AxiosError<PostApiCmsSyncLoanError>, Options<PostApiCmsSyncLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiCmsSyncLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiCmsSyncUserQueryKey = (options?: Options<PostApiCmsSyncUserData>) => [
    createQueryKey("postApiCmsSyncUser", options)
];

export const postApiCmsSyncUserOptions = (options?: Options<PostApiCmsSyncUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiCmsSyncUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiCmsSyncUserQueryKey(options)
}); };

export const postApiCmsSyncUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiCmsSyncUserResponse, AxiosError<PostApiCmsSyncUserError>, Options<PostApiCmsSyncUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiCmsSyncUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiEvaluationLoanSimulatorHistoryQueryKey = (options?: Options) => [
    createQueryKey("getApiEvaluationLoanSimulatorHistory", options)
];

export const getApiEvaluationLoanSimulatorHistoryOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiEvaluationLoanSimulatorHistory({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiEvaluationLoanSimulatorHistoryQueryKey(options)
}); };

export const getApiLendersGetLenderTypeHierarchyQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetLenderTypeHierarchy", options)
];

export const getApiLendersGetLenderTypeHierarchyOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetLenderTypeHierarchy({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetLenderTypeHierarchyQueryKey(options)
}); };

export const getApiLendersLenderGroupsQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersLenderGroups", options)
];

export const getApiLendersLenderGroupsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersLenderGroups({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersLenderGroupsQueryKey(options)
}); };

export const getApiLendersGroupLendersQueryKey = (options?: Options<GetApiLendersGroupLendersData>) => [
    createQueryKey("getApiLendersGroupLenders", options)
];

export const getApiLendersGroupLendersOptions = (options?: Options<GetApiLendersGroupLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGroupLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGroupLendersQueryKey(options)
}); };

export const postApiLendersCreateLenderGroupQueryKey = (options?: Options<PostApiLendersCreateLenderGroupData>) => [
    createQueryKey("postApiLendersCreateLenderGroup", options)
];

export const postApiLendersCreateLenderGroupOptions = (options?: Options<PostApiLendersCreateLenderGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersCreateLenderGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersCreateLenderGroupQueryKey(options)
}); };

export const postApiLendersCreateLenderGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersCreateLenderGroupResponse, AxiosError<PostApiLendersCreateLenderGroupError>, Options<PostApiLendersCreateLenderGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersCreateLenderGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersLoansForLenderGroupQueryKey = (options?: Options<GetApiLendersLoansForLenderGroupData>) => [
    createQueryKey("getApiLendersLoansForLenderGroup", options)
];

export const getApiLendersLoansForLenderGroupOptions = (options?: Options<GetApiLendersLoansForLenderGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersLoansForLenderGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersLoansForLenderGroupQueryKey(options)
}); };

export const postApiLendersInviteChildLenderQueryKey = (options?: Options<PostApiLendersInviteChildLenderData>) => [
    createQueryKey("postApiLendersInviteChildLender", options)
];

export const postApiLendersInviteChildLenderOptions = (options?: Options<PostApiLendersInviteChildLenderData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersInviteChildLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersInviteChildLenderQueryKey(options)
}); };

export const postApiLendersInviteChildLenderMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersInviteChildLenderResponse, AxiosError<PostApiLendersInviteChildLenderError>, Options<PostApiLendersInviteChildLenderData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersInviteChildLender({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateOnboardingStateQueryKey = (options?: Options<PostApiLendersUpdateOnboardingStateData>) => [
    createQueryKey("postApiLendersUpdateOnboardingState", options)
];

export const postApiLendersUpdateOnboardingStateOptions = (options?: Options<PostApiLendersUpdateOnboardingStateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateOnboardingState({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateOnboardingStateQueryKey(options)
}); };

export const postApiLendersUpdateOnboardingStateMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateOnboardingStateResponse, AxiosError<PostApiLendersUpdateOnboardingStateError>, Options<PostApiLendersUpdateOnboardingStateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateOnboardingState({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersRemoveLenderFromGroupQueryKey = (options?: Options<PostApiLendersRemoveLenderFromGroupData>) => [
    createQueryKey("postApiLendersRemoveLenderFromGroup", options)
];

export const postApiLendersRemoveLenderFromGroupOptions = (options?: Options<PostApiLendersRemoveLenderFromGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersRemoveLenderFromGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersRemoveLenderFromGroupQueryKey(options)
}); };

export const postApiLendersRemoveLenderFromGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersRemoveLenderFromGroupResponse, AxiosError<PostApiLendersRemoveLenderFromGroupError>, Options<PostApiLendersRemoveLenderFromGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersRemoveLenderFromGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersAssignLenderToGroupQueryKey = (options?: Options<PostApiLendersAssignLenderToGroupData>) => [
    createQueryKey("postApiLendersAssignLenderToGroup", options)
];

export const postApiLendersAssignLenderToGroupOptions = (options?: Options<PostApiLendersAssignLenderToGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersAssignLenderToGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersAssignLenderToGroupQueryKey(options)
}); };

export const postApiLendersAssignLenderToGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersAssignLenderToGroupResponse, AxiosError<PostApiLendersAssignLenderToGroupError>, Options<PostApiLendersAssignLenderToGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersAssignLenderToGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersProfileFilesQueryKey = (options?: Options<GetApiLendersProfileFilesData>) => [
    createQueryKey("getApiLendersProfileFiles", options)
];

export const getApiLendersProfileFilesOptions = (options?: Options<GetApiLendersProfileFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersProfileFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersProfileFilesQueryKey(options)
}); };

export const postApiLendersRemoveLenderUserQueryKey = (options?: Options<PostApiLendersRemoveLenderUserData>) => [
    createQueryKey("postApiLendersRemoveLenderUser", options)
];

export const postApiLendersRemoveLenderUserOptions = (options?: Options<PostApiLendersRemoveLenderUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersRemoveLenderUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersRemoveLenderUserQueryKey(options)
}); };

export const postApiLendersRemoveLenderUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersRemoveLenderUserResponse, AxiosError<PostApiLendersRemoveLenderUserError>, Options<PostApiLendersRemoveLenderUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersRemoveLenderUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateLenderGroupQueryKey = (options?: Options<PostApiLendersUpdateLenderGroupData>) => [
    createQueryKey("postApiLendersUpdateLenderGroup", options)
];

export const postApiLendersUpdateLenderGroupOptions = (options?: Options<PostApiLendersUpdateLenderGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLenderGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLenderGroupQueryKey(options)
}); };

export const postApiLendersUpdateLenderGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLenderGroupResponse, AxiosError<PostApiLendersUpdateLenderGroupError>, Options<PostApiLendersUpdateLenderGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLenderGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateLenderUserQueryKey = (options?: Options<PostApiLendersUpdateLenderUserData>) => [
    createQueryKey("postApiLendersUpdateLenderUser", options)
];

export const postApiLendersUpdateLenderUserOptions = (options?: Options<PostApiLendersUpdateLenderUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLenderUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLenderUserQueryKey(options)
}); };

export const postApiLendersUpdateLenderUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLenderUserResponse, AxiosError<PostApiLendersUpdateLenderUserError>, Options<PostApiLendersUpdateLenderUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLenderUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUploadLenderProfileFileQueryKey = (options?: Options<PostApiLendersUploadLenderProfileFileData>) => [
    createQueryKey("postApiLendersUploadLenderProfileFile", options)
];

export const postApiLendersUploadLenderProfileFileOptions = (options?: Options<PostApiLendersUploadLenderProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUploadLenderProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUploadLenderProfileFileQueryKey(options)
}); };

export const postApiLendersUploadLenderProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUploadLenderProfileFileResponse, AxiosError<PostApiLendersUploadLenderProfileFileError>, Options<PostApiLendersUploadLenderProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUploadLenderProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersRenameLenderProfileFileQueryKey = (options?: Options<PostApiLendersRenameLenderProfileFileData>) => [
    createQueryKey("postApiLendersRenameLenderProfileFile", options)
];

export const postApiLendersRenameLenderProfileFileOptions = (options?: Options<PostApiLendersRenameLenderProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersRenameLenderProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersRenameLenderProfileFileQueryKey(options)
}); };

export const postApiLendersRenameLenderProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersRenameLenderProfileFileResponse, AxiosError<PostApiLendersRenameLenderProfileFileError>, Options<PostApiLendersRenameLenderProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersRenameLenderProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersDeleteLenderProfileFileQueryKey = (options?: Options<PostApiLendersDeleteLenderProfileFileData>) => [
    createQueryKey("postApiLendersDeleteLenderProfileFile", options)
];

export const postApiLendersDeleteLenderProfileFileOptions = (options?: Options<PostApiLendersDeleteLenderProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersDeleteLenderProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersDeleteLenderProfileFileQueryKey(options)
}); };

export const postApiLendersDeleteLenderProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersDeleteLenderProfileFileResponse, AxiosError<PostApiLendersDeleteLenderProfileFileError>, Options<PostApiLendersDeleteLenderProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersDeleteLenderProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersDownloadLenderTermsFileQueryKey = (options?: Options<PostApiLendersDownloadLenderTermsFileData>) => [
    createQueryKey("postApiLendersDownloadLenderTermsFile", options)
];

export const postApiLendersDownloadLenderTermsFileOptions = (options?: Options<PostApiLendersDownloadLenderTermsFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersDownloadLenderTermsFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersDownloadLenderTermsFileQueryKey(options)
}); };

export const postApiLendersDownloadLenderTermsFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersDownloadLenderTermsFileResponse, AxiosError<PostApiLendersDownloadLenderTermsFileError>, Options<PostApiLendersDownloadLenderTermsFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersDownloadLenderTermsFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersDownloadLenderProfileFileQueryKey = (options?: Options<PostApiLendersDownloadLenderProfileFileData>) => [
    createQueryKey("postApiLendersDownloadLenderProfileFile", options)
];

export const postApiLendersDownloadLenderProfileFileOptions = (options?: Options<PostApiLendersDownloadLenderProfileFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersDownloadLenderProfileFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersDownloadLenderProfileFileQueryKey(options)
}); };

export const postApiLendersDownloadLenderProfileFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersDownloadLenderProfileFileResponse, AxiosError<PostApiLendersDownloadLenderProfileFileError>, Options<PostApiLendersDownloadLenderProfileFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersDownloadLenderProfileFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersSpecialistRemoveLenderUserQueryKey = (options?: Options<PostApiLendersSpecialistRemoveLenderUserData>) => [
    createQueryKey("postApiLendersSpecialistRemoveLenderUser", options)
];

export const postApiLendersSpecialistRemoveLenderUserOptions = (options?: Options<PostApiLendersSpecialistRemoveLenderUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersSpecialistRemoveLenderUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersSpecialistRemoveLenderUserQueryKey(options)
}); };

export const postApiLendersSpecialistRemoveLenderUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersSpecialistRemoveLenderUserResponse, AxiosError<PostApiLendersSpecialistRemoveLenderUserError>, Options<PostApiLendersSpecialistRemoveLenderUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersSpecialistRemoveLenderUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersSpecialistAddLenderUserQueryKey = (options?: Options<PostApiLendersSpecialistAddLenderUserData>) => [
    createQueryKey("postApiLendersSpecialistAddLenderUser", options)
];

export const postApiLendersSpecialistAddLenderUserOptions = (options?: Options<PostApiLendersSpecialistAddLenderUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersSpecialistAddLenderUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersSpecialistAddLenderUserQueryKey(options)
}); };

export const postApiLendersSpecialistAddLenderUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersSpecialistAddLenderUserResponse, AxiosError<PostApiLendersSpecialistAddLenderUserError>, Options<PostApiLendersSpecialistAddLenderUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersSpecialistAddLenderUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersGetLenderUsersQueryKey = (options?: Options<GetApiLendersGetLenderUsersData>) => [
    createQueryKey("getApiLendersGetLenderUsers", options)
];

export const getApiLendersGetLenderUsersOptions = (options?: Options<GetApiLendersGetLenderUsersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetLenderUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetLenderUsersQueryKey(options)
}); };

export const postApiLendersSetMatchingEnabledQueryKey = (options?: Options<PostApiLendersSetMatchingEnabledData>) => [
    createQueryKey("postApiLendersSetMatchingEnabled", options)
];

export const postApiLendersSetMatchingEnabledOptions = (options?: Options<PostApiLendersSetMatchingEnabledData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersSetMatchingEnabled({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersSetMatchingEnabledQueryKey(options)
}); };

export const postApiLendersSetMatchingEnabledMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersSetMatchingEnabledResponse, AxiosError<PostApiLendersSetMatchingEnabledError>, Options<PostApiLendersSetMatchingEnabledData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersSetMatchingEnabled({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersSpecialistReadLenderProfileQueryKey = (options?: Options<GetApiLendersSpecialistReadLenderProfileData>) => [
    createQueryKey("getApiLendersSpecialistReadLenderProfile", options)
];

export const getApiLendersSpecialistReadLenderProfileOptions = (options?: Options<GetApiLendersSpecialistReadLenderProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersSpecialistReadLenderProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersSpecialistReadLenderProfileQueryKey(options)
}); };

export const getApiLendersGetCurrentLenderUsersQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetCurrentLenderUsers", options)
];

export const getApiLendersGetCurrentLenderUsersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetCurrentLenderUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetCurrentLenderUsersQueryKey(options)
}); };

export const getApiLendersSpecialistGetLenderProfileQueryKey = (options?: Options<GetApiLendersSpecialistGetLenderProfileData>) => [
    createQueryKey("getApiLendersSpecialistGetLenderProfile", options)
];

export const getApiLendersSpecialistGetLenderProfileOptions = (options?: Options<GetApiLendersSpecialistGetLenderProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersSpecialistGetLenderProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersSpecialistGetLenderProfileQueryKey(options)
}); };

export const getApiLendersGetLenderProfileQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetLenderProfile", options)
];

export const getApiLendersGetLenderProfileOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetLenderProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetLenderProfileQueryKey(options)
}); };

export const getApiLendersGetFullLenderExportQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetFullLenderExport", options)
];

export const getApiLendersGetFullLenderExportOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetFullLenderExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetFullLenderExportQueryKey(options)
}); };

export const getApiLendersGetLoanHistoryExportQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetLoanHistoryExport", options)
];

export const getApiLendersGetLoanHistoryExportOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetLoanHistoryExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetLoanHistoryExportQueryKey(options)
}); };

export const getApiLendersGetWidgetHistoryExportQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetWidgetHistoryExport", options)
];

export const getApiLendersGetWidgetHistoryExportOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetWidgetHistoryExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetWidgetHistoryExportQueryKey(options)
}); };

export const postApiLendersDeleteLenderQueryKey = (options?: Options<PostApiLendersDeleteLenderData>) => [
    createQueryKey("postApiLendersDeleteLender", options)
];

export const postApiLendersDeleteLenderOptions = (options?: Options<PostApiLendersDeleteLenderData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersDeleteLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersDeleteLenderQueryKey(options)
}); };

export const postApiLendersDeleteLenderMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersDeleteLenderResponse, AxiosError<PostApiLendersDeleteLenderError>, Options<PostApiLendersDeleteLenderData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersDeleteLender({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateConnectedBrandQueryKey = (options?: Options<PostApiLendersUpdateConnectedBrandData>) => [
    createQueryKey("postApiLendersUpdateConnectedBrand", options)
];

export const postApiLendersUpdateConnectedBrandOptions = (options?: Options<PostApiLendersUpdateConnectedBrandData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateConnectedBrand({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateConnectedBrandQueryKey(options)
}); };

export const postApiLendersUpdateConnectedBrandMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateConnectedBrandResponse, AxiosError<PostApiLendersUpdateConnectedBrandError>, Options<PostApiLendersUpdateConnectedBrandData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateConnectedBrand({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersAllQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersAll", options)
];

export const getApiLendersAllOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersAll({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersAllQueryKey(options)
}); };

export const getApiLendersGetCovenantsQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetCovenants", options)
];

export const getApiLendersGetCovenantsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetCovenants({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetCovenantsQueryKey(options)
}); };

export const getApiLendersGetCollateralsQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersGetCollaterals", options)
];

export const getApiLendersGetCollateralsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetCollaterals({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetCollateralsQueryKey(options)
}); };

export const postApiLendersCreateNewLenderQueryKey = (options?: Options<PostApiLendersCreateNewLenderData>) => [
    createQueryKey("postApiLendersCreateNewLender", options)
];

export const postApiLendersCreateNewLenderOptions = (options?: Options<PostApiLendersCreateNewLenderData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersCreateNewLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersCreateNewLenderQueryKey(options)
}); };

export const postApiLendersCreateNewLenderMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersCreateNewLenderResponse, AxiosError<PostApiLendersCreateNewLenderError>, Options<PostApiLendersCreateNewLenderData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersCreateNewLender({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersCreateCollateralQueryKey = (options?: Options<PostApiLendersCreateCollateralData>) => [
    createQueryKey("postApiLendersCreateCollateral", options)
];

export const postApiLendersCreateCollateralOptions = (options?: Options<PostApiLendersCreateCollateralData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersCreateCollateral({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersCreateCollateralQueryKey(options)
}); };

export const postApiLendersCreateCollateralMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersCreateCollateralResponse, AxiosError<PostApiLendersCreateCollateralError>, Options<PostApiLendersCreateCollateralData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersCreateCollateral({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersSetActiveLenderQueryKey = (options?: Options<PostApiLendersSetActiveLenderData>) => [
    createQueryKey("postApiLendersSetActiveLender", options)
];

export const postApiLendersSetActiveLenderOptions = (options?: Options<PostApiLendersSetActiveLenderData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersSetActiveLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersSetActiveLenderQueryKey(options)
}); };

export const postApiLendersSetActiveLenderMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersSetActiveLenderResponse, AxiosError<PostApiLendersSetActiveLenderError>, Options<PostApiLendersSetActiveLenderData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersSetActiveLender({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersListReferralsQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersListReferrals", options)
];

export const getApiLendersListReferralsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersListReferrals({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersListReferralsQueryKey(options)
}); };

export const postApiLendersReferBorrowerQueryKey = (options?: Options<PostApiLendersReferBorrowerData>) => [
    createQueryKey("postApiLendersReferBorrower", options)
];

export const postApiLendersReferBorrowerOptions = (options?: Options<PostApiLendersReferBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersReferBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersReferBorrowerQueryKey(options)
}); };

export const postApiLendersReferBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersReferBorrowerResponse, AxiosError<PostApiLendersReferBorrowerError>, Options<PostApiLendersReferBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersReferBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersCreateCovenantQueryKey = (options?: Options<PostApiLendersCreateCovenantData>) => [
    createQueryKey("postApiLendersCreateCovenant", options)
];

export const postApiLendersCreateCovenantOptions = (options?: Options<PostApiLendersCreateCovenantData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersCreateCovenant({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersCreateCovenantQueryKey(options)
}); };

export const postApiLendersCreateCovenantMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersCreateCovenantResponse, AxiosError<PostApiLendersCreateCovenantError>, Options<PostApiLendersCreateCovenantData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersCreateCovenant({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersGetLenderCriteriaQueryKey = (options?: Options<GetApiLendersGetLenderCriteriaData>) => [
    createQueryKey("getApiLendersGetLenderCriteria", options)
];

export const getApiLendersGetLenderCriteriaOptions = (options?: Options<GetApiLendersGetLenderCriteriaData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetLenderCriteria({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetLenderCriteriaQueryKey(options)
}); };

export const getApiLendersLenderAdminQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersLenderAdmin", options)
];

export const getApiLendersLenderAdminOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersLenderAdmin({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersLenderAdminQueryKey(options)
}); };

export const getApiLendersListDepartmentsQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersListDepartments", options)
];

export const getApiLendersListDepartmentsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersListDepartments({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersListDepartmentsQueryKey(options)
}); };

export const postApiLendersUpdateLenderAdminQueryKey = (options?: Options<PostApiLendersUpdateLenderAdminData>) => [
    createQueryKey("postApiLendersUpdateLenderAdmin", options)
];

export const postApiLendersUpdateLenderAdminOptions = (options?: Options<PostApiLendersUpdateLenderAdminData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLenderAdmin({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLenderAdminQueryKey(options)
}); };

export const postApiLendersUpdateLenderAdminMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLenderAdminResponse, AxiosError<PostApiLendersUpdateLenderAdminError>, Options<PostApiLendersUpdateLenderAdminData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLenderAdmin({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersAssignUserToDepartmentQueryKey = (options?: Options<PostApiLendersAssignUserToDepartmentData>) => [
    createQueryKey("postApiLendersAssignUserToDepartment", options)
];

export const postApiLendersAssignUserToDepartmentOptions = (options?: Options<PostApiLendersAssignUserToDepartmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersAssignUserToDepartment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersAssignUserToDepartmentQueryKey(options)
}); };

export const postApiLendersAssignUserToDepartmentMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersAssignUserToDepartmentResponse, AxiosError<PostApiLendersAssignUserToDepartmentError>, Options<PostApiLendersAssignUserToDepartmentData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersAssignUserToDepartment({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateLoanAccessUsersQueryKey = (options?: Options<PostApiLendersUpdateLoanAccessUsersData>) => [
    createQueryKey("postApiLendersUpdateLoanAccessUsers", options)
];

export const postApiLendersUpdateLoanAccessUsersOptions = (options?: Options<PostApiLendersUpdateLoanAccessUsersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLoanAccessUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLoanAccessUsersQueryKey(options)
}); };

export const postApiLendersUpdateLoanAccessUsersMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLoanAccessUsersResponse, AxiosError<PostApiLendersUpdateLoanAccessUsersError>, Options<PostApiLendersUpdateLoanAccessUsersData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLoanAccessUsers({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersDeleteDepartmentQueryKey = (options?: Options<PostApiLendersDeleteDepartmentData>) => [
    createQueryKey("postApiLendersDeleteDepartment", options)
];

export const postApiLendersDeleteDepartmentOptions = (options?: Options<PostApiLendersDeleteDepartmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersDeleteDepartment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersDeleteDepartmentQueryKey(options)
}); };

export const postApiLendersDeleteDepartmentMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersDeleteDepartmentResponse, AxiosError<PostApiLendersDeleteDepartmentError>, Options<PostApiLendersDeleteDepartmentData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersDeleteDepartment({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersCreateDepartmentQueryKey = (options?: Options<PostApiLendersCreateDepartmentData>) => [
    createQueryKey("postApiLendersCreateDepartment", options)
];

export const postApiLendersCreateDepartmentOptions = (options?: Options<PostApiLendersCreateDepartmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersCreateDepartment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersCreateDepartmentQueryKey(options)
}); };

export const postApiLendersCreateDepartmentMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersCreateDepartmentResponse, AxiosError<PostApiLendersCreateDepartmentError>, Options<PostApiLendersCreateDepartmentData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersCreateDepartment({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLendersCriteriaCompletionQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersCriteriaCompletion", options)
];

export const getApiLendersCriteriaCompletionOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersCriteriaCompletion({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersCriteriaCompletionQueryKey(options)
}); };

export const getApiLendersProfileCompletionQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersProfileCompletion", options)
];

export const getApiLendersProfileCompletionOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersProfileCompletion({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersProfileCompletionQueryKey(options)
}); };

export const getApiLendersLoanAccessUsersQueryKey = (options?: Options<GetApiLendersLoanAccessUsersData>) => [
    createQueryKey("getApiLendersLoanAccessUsers", options)
];

export const getApiLendersLoanAccessUsersOptions = (options?: Options<GetApiLendersLoanAccessUsersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersLoanAccessUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersLoanAccessUsersQueryKey(options)
}); };

export const getApiLendersCurrentRatesQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersCurrentRates", options)
];

export const getApiLendersCurrentRatesOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersCurrentRates({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersCurrentRatesQueryKey(options)
}); };

export const getApiLendersLenderProfileNotesQueryKey = (options?: Options<GetApiLendersLenderProfileNotesData>) => [
    createQueryKey("getApiLendersLenderProfileNotes", options)
];

export const getApiLendersLenderProfileNotesOptions = (options?: Options<GetApiLendersLenderProfileNotesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersLenderProfileNotes({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersLenderProfileNotesQueryKey(options)
}); };

export const getApiLendersDepartmentLoansQueryKey = (options?: Options<GetApiLendersDepartmentLoansData>) => [
    createQueryKey("getApiLendersDepartmentLoans", options)
];

export const getApiLendersDepartmentLoansOptions = (options?: Options<GetApiLendersDepartmentLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersDepartmentLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersDepartmentLoansQueryKey(options)
}); };

export const getApiLendersLenderCriteriaReportQueryKey = (options?: Options) => [
    createQueryKey("getApiLendersLenderCriteriaReport", options)
];

export const getApiLendersLenderCriteriaReportOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersLenderCriteriaReport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersLenderCriteriaReportQueryKey(options)
}); };

export const getApiLendersGetLenderLoansQueryKey = (options?: Options<GetApiLendersGetLenderLoansData>) => [
    createQueryKey("getApiLendersGetLenderLoans", options)
];

export const getApiLendersGetLenderLoansOptions = (options?: Options<GetApiLendersGetLenderLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLendersGetLenderLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLendersGetLenderLoansQueryKey(options)
}); };

export const postApiLendersAddLenderProfileNoteQueryKey = (options?: Options<PostApiLendersAddLenderProfileNoteData>) => [
    createQueryKey("postApiLendersAddLenderProfileNote", options)
];

export const postApiLendersAddLenderProfileNoteOptions = (options?: Options<PostApiLendersAddLenderProfileNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersAddLenderProfileNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersAddLenderProfileNoteQueryKey(options)
}); };

export const postApiLendersAddLenderProfileNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersAddLenderProfileNoteResponse, AxiosError<PostApiLendersAddLenderProfileNoteError>, Options<PostApiLendersAddLenderProfileNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersAddLenderProfileNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersSpecialistUpdateLenderProfileQueryKey = (options?: Options<PostApiLendersSpecialistUpdateLenderProfileData>) => [
    createQueryKey("postApiLendersSpecialistUpdateLenderProfile", options)
];

export const postApiLendersSpecialistUpdateLenderProfileOptions = (options?: Options<PostApiLendersSpecialistUpdateLenderProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersSpecialistUpdateLenderProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersSpecialistUpdateLenderProfileQueryKey(options)
}); };

export const postApiLendersSpecialistUpdateLenderProfileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersSpecialistUpdateLenderProfileResponse, AxiosError<PostApiLendersSpecialistUpdateLenderProfileError>, Options<PostApiLendersSpecialistUpdateLenderProfileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersSpecialistUpdateLenderProfile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateLenderRegionProfileQueryKey = (options?: Options<PostApiLendersUpdateLenderRegionProfileData>) => [
    createQueryKey("postApiLendersUpdateLenderRegionProfile", options)
];

export const postApiLendersUpdateLenderRegionProfileOptions = (options?: Options<PostApiLendersUpdateLenderRegionProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLenderRegionProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLenderRegionProfileQueryKey(options)
}); };

export const postApiLendersUpdateLenderRegionProfileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLenderRegionProfileResponse, AxiosError<PostApiLendersUpdateLenderRegionProfileError>, Options<PostApiLendersUpdateLenderRegionProfileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLenderRegionProfile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateLenderProfileQueryKey = (options?: Options<PostApiLendersUpdateLenderProfileData>) => [
    createQueryKey("postApiLendersUpdateLenderProfile", options)
];

export const postApiLendersUpdateLenderProfileOptions = (options?: Options<PostApiLendersUpdateLenderProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLenderProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLenderProfileQueryKey(options)
}); };

export const postApiLendersUpdateLenderProfileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLenderProfileResponse, AxiosError<PostApiLendersUpdateLenderProfileError>, Options<PostApiLendersUpdateLenderProfileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLenderProfile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersAdminResetLenderTermsQueryKey = (options?: Options<PostApiLendersAdminResetLenderTermsData>) => [
    createQueryKey("postApiLendersAdminResetLenderTerms", options)
];

export const postApiLendersAdminResetLenderTermsOptions = (options?: Options<PostApiLendersAdminResetLenderTermsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersAdminResetLenderTerms({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersAdminResetLenderTermsQueryKey(options)
}); };

export const postApiLendersAdminResetLenderTermsMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersAdminResetLenderTermsResponse, AxiosError<PostApiLendersAdminResetLenderTermsError>, Options<PostApiLendersAdminResetLenderTermsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersAdminResetLenderTerms({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersAcceptLenderTermsQueryKey = (options?: Options<PostApiLendersAcceptLenderTermsData>) => [
    createQueryKey("postApiLendersAcceptLenderTerms", options)
];

export const postApiLendersAcceptLenderTermsOptions = (options?: Options<PostApiLendersAcceptLenderTermsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersAcceptLenderTerms({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersAcceptLenderTermsQueryKey(options)
}); };

export const postApiLendersAcceptLenderTermsMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersAcceptLenderTermsResponse, AxiosError<PostApiLendersAcceptLenderTermsError>, Options<PostApiLendersAcceptLenderTermsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersAcceptLenderTerms({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLendersUpdateLenderCriteriaQueryKey = (options?: Options<PostApiLendersUpdateLenderCriteriaData>) => [
    createQueryKey("postApiLendersUpdateLenderCriteria", options)
];

export const postApiLendersUpdateLenderCriteriaOptions = (options?: Options<PostApiLendersUpdateLenderCriteriaData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLendersUpdateLenderCriteria({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLendersUpdateLenderCriteriaQueryKey(options)
}); };

export const postApiLendersUpdateLenderCriteriaMutation = () => { const mutationOptions: UseMutationOptions<PostApiLendersUpdateLenderCriteriaResponse, AxiosError<PostApiLendersUpdateLenderCriteriaError>, Options<PostApiLendersUpdateLenderCriteriaData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLendersUpdateLenderCriteria({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLenderApplicationsExpressInterestQueryKey = (options?: Options<PostApiLenderApplicationsExpressInterestData>) => [
    createQueryKey("postApiLenderApplicationsExpressInterest", options)
];

export const postApiLenderApplicationsExpressInterestOptions = (options?: Options<PostApiLenderApplicationsExpressInterestData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLenderApplicationsExpressInterest({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLenderApplicationsExpressInterestQueryKey(options)
}); };

export const postApiLenderApplicationsExpressInterestMutation = () => { const mutationOptions: UseMutationOptions<PostApiLenderApplicationsExpressInterestResponse, AxiosError<PostApiLenderApplicationsExpressInterestError>, Options<PostApiLenderApplicationsExpressInterestData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLenderApplicationsExpressInterest({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLenderApplicationsSpecialistUpdateUnderwritingStateQueryKey = (options?: Options<PostApiLenderApplicationsSpecialistUpdateUnderwritingStateData>) => [
    createQueryKey("postApiLenderApplicationsSpecialistUpdateUnderwritingState", options)
];

export const postApiLenderApplicationsSpecialistUpdateUnderwritingStateOptions = (options?: Options<PostApiLenderApplicationsSpecialistUpdateUnderwritingStateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLenderApplicationsSpecialistUpdateUnderwritingState({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLenderApplicationsSpecialistUpdateUnderwritingStateQueryKey(options)
}); };

export const postApiLenderApplicationsSpecialistUpdateUnderwritingStateMutation = () => { const mutationOptions: UseMutationOptions<PostApiLenderApplicationsSpecialistUpdateUnderwritingStateResponse, AxiosError<PostApiLenderApplicationsSpecialistUpdateUnderwritingStateError>, Options<PostApiLenderApplicationsSpecialistUpdateUnderwritingStateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLenderApplicationsSpecialistUpdateUnderwritingState({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLenderApplicationsSpecialistExpressInterestQueryKey = (options?: Options<PostApiLenderApplicationsSpecialistExpressInterestData>) => [
    createQueryKey("postApiLenderApplicationsSpecialistExpressInterest", options)
];

export const postApiLenderApplicationsSpecialistExpressInterestOptions = (options?: Options<PostApiLenderApplicationsSpecialistExpressInterestData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLenderApplicationsSpecialistExpressInterest({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLenderApplicationsSpecialistExpressInterestQueryKey(options)
}); };

export const postApiLenderApplicationsSpecialistExpressInterestMutation = () => { const mutationOptions: UseMutationOptions<PostApiLenderApplicationsSpecialistExpressInterestResponse, AxiosError<PostApiLenderApplicationsSpecialistExpressInterestError>, Options<PostApiLenderApplicationsSpecialistExpressInterestData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLenderApplicationsSpecialistExpressInterest({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLenderApplicationsAddLenderApplicationNoteQueryKey = (options?: Options<PostApiLenderApplicationsAddLenderApplicationNoteData>) => [
    createQueryKey("postApiLenderApplicationsAddLenderApplicationNote", options)
];

export const postApiLenderApplicationsAddLenderApplicationNoteOptions = (options?: Options<PostApiLenderApplicationsAddLenderApplicationNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLenderApplicationsAddLenderApplicationNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLenderApplicationsAddLenderApplicationNoteQueryKey(options)
}); };

export const postApiLenderApplicationsAddLenderApplicationNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLenderApplicationsAddLenderApplicationNoteResponse, AxiosError<PostApiLenderApplicationsAddLenderApplicationNoteError>, Options<PostApiLenderApplicationsAddLenderApplicationNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLenderApplicationsAddLenderApplicationNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLenderApplicationsGetLenderApplicationNotesQueryKey = (options?: Options<GetApiLenderApplicationsGetLenderApplicationNotesData>) => [
    createQueryKey("getApiLenderApplicationsGetLenderApplicationNotes", options)
];

export const getApiLenderApplicationsGetLenderApplicationNotesOptions = (options?: Options<GetApiLenderApplicationsGetLenderApplicationNotesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLenderApplicationsGetLenderApplicationNotes({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLenderApplicationsGetLenderApplicationNotesQueryKey(options)
}); };

export const getApiLenderApplicationsGetLenderAppAuditLogQueryKey = (options?: Options<GetApiLenderApplicationsGetLenderAppAuditLogData>) => [
    createQueryKey("getApiLenderApplicationsGetLenderAppAuditLog", options)
];

export const getApiLenderApplicationsGetLenderAppAuditLogOptions = (options?: Options<GetApiLenderApplicationsGetLenderAppAuditLogData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLenderApplicationsGetLenderAppAuditLog({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLenderApplicationsGetLenderAppAuditLogQueryKey(options)
}); };

export const postApiLoanApplicationsRefreshBorrowerProfileQueryKey = (options?: Options<PostApiLoanApplicationsRefreshBorrowerProfileData>) => [
    createQueryKey("postApiLoanApplicationsRefreshBorrowerProfile", options)
];

export const postApiLoanApplicationsRefreshBorrowerProfileOptions = (options?: Options<PostApiLoanApplicationsRefreshBorrowerProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsRefreshBorrowerProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsRefreshBorrowerProfileQueryKey(options)
}); };

export const postApiLoanApplicationsRefreshBorrowerProfileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsRefreshBorrowerProfileResponse, AxiosError<PostApiLoanApplicationsRefreshBorrowerProfileError>, Options<PostApiLoanApplicationsRefreshBorrowerProfileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsRefreshBorrowerProfile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsImportantAuditQueryKey = (options?: Options<GetApiLoanApplicationsImportantAuditData>) => [
    createQueryKey("getApiLoanApplicationsImportantAudit", options)
];

export const getApiLoanApplicationsImportantAuditOptions = (options?: Options<GetApiLoanApplicationsImportantAuditData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsImportantAudit({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsImportantAuditQueryKey(options)
}); };

export const postApiLoanApplicationsCompleteTriageQueryKey = (options?: Options<PostApiLoanApplicationsCompleteTriageData>) => [
    createQueryKey("postApiLoanApplicationsCompleteTriage", options)
];

export const postApiLoanApplicationsCompleteTriageOptions = (options?: Options<PostApiLoanApplicationsCompleteTriageData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsCompleteTriage({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsCompleteTriageQueryKey(options)
}); };

export const postApiLoanApplicationsCompleteTriageMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsCompleteTriageResponse, AxiosError<PostApiLoanApplicationsCompleteTriageError>, Options<PostApiLoanApplicationsCompleteTriageData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsCompleteTriage({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsForceCloseLoanQueryKey = (options?: Options<PostApiLoanApplicationsForceCloseLoanData>) => [
    createQueryKey("postApiLoanApplicationsForceCloseLoan", options)
];

export const postApiLoanApplicationsForceCloseLoanOptions = (options?: Options<PostApiLoanApplicationsForceCloseLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsForceCloseLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsForceCloseLoanQueryKey(options)
}); };

export const postApiLoanApplicationsForceCloseLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsForceCloseLoanResponse, AxiosError<PostApiLoanApplicationsForceCloseLoanError>, Options<PostApiLoanApplicationsForceCloseLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsForceCloseLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsTriageLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsTriageLoans", options)
];

export const getApiLoanApplicationsTriageLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsTriageLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsTriageLoansQueryKey(options)
}); };

export const getApiLoanApplicationsSkippedLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsSkippedLoans", options)
];

export const getApiLoanApplicationsSkippedLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsSkippedLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsSkippedLoansQueryKey(options)
}); };

export const getApiLoanApplicationsSupervisorLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsSupervisorLoans", options)
];

export const getApiLoanApplicationsSupervisorLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsSupervisorLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsSupervisorLoansQueryKey(options)
}); };

export const getApiLoanApplicationsGetLoanAuditLogQueryKey = (options?: Options<GetApiLoanApplicationsGetLoanAuditLogData>) => [
    createQueryKey("getApiLoanApplicationsGetLoanAuditLog", options)
];

export const getApiLoanApplicationsGetLoanAuditLogOptions = (options?: Options<GetApiLoanApplicationsGetLoanAuditLogData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetLoanAuditLog({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetLoanAuditLogQueryKey(options)
}); };

export const getApiLoanApplicationsGetAllLoansQueryKey = (options?: Options<GetApiLoanApplicationsGetAllLoansData>) => [
    createQueryKey("getApiLoanApplicationsGetAllLoans", options)
];

export const getApiLoanApplicationsGetAllLoansOptions = (options?: Options<GetApiLoanApplicationsGetAllLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetAllLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetAllLoansQueryKey(options)
}); };

export const getApiLoanApplicationsActiveLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsActiveLoans", options)
];

export const getApiLoanApplicationsActiveLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsActiveLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsActiveLoansQueryKey(options)
}); };

export const postApiLoanApplicationsAdminOverrideStatusQueryKey = (options?: Options<PostApiLoanApplicationsAdminOverrideStatusData>) => [
    createQueryKey("postApiLoanApplicationsAdminOverrideStatus", options)
];

export const postApiLoanApplicationsAdminOverrideStatusOptions = (options?: Options<PostApiLoanApplicationsAdminOverrideStatusData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAdminOverrideStatus({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAdminOverrideStatusQueryKey(options)
}); };

export const postApiLoanApplicationsAdminOverrideStatusMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAdminOverrideStatusResponse, AxiosError<PostApiLoanApplicationsAdminOverrideStatusError>, Options<PostApiLoanApplicationsAdminOverrideStatusData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAdminOverrideStatus({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsCancelLoanQueryKey = (options?: Options<PostApiLoanApplicationsCancelLoanData>) => [
    createQueryKey("postApiLoanApplicationsCancelLoan", options)
];

export const postApiLoanApplicationsCancelLoanOptions = (options?: Options<PostApiLoanApplicationsCancelLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsCancelLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsCancelLoanQueryKey(options)
}); };

export const postApiLoanApplicationsCancelLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsCancelLoanResponse, AxiosError<PostApiLoanApplicationsCancelLoanError>, Options<PostApiLoanApplicationsCancelLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsCancelLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsSubmitSignedClosingFilesQueryKey = (options?: Options<PostApiLoanApplicationsSubmitSignedClosingFilesData>) => [
    createQueryKey("postApiLoanApplicationsSubmitSignedClosingFiles", options)
];

export const postApiLoanApplicationsSubmitSignedClosingFilesOptions = (options?: Options<PostApiLoanApplicationsSubmitSignedClosingFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSubmitSignedClosingFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSubmitSignedClosingFilesQueryKey(options)
}); };

export const postApiLoanApplicationsSubmitSignedClosingFilesMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSubmitSignedClosingFilesResponse, AxiosError<PostApiLoanApplicationsSubmitSignedClosingFilesError>, Options<PostApiLoanApplicationsSubmitSignedClosingFilesData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSubmitSignedClosingFiles({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsSubmitClosingFilesQueryKey = (options?: Options<PostApiLoanApplicationsSubmitClosingFilesData>) => [
    createQueryKey("postApiLoanApplicationsSubmitClosingFiles", options)
];

export const postApiLoanApplicationsSubmitClosingFilesOptions = (options?: Options<PostApiLoanApplicationsSubmitClosingFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSubmitClosingFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSubmitClosingFilesQueryKey(options)
}); };

export const postApiLoanApplicationsSubmitClosingFilesMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSubmitClosingFilesResponse, AxiosError<PostApiLoanApplicationsSubmitClosingFilesError>, Options<PostApiLoanApplicationsSubmitClosingFilesData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSubmitClosingFiles({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsSubmitFinalClosingFilesQueryKey = (options?: Options<PostApiLoanApplicationsSubmitFinalClosingFilesData>) => [
    createQueryKey("postApiLoanApplicationsSubmitFinalClosingFiles", options)
];

export const postApiLoanApplicationsSubmitFinalClosingFilesOptions = (options?: Options<PostApiLoanApplicationsSubmitFinalClosingFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSubmitFinalClosingFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSubmitFinalClosingFilesQueryKey(options)
}); };

export const postApiLoanApplicationsSubmitFinalClosingFilesMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSubmitFinalClosingFilesResponse, AxiosError<PostApiLoanApplicationsSubmitFinalClosingFilesError>, Options<PostApiLoanApplicationsSubmitFinalClosingFilesData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSubmitFinalClosingFiles({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsOutgoingLenderApplicationsQueryKey = (options?: Options<GetApiLoanApplicationsOutgoingLenderApplicationsData>) => [
    createQueryKey("getApiLoanApplicationsOutgoingLenderApplications", options)
];

export const getApiLoanApplicationsOutgoingLenderApplicationsOptions = (options?: Options<GetApiLoanApplicationsOutgoingLenderApplicationsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsOutgoingLenderApplications({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsOutgoingLenderApplicationsQueryKey(options)
}); };

export const postApiLoanApplicationsSpecialistDeclineLoanQueryKey = (options?: Options<PostApiLoanApplicationsSpecialistDeclineLoanData>) => [
    createQueryKey("postApiLoanApplicationsSpecialistDeclineLoan", options)
];

export const postApiLoanApplicationsSpecialistDeclineLoanOptions = (options?: Options<PostApiLoanApplicationsSpecialistDeclineLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSpecialistDeclineLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSpecialistDeclineLoanQueryKey(options)
}); };

export const postApiLoanApplicationsSpecialistDeclineLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSpecialistDeclineLoanResponse, AxiosError<PostApiLoanApplicationsSpecialistDeclineLoanError>, Options<PostApiLoanApplicationsSpecialistDeclineLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSpecialistDeclineLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsApproveSignedClosingQueryKey = (options?: Options<PostApiLoanApplicationsApproveSignedClosingData>) => [
    createQueryKey("postApiLoanApplicationsApproveSignedClosing", options)
];

export const postApiLoanApplicationsApproveSignedClosingOptions = (options?: Options<PostApiLoanApplicationsApproveSignedClosingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsApproveSignedClosing({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsApproveSignedClosingQueryKey(options)
}); };

export const postApiLoanApplicationsApproveSignedClosingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsApproveSignedClosingResponse, AxiosError<PostApiLoanApplicationsApproveSignedClosingError>, Options<PostApiLoanApplicationsApproveSignedClosingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsApproveSignedClosing({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsDeclineLoanQueryKey = (options?: Options<PostApiLoanApplicationsDeclineLoanData>) => [
    createQueryKey("postApiLoanApplicationsDeclineLoan", options)
];

export const postApiLoanApplicationsDeclineLoanOptions = (options?: Options<PostApiLoanApplicationsDeclineLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeclineLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeclineLoanQueryKey(options)
}); };

export const postApiLoanApplicationsDeclineLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeclineLoanResponse, AxiosError<PostApiLoanApplicationsDeclineLoanError>, Options<PostApiLoanApplicationsDeclineLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeclineLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsDeclineSignedClosingQueryKey = (options?: Options<PostApiLoanApplicationsDeclineSignedClosingData>) => [
    createQueryKey("postApiLoanApplicationsDeclineSignedClosing", options)
];

export const postApiLoanApplicationsDeclineSignedClosingOptions = (options?: Options<PostApiLoanApplicationsDeclineSignedClosingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeclineSignedClosing({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeclineSignedClosingQueryKey(options)
}); };

export const postApiLoanApplicationsDeclineSignedClosingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeclineSignedClosingResponse, AxiosError<PostApiLoanApplicationsDeclineSignedClosingError>, Options<PostApiLoanApplicationsDeclineSignedClosingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeclineSignedClosing({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsApproveClosingQueryKey = (options?: Options<PostApiLoanApplicationsApproveClosingData>) => [
    createQueryKey("postApiLoanApplicationsApproveClosing", options)
];

export const postApiLoanApplicationsApproveClosingOptions = (options?: Options<PostApiLoanApplicationsApproveClosingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsApproveClosing({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsApproveClosingQueryKey(options)
}); };

export const postApiLoanApplicationsApproveClosingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsApproveClosingResponse, AxiosError<PostApiLoanApplicationsApproveClosingError>, Options<PostApiLoanApplicationsApproveClosingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsApproveClosing({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsDeclineClosingQueryKey = (options?: Options<PostApiLoanApplicationsDeclineClosingData>) => [
    createQueryKey("postApiLoanApplicationsDeclineClosing", options)
];

export const postApiLoanApplicationsDeclineClosingOptions = (options?: Options<PostApiLoanApplicationsDeclineClosingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeclineClosing({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeclineClosingQueryKey(options)
}); };

export const postApiLoanApplicationsDeclineClosingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeclineClosingResponse, AxiosError<PostApiLoanApplicationsDeclineClosingError>, Options<PostApiLoanApplicationsDeclineClosingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeclineClosing({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsApproveFinalClosingDocsQueryKey = (options?: Options<PostApiLoanApplicationsApproveFinalClosingDocsData>) => [
    createQueryKey("postApiLoanApplicationsApproveFinalClosingDocs", options)
];

export const postApiLoanApplicationsApproveFinalClosingDocsOptions = (options?: Options<PostApiLoanApplicationsApproveFinalClosingDocsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsApproveFinalClosingDocs({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsApproveFinalClosingDocsQueryKey(options)
}); };

export const postApiLoanApplicationsApproveFinalClosingDocsMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsApproveFinalClosingDocsResponse, AxiosError<PostApiLoanApplicationsApproveFinalClosingDocsError>, Options<PostApiLoanApplicationsApproveFinalClosingDocsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsApproveFinalClosingDocs({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsConfirmFundingQueryKey = (options?: Options<PostApiLoanApplicationsConfirmFundingData>) => [
    createQueryKey("postApiLoanApplicationsConfirmFunding", options)
];

export const postApiLoanApplicationsConfirmFundingOptions = (options?: Options<PostApiLoanApplicationsConfirmFundingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsConfirmFunding({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsConfirmFundingQueryKey(options)
}); };

export const postApiLoanApplicationsConfirmFundingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsConfirmFundingResponse, AxiosError<PostApiLoanApplicationsConfirmFundingError>, Options<PostApiLoanApplicationsConfirmFundingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsConfirmFunding({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsMarkLoanNotFundedQueryKey = (options?: Options<PostApiLoanApplicationsMarkLoanNotFundedData>) => [
    createQueryKey("postApiLoanApplicationsMarkLoanNotFunded", options)
];

export const postApiLoanApplicationsMarkLoanNotFundedOptions = (options?: Options<PostApiLoanApplicationsMarkLoanNotFundedData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsMarkLoanNotFunded({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsMarkLoanNotFundedQueryKey(options)
}); };

export const postApiLoanApplicationsMarkLoanNotFundedMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsMarkLoanNotFundedResponse, AxiosError<PostApiLoanApplicationsMarkLoanNotFundedError>, Options<PostApiLoanApplicationsMarkLoanNotFundedData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsMarkLoanNotFunded({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsCloseLoanQueryKey = (options?: Options<PostApiLoanApplicationsCloseLoanData>) => [
    createQueryKey("postApiLoanApplicationsCloseLoan", options)
];

export const postApiLoanApplicationsCloseLoanOptions = (options?: Options<PostApiLoanApplicationsCloseLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsCloseLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsCloseLoanQueryKey(options)
}); };

export const postApiLoanApplicationsCloseLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsCloseLoanResponse, AxiosError<PostApiLoanApplicationsCloseLoanError>, Options<PostApiLoanApplicationsCloseLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsCloseLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsApproveSignedBindingQueryKey = (options?: Options<PostApiLoanApplicationsApproveSignedBindingData>) => [
    createQueryKey("postApiLoanApplicationsApproveSignedBinding", options)
];

export const postApiLoanApplicationsApproveSignedBindingOptions = (options?: Options<PostApiLoanApplicationsApproveSignedBindingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsApproveSignedBinding({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsApproveSignedBindingQueryKey(options)
}); };

export const postApiLoanApplicationsApproveSignedBindingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsApproveSignedBindingResponse, AxiosError<PostApiLoanApplicationsApproveSignedBindingError>, Options<PostApiLoanApplicationsApproveSignedBindingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsApproveSignedBinding({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsWithdrawLenderFromLoanQueryKey = (options?: Options<PostApiLoanApplicationsWithdrawLenderFromLoanData>) => [
    createQueryKey("postApiLoanApplicationsWithdrawLenderFromLoan", options)
];

export const postApiLoanApplicationsWithdrawLenderFromLoanOptions = (options?: Options<PostApiLoanApplicationsWithdrawLenderFromLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsWithdrawLenderFromLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsWithdrawLenderFromLoanQueryKey(options)
}); };

export const postApiLoanApplicationsWithdrawLenderFromLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsWithdrawLenderFromLoanResponse, AxiosError<PostApiLoanApplicationsWithdrawLenderFromLoanError>, Options<PostApiLoanApplicationsWithdrawLenderFromLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsWithdrawLenderFromLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsDeclineSignedBindingQueryKey = (options?: Options<PostApiLoanApplicationsDeclineSignedBindingData>) => [
    createQueryKey("postApiLoanApplicationsDeclineSignedBinding", options)
];

export const postApiLoanApplicationsDeclineSignedBindingOptions = (options?: Options<PostApiLoanApplicationsDeclineSignedBindingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeclineSignedBinding({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeclineSignedBindingQueryKey(options)
}); };

export const postApiLoanApplicationsDeclineSignedBindingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeclineSignedBindingResponse, AxiosError<PostApiLoanApplicationsDeclineSignedBindingError>, Options<PostApiLoanApplicationsDeclineSignedBindingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeclineSignedBinding({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsSpecialistUpdateLoanAskQueryKey = (options?: Options<PostApiLoanApplicationsSpecialistUpdateLoanAskData>) => [
    createQueryKey("postApiLoanApplicationsSpecialistUpdateLoanAsk", options)
];

export const postApiLoanApplicationsSpecialistUpdateLoanAskOptions = (options?: Options<PostApiLoanApplicationsSpecialistUpdateLoanAskData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSpecialistUpdateLoanAsk({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSpecialistUpdateLoanAskQueryKey(options)
}); };

export const postApiLoanApplicationsSpecialistUpdateLoanAskMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSpecialistUpdateLoanAskResponse, AxiosError<PostApiLoanApplicationsSpecialistUpdateLoanAskError>, Options<PostApiLoanApplicationsSpecialistUpdateLoanAskData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSpecialistUpdateLoanAsk({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateLoanApplicationDashboardNoteQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLoanApplicationDashboardNote", options)
];

export const postApiLoanApplicationsUpdateLoanApplicationDashboardNoteOptions = (options?: Options<PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLoanApplicationDashboardNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLoanApplicationDashboardNoteQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanApplicationDashboardNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteResponse, AxiosError<PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteError>, Options<PostApiLoanApplicationsUpdateLoanApplicationDashboardNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLoanApplicationDashboardNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsGetAdditionalFilesQueryKey = (options?: Options<GetApiLoanApplicationsGetAdditionalFilesData>) => [
    createQueryKey("getApiLoanApplicationsGetAdditionalFiles", options)
];

export const getApiLoanApplicationsGetAdditionalFilesOptions = (options?: Options<GetApiLoanApplicationsGetAdditionalFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetAdditionalFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetAdditionalFilesQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanApplicationOnHoldQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLoanApplicationOnHoldData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLoanApplicationOnHold", options)
];

export const postApiLoanApplicationsUpdateLoanApplicationOnHoldOptions = (options?: Options<PostApiLoanApplicationsUpdateLoanApplicationOnHoldData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLoanApplicationOnHold({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLoanApplicationOnHoldQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanApplicationOnHoldMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLoanApplicationOnHoldResponse, AxiosError<PostApiLoanApplicationsUpdateLoanApplicationOnHoldError>, Options<PostApiLoanApplicationsUpdateLoanApplicationOnHoldData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLoanApplicationOnHold({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsChartLoanDataQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsChartLoanData", options)
];

export const getApiLoanApplicationsChartLoanDataOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsChartLoanData({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsChartLoanDataQueryKey(options)
}); };

export const getApiLoanApplicationsChartTermSheetDataQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsChartTermSheetData", options)
];

export const getApiLoanApplicationsChartTermSheetDataOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsChartTermSheetData({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsChartTermSheetDataQueryKey(options)
}); };

export const postApiLoanApplicationsRevertTermSheetQueryKey = (options?: Options<PostApiLoanApplicationsRevertTermSheetData>) => [
    createQueryKey("postApiLoanApplicationsRevertTermSheet", options)
];

export const postApiLoanApplicationsRevertTermSheetOptions = (options?: Options<PostApiLoanApplicationsRevertTermSheetData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsRevertTermSheet({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsRevertTermSheetQueryKey(options)
}); };

export const postApiLoanApplicationsRevertTermSheetMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsRevertTermSheetResponse, AxiosError<PostApiLoanApplicationsRevertTermSheetError>, Options<PostApiLoanApplicationsRevertTermSheetData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsRevertTermSheet({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateOfferDeadlineQueryKey = (options?: Options<PostApiLoanApplicationsUpdateOfferDeadlineData>) => [
    createQueryKey("postApiLoanApplicationsUpdateOfferDeadline", options)
];

export const postApiLoanApplicationsUpdateOfferDeadlineOptions = (options?: Options<PostApiLoanApplicationsUpdateOfferDeadlineData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateOfferDeadline({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateOfferDeadlineQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateOfferDeadlineMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateOfferDeadlineResponse, AxiosError<PostApiLoanApplicationsUpdateOfferDeadlineError>, Options<PostApiLoanApplicationsUpdateOfferDeadlineData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateOfferDeadline({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsGetLenderLoanAuditQueryKey = (options?: Options<GetApiLoanApplicationsGetLenderLoanAuditData>) => [
    createQueryKey("getApiLoanApplicationsGetLenderLoanAudit", options)
];

export const getApiLoanApplicationsGetLenderLoanAuditOptions = (options?: Options<GetApiLoanApplicationsGetLenderLoanAuditData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetLenderLoanAudit({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetLenderLoanAuditQueryKey(options)
}); };

export const getApiLoanApplicationsGetBorrowerReviewFilesQueryKey = (options?: Options<GetApiLoanApplicationsGetBorrowerReviewFilesData>) => [
    createQueryKey("getApiLoanApplicationsGetBorrowerReviewFiles", options)
];

export const getApiLoanApplicationsGetBorrowerReviewFilesOptions = (options?: Options<GetApiLoanApplicationsGetBorrowerReviewFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetBorrowerReviewFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetBorrowerReviewFilesQueryKey(options)
}); };

export const postApiLoanApplicationsDeleteBorrowerReviewFileQueryKey = (options?: Options<PostApiLoanApplicationsDeleteBorrowerReviewFileData>) => [
    createQueryKey("postApiLoanApplicationsDeleteBorrowerReviewFile", options)
];

export const postApiLoanApplicationsDeleteBorrowerReviewFileOptions = (options?: Options<PostApiLoanApplicationsDeleteBorrowerReviewFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeleteBorrowerReviewFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeleteBorrowerReviewFileQueryKey(options)
}); };

export const postApiLoanApplicationsDeleteBorrowerReviewFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeleteBorrowerReviewFileResponse, AxiosError<PostApiLoanApplicationsDeleteBorrowerReviewFileError>, Options<PostApiLoanApplicationsDeleteBorrowerReviewFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeleteBorrowerReviewFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUploadBorrowerReviewFilesQueryKey = (options?: Options<PostApiLoanApplicationsUploadBorrowerReviewFilesData>) => [
    createQueryKey("postApiLoanApplicationsUploadBorrowerReviewFiles", options)
];

export const postApiLoanApplicationsUploadBorrowerReviewFilesOptions = (options?: Options<PostApiLoanApplicationsUploadBorrowerReviewFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUploadBorrowerReviewFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUploadBorrowerReviewFilesQueryKey(options)
}); };

export const postApiLoanApplicationsUploadBorrowerReviewFilesMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUploadBorrowerReviewFilesResponse, AxiosError<PostApiLoanApplicationsUploadBorrowerReviewFilesError>, Options<PostApiLoanApplicationsUploadBorrowerReviewFilesData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUploadBorrowerReviewFiles({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsRequestLenderSubmissionQueryKey = (options?: Options<PostApiLoanApplicationsRequestLenderSubmissionData>) => [
    createQueryKey("postApiLoanApplicationsRequestLenderSubmission", options)
];

export const postApiLoanApplicationsRequestLenderSubmissionOptions = (options?: Options<PostApiLoanApplicationsRequestLenderSubmissionData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsRequestLenderSubmission({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsRequestLenderSubmissionQueryKey(options)
}); };

export const postApiLoanApplicationsRequestLenderSubmissionMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsRequestLenderSubmissionResponse, AxiosError<PostApiLoanApplicationsRequestLenderSubmissionError>, Options<PostApiLoanApplicationsRequestLenderSubmissionData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsRequestLenderSubmission({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUploadAdditionalFileQueryKey = (options?: Options<PostApiLoanApplicationsUploadAdditionalFileData>) => [
    createQueryKey("postApiLoanApplicationsUploadAdditionalFile", options)
];

export const postApiLoanApplicationsUploadAdditionalFileOptions = (options?: Options<PostApiLoanApplicationsUploadAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUploadAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUploadAdditionalFileQueryKey(options)
}); };

export const postApiLoanApplicationsUploadAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUploadAdditionalFileResponse, AxiosError<PostApiLoanApplicationsUploadAdditionalFileError>, Options<PostApiLoanApplicationsUploadAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUploadAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsDeleteAdditionalFileQueryKey = (options?: Options<PostApiLoanApplicationsDeleteAdditionalFileData>) => [
    createQueryKey("postApiLoanApplicationsDeleteAdditionalFile", options)
];

export const postApiLoanApplicationsDeleteAdditionalFileOptions = (options?: Options<PostApiLoanApplicationsDeleteAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeleteAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeleteAdditionalFileQueryKey(options)
}); };

export const postApiLoanApplicationsDeleteAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeleteAdditionalFileResponse, AxiosError<PostApiLoanApplicationsDeleteAdditionalFileError>, Options<PostApiLoanApplicationsDeleteAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeleteAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsGetAcceptedOffersQueryKey = (options?: Options<GetApiLoanApplicationsGetAcceptedOffersData>) => [
    createQueryKey("getApiLoanApplicationsGetAcceptedOffers", options)
];

export const getApiLoanApplicationsGetAcceptedOffersOptions = (options?: Options<GetApiLoanApplicationsGetAcceptedOffersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetAcceptedOffers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetAcceptedOffersQueryKey(options)
}); };

export const getApiLoanApplicationsDownloadAdditionalFileQueryKey = (options?: Options<GetApiLoanApplicationsDownloadAdditionalFileData>) => [
    createQueryKey("getApiLoanApplicationsDownloadAdditionalFile", options)
];

export const getApiLoanApplicationsDownloadAdditionalFileOptions = (options?: Options<GetApiLoanApplicationsDownloadAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsDownloadAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsDownloadAdditionalFileQueryKey(options)
}); };

export const getApiLoanApplicationsGetBorrowerTemplateExportQueryKey = (options?: Options<GetApiLoanApplicationsGetBorrowerTemplateExportData>) => [
    createQueryKey("getApiLoanApplicationsGetBorrowerTemplateExport", options)
];

export const getApiLoanApplicationsGetBorrowerTemplateExportOptions = (options?: Options<GetApiLoanApplicationsGetBorrowerTemplateExportData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetBorrowerTemplateExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetBorrowerTemplateExportQueryKey(options)
}); };

export const postApiLoanApplicationsGetBorrowerPackageExportQueryKey = (options?: Options<PostApiLoanApplicationsGetBorrowerPackageExportData>) => [
    createQueryKey("postApiLoanApplicationsGetBorrowerPackageExport", options)
];

export const postApiLoanApplicationsGetBorrowerPackageExportOptions = (options?: Options<PostApiLoanApplicationsGetBorrowerPackageExportData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsGetBorrowerPackageExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsGetBorrowerPackageExportQueryKey(options)
}); };

export const postApiLoanApplicationsGetBorrowerPackageExportMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsGetBorrowerPackageExportResponse, AxiosError<PostApiLoanApplicationsGetBorrowerPackageExportError>, Options<PostApiLoanApplicationsGetBorrowerPackageExportData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsGetBorrowerPackageExport({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsLenderReferredLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsLenderReferredLoans", options)
];

export const getApiLoanApplicationsLenderReferredLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsLenderReferredLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsLenderReferredLoansQueryKey(options)
}); };

export const postApiLoanApplicationsGenerateLenderSummaryQueryKey = (options?: Options<PostApiLoanApplicationsGenerateLenderSummaryData>) => [
    createQueryKey("postApiLoanApplicationsGenerateLenderSummary", options)
];

export const postApiLoanApplicationsGenerateLenderSummaryOptions = (options?: Options<PostApiLoanApplicationsGenerateLenderSummaryData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsGenerateLenderSummary({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsGenerateLenderSummaryQueryKey(options)
}); };

export const postApiLoanApplicationsGenerateLenderSummaryMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsGenerateLenderSummaryResponse, AxiosError<PostApiLoanApplicationsGenerateLenderSummaryError>, Options<PostApiLoanApplicationsGenerateLenderSummaryData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsGenerateLenderSummary({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsGenerateLoanPreviewQueryKey = (options?: Options<PostApiLoanApplicationsGenerateLoanPreviewData>) => [
    createQueryKey("postApiLoanApplicationsGenerateLoanPreview", options)
];

export const postApiLoanApplicationsGenerateLoanPreviewOptions = (options?: Options<PostApiLoanApplicationsGenerateLoanPreviewData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsGenerateLoanPreview({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsGenerateLoanPreviewQueryKey(options)
}); };

export const postApiLoanApplicationsGenerateLoanPreviewMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsGenerateLoanPreviewResponse, AxiosError<PostApiLoanApplicationsGenerateLoanPreviewError>, Options<PostApiLoanApplicationsGenerateLoanPreviewData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsGenerateLoanPreview({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateLoanPreviewQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLoanPreviewData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLoanPreview", options)
];

export const postApiLoanApplicationsUpdateLoanPreviewOptions = (options?: Options<PostApiLoanApplicationsUpdateLoanPreviewData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLoanPreview({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLoanPreviewQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanPreviewMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLoanPreviewResponse, AxiosError<PostApiLoanApplicationsUpdateLoanPreviewError>, Options<PostApiLoanApplicationsUpdateLoanPreviewData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLoanPreview({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsDownloadFinancialExportQueryKey = (options?: Options<GetApiLoanApplicationsDownloadFinancialExportData>) => [
    createQueryKey("getApiLoanApplicationsDownloadFinancialExport", options)
];

export const getApiLoanApplicationsDownloadFinancialExportOptions = (options?: Options<GetApiLoanApplicationsDownloadFinancialExportData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsDownloadFinancialExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsDownloadFinancialExportQueryKey(options)
}); };

export const getApiLoanApplicationsGetLoanApplicationsQueryKey = (options?: Options) => [
    createQueryKey("getApiLoanApplicationsGetLoanApplications", options)
];

export const getApiLoanApplicationsGetLoanApplicationsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetLoanApplications({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetLoanApplicationsQueryKey(options)
}); };

export const getApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsQueryKey = (options?: Options<GetApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsData>) => [
    createQueryKey("getApiLoanApplicationsSpecialistGetBorrowerLoanApplications", options)
];

export const getApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsOptions = (options?: Options<GetApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsSpecialistGetBorrowerLoanApplications({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsSpecialistGetBorrowerLoanApplicationsQueryKey(options)
}); };

export const postApiLoanApplicationsSetExpectedCloseDateQueryKey = (options?: Options<PostApiLoanApplicationsSetExpectedCloseDateData>) => [
    createQueryKey("postApiLoanApplicationsSetExpectedCloseDate", options)
];

export const postApiLoanApplicationsSetExpectedCloseDateOptions = (options?: Options<PostApiLoanApplicationsSetExpectedCloseDateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSetExpectedCloseDate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSetExpectedCloseDateQueryKey(options)
}); };

export const postApiLoanApplicationsSetExpectedCloseDateMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSetExpectedCloseDateResponse, AxiosError<PostApiLoanApplicationsSetExpectedCloseDateError>, Options<PostApiLoanApplicationsSetExpectedCloseDateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSetExpectedCloseDate({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsSetExpectedFundsDateQueryKey = (options?: Options<PostApiLoanApplicationsSetExpectedFundsDateData>) => [
    createQueryKey("postApiLoanApplicationsSetExpectedFundsDate", options)
];

export const postApiLoanApplicationsSetExpectedFundsDateOptions = (options?: Options<PostApiLoanApplicationsSetExpectedFundsDateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsSetExpectedFundsDate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsSetExpectedFundsDateQueryKey(options)
}); };

export const postApiLoanApplicationsSetExpectedFundsDateMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsSetExpectedFundsDateResponse, AxiosError<PostApiLoanApplicationsSetExpectedFundsDateError>, Options<PostApiLoanApplicationsSetExpectedFundsDateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsSetExpectedFundsDate({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsRevertAttestationQueryKey = (options?: Options<PostApiLoanApplicationsRevertAttestationData>) => [
    createQueryKey("postApiLoanApplicationsRevertAttestation", options)
];

export const postApiLoanApplicationsRevertAttestationOptions = (options?: Options<PostApiLoanApplicationsRevertAttestationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsRevertAttestation({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsRevertAttestationQueryKey(options)
}); };

export const postApiLoanApplicationsRevertAttestationMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsRevertAttestationResponse, AxiosError<PostApiLoanApplicationsRevertAttestationError>, Options<PostApiLoanApplicationsRevertAttestationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsRevertAttestation({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsReviewSubmissionQueryKey = (options?: Options<PostApiLoanApplicationsReviewSubmissionData>) => [
    createQueryKey("postApiLoanApplicationsReviewSubmission", options)
];

export const postApiLoanApplicationsReviewSubmissionOptions = (options?: Options<PostApiLoanApplicationsReviewSubmissionData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsReviewSubmission({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsReviewSubmissionQueryKey(options)
}); };

export const postApiLoanApplicationsReviewSubmissionMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsReviewSubmissionResponse, AxiosError<PostApiLoanApplicationsReviewSubmissionError>, Options<PostApiLoanApplicationsReviewSubmissionData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsReviewSubmission({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateLoanApplicationQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLoanApplicationData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLoanApplication", options)
];

export const postApiLoanApplicationsUpdateLoanApplicationOptions = (options?: Options<PostApiLoanApplicationsUpdateLoanApplicationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLoanApplication({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLoanApplicationQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanApplicationMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLoanApplicationResponse, AxiosError<PostApiLoanApplicationsUpdateLoanApplicationError>, Options<PostApiLoanApplicationsUpdateLoanApplicationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLoanApplication({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsAttestLoanApplicationQueryKey = (options?: Options<PostApiLoanApplicationsAttestLoanApplicationData>) => [
    createQueryKey("postApiLoanApplicationsAttestLoanApplication", options)
];

export const postApiLoanApplicationsAttestLoanApplicationOptions = (options?: Options<PostApiLoanApplicationsAttestLoanApplicationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAttestLoanApplication({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAttestLoanApplicationQueryKey(options)
}); };

export const postApiLoanApplicationsAttestLoanApplicationMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAttestLoanApplicationResponse, AxiosError<PostApiLoanApplicationsAttestLoanApplicationError>, Options<PostApiLoanApplicationsAttestLoanApplicationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAttestLoanApplication({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsCompleteOnboardingQueryKey = (options?: Options<PostApiLoanApplicationsCompleteOnboardingData>) => [
    createQueryKey("postApiLoanApplicationsCompleteOnboarding", options)
];

export const postApiLoanApplicationsCompleteOnboardingOptions = (options?: Options<PostApiLoanApplicationsCompleteOnboardingData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsCompleteOnboarding({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsCompleteOnboardingQueryKey(options)
}); };

export const postApiLoanApplicationsCompleteOnboardingMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsCompleteOnboardingResponse, AxiosError<PostApiLoanApplicationsCompleteOnboardingError>, Options<PostApiLoanApplicationsCompleteOnboardingData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsCompleteOnboarding({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsCompleteManualStepQueryKey = (options?: Options<PostApiLoanApplicationsCompleteManualStepData>) => [
    createQueryKey("postApiLoanApplicationsCompleteManualStep", options)
];

export const postApiLoanApplicationsCompleteManualStepOptions = (options?: Options<PostApiLoanApplicationsCompleteManualStepData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsCompleteManualStep({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsCompleteManualStepQueryKey(options)
}); };

export const postApiLoanApplicationsCompleteManualStepMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsCompleteManualStepResponse, AxiosError<PostApiLoanApplicationsCompleteManualStepError>, Options<PostApiLoanApplicationsCompleteManualStepData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsCompleteManualStep({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsGetEngagedLendersQueryKey = (options?: Options<GetApiLoanApplicationsGetEngagedLendersData>) => [
    createQueryKey("getApiLoanApplicationsGetEngagedLenders", options)
];

export const getApiLoanApplicationsGetEngagedLendersOptions = (options?: Options<GetApiLoanApplicationsGetEngagedLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetEngagedLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetEngagedLendersQueryKey(options)
}); };

export const postApiLoanApplicationsApproveAdditionalFileQueryKey = (options?: Options<PostApiLoanApplicationsApproveAdditionalFileData>) => [
    createQueryKey("postApiLoanApplicationsApproveAdditionalFile", options)
];

export const postApiLoanApplicationsApproveAdditionalFileOptions = (options?: Options<PostApiLoanApplicationsApproveAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsApproveAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsApproveAdditionalFileQueryKey(options)
}); };

export const postApiLoanApplicationsApproveAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsApproveAdditionalFileResponse, AxiosError<PostApiLoanApplicationsApproveAdditionalFileError>, Options<PostApiLoanApplicationsApproveAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsApproveAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsRenameAdditionalFileQueryKey = (options?: Options<PostApiLoanApplicationsRenameAdditionalFileData>) => [
    createQueryKey("postApiLoanApplicationsRenameAdditionalFile", options)
];

export const postApiLoanApplicationsRenameAdditionalFileOptions = (options?: Options<PostApiLoanApplicationsRenameAdditionalFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsRenameAdditionalFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsRenameAdditionalFileQueryKey(options)
}); };

export const postApiLoanApplicationsRenameAdditionalFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsRenameAdditionalFileResponse, AxiosError<PostApiLoanApplicationsRenameAdditionalFileError>, Options<PostApiLoanApplicationsRenameAdditionalFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsRenameAdditionalFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsGetApplicationNotesQueryKey = (options?: Options<GetApiLoanApplicationsGetApplicationNotesData>) => [
    createQueryKey("getApiLoanApplicationsGetApplicationNotes", options)
];

export const getApiLoanApplicationsGetApplicationNotesOptions = (options?: Options<GetApiLoanApplicationsGetApplicationNotesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetApplicationNotes({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetApplicationNotesQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateApplicationNoteQueryKey = (options?: Options<PostApiLoanApplicationsUpdateApplicationNoteData>) => [
    createQueryKey("postApiLoanApplicationsUpdateApplicationNote", options)
];

export const postApiLoanApplicationsUpdateApplicationNoteOptions = (options?: Options<PostApiLoanApplicationsUpdateApplicationNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateApplicationNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateApplicationNoteQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateApplicationNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateApplicationNoteResponse, AxiosError<PostApiLoanApplicationsUpdateApplicationNoteError>, Options<PostApiLoanApplicationsUpdateApplicationNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateApplicationNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsDeleteApplicationNoteQueryKey = (options?: Options<PostApiLoanApplicationsDeleteApplicationNoteData>) => [
    createQueryKey("postApiLoanApplicationsDeleteApplicationNote", options)
];

export const postApiLoanApplicationsDeleteApplicationNoteOptions = (options?: Options<PostApiLoanApplicationsDeleteApplicationNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsDeleteApplicationNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsDeleteApplicationNoteQueryKey(options)
}); };

export const postApiLoanApplicationsDeleteApplicationNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsDeleteApplicationNoteResponse, AxiosError<PostApiLoanApplicationsDeleteApplicationNoteError>, Options<PostApiLoanApplicationsDeleteApplicationNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsDeleteApplicationNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsAddApplicationNoteQueryKey = (options?: Options<PostApiLoanApplicationsAddApplicationNoteData>) => [
    createQueryKey("postApiLoanApplicationsAddApplicationNote", options)
];

export const postApiLoanApplicationsAddApplicationNoteOptions = (options?: Options<PostApiLoanApplicationsAddApplicationNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAddApplicationNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAddApplicationNoteQueryKey(options)
}); };

export const postApiLoanApplicationsAddApplicationNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAddApplicationNoteResponse, AxiosError<PostApiLoanApplicationsAddApplicationNoteError>, Options<PostApiLoanApplicationsAddApplicationNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAddApplicationNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsAddLenderProfileNoteQueryKey = (options?: Options<PostApiLoanApplicationsAddLenderProfileNoteData>) => [
    createQueryKey("postApiLoanApplicationsAddLenderProfileNote", options)
];

export const postApiLoanApplicationsAddLenderProfileNoteOptions = (options?: Options<PostApiLoanApplicationsAddLenderProfileNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAddLenderProfileNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAddLenderProfileNoteQueryKey(options)
}); };

export const postApiLoanApplicationsAddLenderProfileNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAddLenderProfileNoteResponse, AxiosError<PostApiLoanApplicationsAddLenderProfileNoteError>, Options<PostApiLoanApplicationsAddLenderProfileNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAddLenderProfileNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsParticipatingLoanApplicationQueryKey = (options?: Options<GetApiLoanApplicationsParticipatingLoanApplicationData>) => [
    createQueryKey("getApiLoanApplicationsParticipatingLoanApplication", options)
];

export const getApiLoanApplicationsParticipatingLoanApplicationOptions = (options?: Options<GetApiLoanApplicationsParticipatingLoanApplicationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsParticipatingLoanApplication({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsParticipatingLoanApplicationQueryKey(options)
}); };

export const getApiLoanApplicationsGetProfileFilesQueryKey = (options?: Options<GetApiLoanApplicationsGetProfileFilesData>) => [
    createQueryKey("getApiLoanApplicationsGetProfileFiles", options)
];

export const getApiLoanApplicationsGetProfileFilesOptions = (options?: Options<GetApiLoanApplicationsGetProfileFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetProfileFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetProfileFilesQueryKey(options)
}); };

export const getApiLoanApplicationsGetLoanApplicationPreviewQueryKey = (options?: Options<GetApiLoanApplicationsGetLoanApplicationPreviewData>) => [
    createQueryKey("getApiLoanApplicationsGetLoanApplicationPreview", options)
];

export const getApiLoanApplicationsGetLoanApplicationPreviewOptions = (options?: Options<GetApiLoanApplicationsGetLoanApplicationPreviewData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetLoanApplicationPreview({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetLoanApplicationPreviewQueryKey(options)
}); };

export const getApiLoanApplicationsGetLoanApplicationQueryKey = (options?: Options<GetApiLoanApplicationsGetLoanApplicationData>) => [
    createQueryKey("getApiLoanApplicationsGetLoanApplication", options)
];

export const getApiLoanApplicationsGetLoanApplicationOptions = (options?: Options<GetApiLoanApplicationsGetLoanApplicationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetLoanApplication({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetLoanApplicationQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLenderSummaryQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLenderSummaryData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLenderSummary", options)
];

export const postApiLoanApplicationsUpdateLenderSummaryOptions = (options?: Options<PostApiLoanApplicationsUpdateLenderSummaryData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLenderSummary({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLenderSummaryQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLenderSummaryMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLenderSummaryResponse, AxiosError<PostApiLoanApplicationsUpdateLenderSummaryError>, Options<PostApiLoanApplicationsUpdateLenderSummaryData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLenderSummary({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateLoanCommentaryQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLoanCommentaryData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLoanCommentary", options)
];

export const postApiLoanApplicationsUpdateLoanCommentaryOptions = (options?: Options<PostApiLoanApplicationsUpdateLoanCommentaryData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLoanCommentary({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLoanCommentaryQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanCommentaryMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLoanCommentaryResponse, AxiosError<PostApiLoanApplicationsUpdateLoanCommentaryError>, Options<PostApiLoanApplicationsUpdateLoanCommentaryData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLoanCommentary({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateLoanObjectiveQueryKey = (options?: Options<PostApiLoanApplicationsUpdateLoanObjectiveData>) => [
    createQueryKey("postApiLoanApplicationsUpdateLoanObjective", options)
];

export const postApiLoanApplicationsUpdateLoanObjectiveOptions = (options?: Options<PostApiLoanApplicationsUpdateLoanObjectiveData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateLoanObjective({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateLoanObjectiveQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateLoanObjectiveMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateLoanObjectiveResponse, AxiosError<PostApiLoanApplicationsUpdateLoanObjectiveError>, Options<PostApiLoanApplicationsUpdateLoanObjectiveData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateLoanObjective({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateProbabilityOfCloseQueryKey = (options?: Options<PostApiLoanApplicationsUpdateProbabilityOfCloseData>) => [
    createQueryKey("postApiLoanApplicationsUpdateProbabilityOfClose", options)
];

export const postApiLoanApplicationsUpdateProbabilityOfCloseOptions = (options?: Options<PostApiLoanApplicationsUpdateProbabilityOfCloseData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateProbabilityOfClose({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateProbabilityOfCloseQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateProbabilityOfCloseMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateProbabilityOfCloseResponse, AxiosError<PostApiLoanApplicationsUpdateProbabilityOfCloseError>, Options<PostApiLoanApplicationsUpdateProbabilityOfCloseData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateProbabilityOfClose({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsCreateLoanApplicationQueryKey = (options?: Options<PostApiLoanApplicationsCreateLoanApplicationData>) => [
    createQueryKey("postApiLoanApplicationsCreateLoanApplication", options)
];

export const postApiLoanApplicationsCreateLoanApplicationOptions = (options?: Options<PostApiLoanApplicationsCreateLoanApplicationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsCreateLoanApplication({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsCreateLoanApplicationQueryKey(options)
}); };

export const postApiLoanApplicationsCreateLoanApplicationMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsCreateLoanApplicationResponse, AxiosError<PostApiLoanApplicationsCreateLoanApplicationError>, Options<PostApiLoanApplicationsCreateLoanApplicationData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsCreateLoanApplication({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsUpdateDiligenceStatusQueryKey = (options?: Options<PostApiLoanApplicationsUpdateDiligenceStatusData>) => [
    createQueryKey("postApiLoanApplicationsUpdateDiligenceStatus", options)
];

export const postApiLoanApplicationsUpdateDiligenceStatusOptions = (options?: Options<PostApiLoanApplicationsUpdateDiligenceStatusData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsUpdateDiligenceStatus({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsUpdateDiligenceStatusQueryKey(options)
}); };

export const postApiLoanApplicationsUpdateDiligenceStatusMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsUpdateDiligenceStatusResponse, AxiosError<PostApiLoanApplicationsUpdateDiligenceStatusError>, Options<PostApiLoanApplicationsUpdateDiligenceStatusData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsUpdateDiligenceStatus({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsApproveLoanQueryKey = (options?: Options<PostApiLoanApplicationsApproveLoanData>) => [
    createQueryKey("postApiLoanApplicationsApproveLoan", options)
];

export const postApiLoanApplicationsApproveLoanOptions = (options?: Options<PostApiLoanApplicationsApproveLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsApproveLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsApproveLoanQueryKey(options)
}); };

export const postApiLoanApplicationsApproveLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsApproveLoanResponse, AxiosError<PostApiLoanApplicationsApproveLoanError>, Options<PostApiLoanApplicationsApproveLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsApproveLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsDownloadBorrowerReviewFileQueryKey = (options?: Options<GetApiLoanApplicationsDownloadBorrowerReviewFileData>) => [
    createQueryKey("getApiLoanApplicationsDownloadBorrowerReviewFile", options)
];

export const getApiLoanApplicationsDownloadBorrowerReviewFileOptions = (options?: Options<GetApiLoanApplicationsDownloadBorrowerReviewFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsDownloadBorrowerReviewFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsDownloadBorrowerReviewFileQueryKey(options)
}); };

export const getApiLoanApplicationsGetCalculatedMatchedLendersQueryKey = (options?: Options<GetApiLoanApplicationsGetCalculatedMatchedLendersData>) => [
    createQueryKey("getApiLoanApplicationsGetCalculatedMatchedLenders", options)
];

export const getApiLoanApplicationsGetCalculatedMatchedLendersOptions = (options?: Options<GetApiLoanApplicationsGetCalculatedMatchedLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetCalculatedMatchedLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetCalculatedMatchedLendersQueryKey(options)
}); };

export const getApiLoanApplicationsEngageableLendersQueryKey = (options?: Options<GetApiLoanApplicationsEngageableLendersData>) => [
    createQueryKey("getApiLoanApplicationsEngageableLenders", options)
];

export const getApiLoanApplicationsEngageableLendersOptions = (options?: Options<GetApiLoanApplicationsEngageableLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsEngageableLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsEngageableLendersQueryKey(options)
}); };

export const postApiLoanApplicationsAssignSpecialistQueryKey = (options?: Options<PostApiLoanApplicationsAssignSpecialistData>) => [
    createQueryKey("postApiLoanApplicationsAssignSpecialist", options)
];

export const postApiLoanApplicationsAssignSpecialistOptions = (options?: Options<PostApiLoanApplicationsAssignSpecialistData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAssignSpecialist({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAssignSpecialistQueryKey(options)
}); };

export const postApiLoanApplicationsAssignSpecialistMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAssignSpecialistResponse, AxiosError<PostApiLoanApplicationsAssignSpecialistError>, Options<PostApiLoanApplicationsAssignSpecialistData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAssignSpecialist({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsAssignAdditionalLenderQueryKey = (options?: Options<PostApiLoanApplicationsAssignAdditionalLenderData>) => [
    createQueryKey("postApiLoanApplicationsAssignAdditionalLender", options)
];

export const postApiLoanApplicationsAssignAdditionalLenderOptions = (options?: Options<PostApiLoanApplicationsAssignAdditionalLenderData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAssignAdditionalLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAssignAdditionalLenderQueryKey(options)
}); };

export const postApiLoanApplicationsAssignAdditionalLenderMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAssignAdditionalLenderResponse, AxiosError<PostApiLoanApplicationsAssignAdditionalLenderError>, Options<PostApiLoanApplicationsAssignAdditionalLenderData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAssignAdditionalLender({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsAssignAdditionalLendersQueryKey = (options?: Options<PostApiLoanApplicationsAssignAdditionalLendersData>) => [
    createQueryKey("postApiLoanApplicationsAssignAdditionalLenders", options)
];

export const postApiLoanApplicationsAssignAdditionalLendersOptions = (options?: Options<PostApiLoanApplicationsAssignAdditionalLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsAssignAdditionalLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsAssignAdditionalLendersQueryKey(options)
}); };

export const postApiLoanApplicationsAssignAdditionalLendersMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsAssignAdditionalLendersResponse, AxiosError<PostApiLoanApplicationsAssignAdditionalLendersError>, Options<PostApiLoanApplicationsAssignAdditionalLendersData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsAssignAdditionalLenders({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiLoanApplicationsWithdrawUnsubmittedLendersQueryKey = (options?: Options<PostApiLoanApplicationsWithdrawUnsubmittedLendersData>) => [
    createQueryKey("postApiLoanApplicationsWithdrawUnsubmittedLenders", options)
];

export const postApiLoanApplicationsWithdrawUnsubmittedLendersOptions = (options?: Options<PostApiLoanApplicationsWithdrawUnsubmittedLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiLoanApplicationsWithdrawUnsubmittedLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiLoanApplicationsWithdrawUnsubmittedLendersQueryKey(options)
}); };

export const postApiLoanApplicationsWithdrawUnsubmittedLendersMutation = () => { const mutationOptions: UseMutationOptions<PostApiLoanApplicationsWithdrawUnsubmittedLendersResponse, AxiosError<PostApiLoanApplicationsWithdrawUnsubmittedLendersError>, Options<PostApiLoanApplicationsWithdrawUnsubmittedLendersData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiLoanApplicationsWithdrawUnsubmittedLenders({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiLoanApplicationsAccessLoanApplicationQueryKey = (options?: Options<GetApiLoanApplicationsAccessLoanApplicationData>) => [
    createQueryKey("getApiLoanApplicationsAccessLoanApplication", options)
];

export const getApiLoanApplicationsAccessLoanApplicationOptions = (options?: Options<GetApiLoanApplicationsAccessLoanApplicationData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsAccessLoanApplication({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsAccessLoanApplicationQueryKey(options)
}); };

export const getApiLoanApplicationsGetTermSheetsQueryKey = (options?: Options<GetApiLoanApplicationsGetTermSheetsData>) => [
    createQueryKey("getApiLoanApplicationsGetTermSheets", options)
];

export const getApiLoanApplicationsGetTermSheetsOptions = (options?: Options<GetApiLoanApplicationsGetTermSheetsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiLoanApplicationsGetTermSheets({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiLoanApplicationsGetTermSheetsQueryKey(options)
}); };

export const getApiOffersGetOffersForReviewQueryKey = (options?: Options<GetApiOffersGetOffersForReviewData>) => [
    createQueryKey("getApiOffersGetOffersForReview", options)
];

export const getApiOffersGetOffersForReviewOptions = (options?: Options<GetApiOffersGetOffersForReviewData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiOffersGetOffersForReview({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiOffersGetOffersForReviewQueryKey(options)
}); };

export const postApiOffersReturnOffersToLendersQueryKey = (options?: Options<PostApiOffersReturnOffersToLendersData>) => [
    createQueryKey("postApiOffersReturnOffersToLenders", options)
];

export const postApiOffersReturnOffersToLendersOptions = (options?: Options<PostApiOffersReturnOffersToLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersReturnOffersToLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersReturnOffersToLendersQueryKey(options)
}); };

export const postApiOffersReturnOffersToLendersMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersReturnOffersToLendersResponse, AxiosError<PostApiOffersReturnOffersToLendersError>, Options<PostApiOffersReturnOffersToLendersData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersReturnOffersToLenders({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiOffersRenameOfferFileQueryKey = (options?: Options<PostApiOffersRenameOfferFileData>) => [
    createQueryKey("postApiOffersRenameOfferFile", options)
];

export const postApiOffersRenameOfferFileOptions = (options?: Options<PostApiOffersRenameOfferFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersRenameOfferFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersRenameOfferFileQueryKey(options)
}); };

export const postApiOffersRenameOfferFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersRenameOfferFileResponse, AxiosError<PostApiOffersRenameOfferFileError>, Options<PostApiOffersRenameOfferFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersRenameOfferFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiOffersDownloadOfferFileQueryKey = (options?: Options<GetApiOffersDownloadOfferFileData>) => [
    createQueryKey("getApiOffersDownloadOfferFile", options)
];

export const getApiOffersDownloadOfferFileOptions = (options?: Options<GetApiOffersDownloadOfferFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiOffersDownloadOfferFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiOffersDownloadOfferFileQueryKey(options)
}); };

export const postApiOffersDeleteOfferFileQueryKey = (options?: Options<PostApiOffersDeleteOfferFileData>) => [
    createQueryKey("postApiOffersDeleteOfferFile", options)
];

export const postApiOffersDeleteOfferFileOptions = (options?: Options<PostApiOffersDeleteOfferFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersDeleteOfferFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersDeleteOfferFileQueryKey(options)
}); };

export const postApiOffersDeleteOfferFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersDeleteOfferFileResponse, AxiosError<PostApiOffersDeleteOfferFileError>, Options<PostApiOffersDeleteOfferFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersDeleteOfferFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiOffersGetOfferFilesQueryKey = (options?: Options<GetApiOffersGetOfferFilesData>) => [
    createQueryKey("getApiOffersGetOfferFiles", options)
];

export const getApiOffersGetOfferFilesOptions = (options?: Options<GetApiOffersGetOfferFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiOffersGetOfferFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiOffersGetOfferFilesQueryKey(options)
}); };

export const postApiOffersApproveOffersQueryKey = (options?: Options<PostApiOffersApproveOffersData>) => [
    createQueryKey("postApiOffersApproveOffers", options)
];

export const postApiOffersApproveOffersOptions = (options?: Options<PostApiOffersApproveOffersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersApproveOffers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersApproveOffersQueryKey(options)
}); };

export const postApiOffersApproveOffersMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersApproveOffersResponse, AxiosError<PostApiOffersApproveOffersError>, Options<PostApiOffersApproveOffersData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersApproveOffers({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiOffersUploadOfferFileQueryKey = (options?: Options<PostApiOffersUploadOfferFileData>) => [
    createQueryKey("postApiOffersUploadOfferFile", options)
];

export const postApiOffersUploadOfferFileOptions = (options?: Options<PostApiOffersUploadOfferFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersUploadOfferFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersUploadOfferFileQueryKey(options)
}); };

export const postApiOffersUploadOfferFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersUploadOfferFileResponse, AxiosError<PostApiOffersUploadOfferFileError>, Options<PostApiOffersUploadOfferFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersUploadOfferFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiOffersSubmitNonBindingOfferQueryKey = (options?: Options<PostApiOffersSubmitNonBindingOfferData>) => [
    createQueryKey("postApiOffersSubmitNonBindingOffer", options)
];

export const postApiOffersSubmitNonBindingOfferOptions = (options?: Options<PostApiOffersSubmitNonBindingOfferData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersSubmitNonBindingOffer({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersSubmitNonBindingOfferQueryKey(options)
}); };

export const postApiOffersSubmitNonBindingOfferMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersSubmitNonBindingOfferResponse, AxiosError<PostApiOffersSubmitNonBindingOfferError>, Options<PostApiOffersSubmitNonBindingOfferData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersSubmitNonBindingOffer({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiOffersSubmitBindingOfferQueryKey = (options?: Options<PostApiOffersSubmitBindingOfferData>) => [
    createQueryKey("postApiOffersSubmitBindingOffer", options)
];

export const postApiOffersSubmitBindingOfferOptions = (options?: Options<PostApiOffersSubmitBindingOfferData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersSubmitBindingOffer({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersSubmitBindingOfferQueryKey(options)
}); };

export const postApiOffersSubmitBindingOfferMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersSubmitBindingOfferResponse, AxiosError<PostApiOffersSubmitBindingOfferError>, Options<PostApiOffersSubmitBindingOfferData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersSubmitBindingOffer({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiOffersAcceptLoanOfferQueryKey = (options?: Options<PostApiOffersAcceptLoanOfferData>) => [
    createQueryKey("postApiOffersAcceptLoanOffer", options)
];

export const postApiOffersAcceptLoanOfferOptions = (options?: Options<PostApiOffersAcceptLoanOfferData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersAcceptLoanOffer({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersAcceptLoanOfferQueryKey(options)
}); };

export const postApiOffersAcceptLoanOfferMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersAcceptLoanOfferResponse, AxiosError<PostApiOffersAcceptLoanOfferError>, Options<PostApiOffersAcceptLoanOfferData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersAcceptLoanOffer({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiOffersDeclineLoanOfferQueryKey = (options?: Options<PostApiOffersDeclineLoanOfferData>) => [
    createQueryKey("postApiOffersDeclineLoanOffer", options)
];

export const postApiOffersDeclineLoanOfferOptions = (options?: Options<PostApiOffersDeclineLoanOfferData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiOffersDeclineLoanOffer({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiOffersDeclineLoanOfferQueryKey(options)
}); };

export const postApiOffersDeclineLoanOfferMutation = () => { const mutationOptions: UseMutationOptions<PostApiOffersDeclineLoanOfferResponse, AxiosError<PostApiOffersDeclineLoanOfferError>, Options<PostApiOffersDeclineLoanOfferData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiOffersDeclineLoanOffer({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiOffersDownloadOfferPackageQueryKey = (options?: Options<GetApiOffersDownloadOfferPackageData>) => [
    createQueryKey("getApiOffersDownloadOfferPackage", options)
];

export const getApiOffersDownloadOfferPackageOptions = (options?: Options<GetApiOffersDownloadOfferPackageData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiOffersDownloadOfferPackage({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiOffersDownloadOfferPackageQueryKey(options)
}); };

export const postApiMessagesUploadMessageFileAttachmentsQueryKey = (options?: Options) => [
    createQueryKey("postApiMessagesUploadMessageFileAttachments", options)
];

export const postApiMessagesUploadMessageFileAttachmentsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiMessagesUploadMessageFileAttachments({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiMessagesUploadMessageFileAttachmentsQueryKey(options)
}); };

export const postApiMessagesUploadMessageFileAttachmentsMutation = () => { const mutationOptions: UseMutationOptions<PostApiMessagesUploadMessageFileAttachmentsResponse, AxiosError<PostApiMessagesUploadMessageFileAttachmentsError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiMessagesUploadMessageFileAttachments({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiMessagesDownloadLoanAppMessageAttachmentQueryKey = (options?: Options<GetApiMessagesDownloadLoanAppMessageAttachmentData>) => [
    createQueryKey("getApiMessagesDownloadLoanAppMessageAttachment", options)
];

export const getApiMessagesDownloadLoanAppMessageAttachmentOptions = (options?: Options<GetApiMessagesDownloadLoanAppMessageAttachmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiMessagesDownloadLoanAppMessageAttachment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiMessagesDownloadLoanAppMessageAttachmentQueryKey(options)
}); };

export const getApiMessagesGetLoanAppMessagesQueryKey = (options?: Options<GetApiMessagesGetLoanAppMessagesData>) => [
    createQueryKey("getApiMessagesGetLoanAppMessages", options)
];

export const getApiMessagesGetLoanAppMessagesOptions = (options?: Options<GetApiMessagesGetLoanAppMessagesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiMessagesGetLoanAppMessages({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiMessagesGetLoanAppMessagesQueryKey(options)
}); };

export const postApiMessagesSendLoanAppMessageQueryKey = (options?: Options<PostApiMessagesSendLoanAppMessageData>) => [
    createQueryKey("postApiMessagesSendLoanAppMessage", options)
];

export const postApiMessagesSendLoanAppMessageOptions = (options?: Options<PostApiMessagesSendLoanAppMessageData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiMessagesSendLoanAppMessage({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiMessagesSendLoanAppMessageQueryKey(options)
}); };

export const postApiMessagesSendLoanAppMessageMutation = () => { const mutationOptions: UseMutationOptions<PostApiMessagesSendLoanAppMessageResponse, AxiosError<PostApiMessagesSendLoanAppMessageError>, Options<PostApiMessagesSendLoanAppMessageData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiMessagesSendLoanAppMessage({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersSetActivePartnerQueryKey = (options?: Options<PostApiPartnersSetActivePartnerData>) => [
    createQueryKey("postApiPartnersSetActivePartner", options)
];

export const postApiPartnersSetActivePartnerOptions = (options?: Options<PostApiPartnersSetActivePartnerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersSetActivePartner({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersSetActivePartnerQueryKey(options)
}); };

export const postApiPartnersSetActivePartnerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersSetActivePartnerResponse, AxiosError<PostApiPartnersSetActivePartnerError>, Options<PostApiPartnersSetActivePartnerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersSetActivePartner({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersUploadPartnerFileQueryKey = (options?: Options<PostApiPartnersUploadPartnerFileData>) => [
    createQueryKey("postApiPartnersUploadPartnerFile", options)
];

export const postApiPartnersUploadPartnerFileOptions = (options?: Options<PostApiPartnersUploadPartnerFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersUploadPartnerFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUploadPartnerFileQueryKey(options)
}); };

export const postApiPartnersUploadPartnerFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersUploadPartnerFileResponse, AxiosError<PostApiPartnersUploadPartnerFileError>, Options<PostApiPartnersUploadPartnerFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersUploadPartnerFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersDeletePartnerFileQueryKey = (options?: Options<PostApiPartnersDeletePartnerFileData>) => [
    createQueryKey("postApiPartnersDeletePartnerFile", options)
];

export const postApiPartnersDeletePartnerFileOptions = (options?: Options<PostApiPartnersDeletePartnerFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersDeletePartnerFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersDeletePartnerFileQueryKey(options)
}); };

export const postApiPartnersDeletePartnerFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersDeletePartnerFileResponse, AxiosError<PostApiPartnersDeletePartnerFileError>, Options<PostApiPartnersDeletePartnerFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersDeletePartnerFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersDownloadPartnerFileQueryKey = (options?: Options<PostApiPartnersDownloadPartnerFileData>) => [
    createQueryKey("postApiPartnersDownloadPartnerFile", options)
];

export const postApiPartnersDownloadPartnerFileOptions = (options?: Options<PostApiPartnersDownloadPartnerFileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersDownloadPartnerFile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersDownloadPartnerFileQueryKey(options)
}); };

export const postApiPartnersDownloadPartnerFileMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersDownloadPartnerFileResponse, AxiosError<PostApiPartnersDownloadPartnerFileError>, Options<PostApiPartnersDownloadPartnerFileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersDownloadPartnerFile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersPartnerFilesQueryKey = (options?: Options<GetApiPartnersPartnerFilesData>) => [
    createQueryKey("getApiPartnersPartnerFiles", options)
];

export const getApiPartnersPartnerFilesOptions = (options?: Options<GetApiPartnersPartnerFilesData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersPartnerFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersPartnerFilesQueryKey(options)
}); };

export const getApiPartnersListQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersList", options)
];

export const getApiPartnersListOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersList({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersListQueryKey(options)
}); };

export const postApiPartnersDeleteDepartmentQueryKey = (options?: Options<PostApiPartnersDeleteDepartmentData>) => [
    createQueryKey("postApiPartnersDeleteDepartment", options)
];

export const postApiPartnersDeleteDepartmentOptions = (options?: Options<PostApiPartnersDeleteDepartmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersDeleteDepartment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersDeleteDepartmentQueryKey(options)
}); };

export const postApiPartnersDeleteDepartmentMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersDeleteDepartmentResponse, AxiosError<PostApiPartnersDeleteDepartmentError>, Options<PostApiPartnersDeleteDepartmentData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersDeleteDepartment({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersListDepartmentsQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersListDepartments", options)
];

export const getApiPartnersListDepartmentsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersListDepartments({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersListDepartmentsQueryKey(options)
}); };

export const getApiPartnersListUsersQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersListUsers", options)
];

export const getApiPartnersListUsersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersListUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersListUsersQueryKey(options)
}); };

export const postApiPartnersDeletePartnerLoanQueryKey = (options?: Options<PostApiPartnersDeletePartnerLoanData>) => [
    createQueryKey("postApiPartnersDeletePartnerLoan", options)
];

export const postApiPartnersDeletePartnerLoanOptions = (options?: Options<PostApiPartnersDeletePartnerLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersDeletePartnerLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersDeletePartnerLoanQueryKey(options)
}); };

export const postApiPartnersDeletePartnerLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersDeletePartnerLoanResponse, AxiosError<PostApiPartnersDeletePartnerLoanError>, Options<PostApiPartnersDeletePartnerLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersDeletePartnerLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersUpdatePartnerLoanQueryKey = (options?: Options<PostApiPartnersUpdatePartnerLoanData>) => [
    createQueryKey("postApiPartnersUpdatePartnerLoan", options)
];

export const postApiPartnersUpdatePartnerLoanOptions = (options?: Options<PostApiPartnersUpdatePartnerLoanData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersUpdatePartnerLoan({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUpdatePartnerLoanQueryKey(options)
}); };

export const postApiPartnersUpdatePartnerLoanMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersUpdatePartnerLoanResponse, AxiosError<PostApiPartnersUpdatePartnerLoanError>, Options<PostApiPartnersUpdatePartnerLoanData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersUpdatePartnerLoan({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersCapitalSimulatorHistoryQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersCapitalSimulatorHistory", options)
];

export const getApiPartnersCapitalSimulatorHistoryOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersCapitalSimulatorHistory({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersCapitalSimulatorHistoryQueryKey(options)
}); };

export const postApiPartnersAssignUserToDepartmentQueryKey = (options?: Options<PostApiPartnersAssignUserToDepartmentData>) => [
    createQueryKey("postApiPartnersAssignUserToDepartment", options)
];

export const postApiPartnersAssignUserToDepartmentOptions = (options?: Options<PostApiPartnersAssignUserToDepartmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersAssignUserToDepartment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersAssignUserToDepartmentQueryKey(options)
}); };

export const postApiPartnersAssignUserToDepartmentMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersAssignUserToDepartmentResponse, AxiosError<PostApiPartnersAssignUserToDepartmentError>, Options<PostApiPartnersAssignUserToDepartmentData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersAssignUserToDepartment({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersUpdateUserRoleQueryKey = (options?: Options<PostApiPartnersUpdateUserRoleData>) => [
    createQueryKey("postApiPartnersUpdateUserRole", options)
];

export const postApiPartnersUpdateUserRoleOptions = (options?: Options<PostApiPartnersUpdateUserRoleData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersUpdateUserRole({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUpdateUserRoleQueryKey(options)
}); };

export const postApiPartnersUpdateUserRoleMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersUpdateUserRoleResponse, AxiosError<PostApiPartnersUpdateUserRoleError>, Options<PostApiPartnersUpdateUserRoleData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersUpdateUserRole({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersAssignLoanToPartnerUserQueryKey = (options?: Options<PostApiPartnersAssignLoanToPartnerUserData>) => [
    createQueryKey("postApiPartnersAssignLoanToPartnerUser", options)
];

export const postApiPartnersAssignLoanToPartnerUserOptions = (options?: Options<PostApiPartnersAssignLoanToPartnerUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersAssignLoanToPartnerUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersAssignLoanToPartnerUserQueryKey(options)
}); };

export const postApiPartnersAssignLoanToPartnerUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersAssignLoanToPartnerUserResponse, AxiosError<PostApiPartnersAssignLoanToPartnerUserError>, Options<PostApiPartnersAssignLoanToPartnerUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersAssignLoanToPartnerUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersUpdatePartnerUserQueryKey = (options?: Options<PostApiPartnersUpdatePartnerUserData>) => [
    createQueryKey("postApiPartnersUpdatePartnerUser", options)
];

export const postApiPartnersUpdatePartnerUserOptions = (options?: Options<PostApiPartnersUpdatePartnerUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersUpdatePartnerUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUpdatePartnerUserQueryKey(options)
}); };

export const postApiPartnersUpdatePartnerUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersUpdatePartnerUserResponse, AxiosError<PostApiPartnersUpdatePartnerUserError>, Options<PostApiPartnersUpdatePartnerUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersUpdatePartnerUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersDepartmentLoansQueryKey = (options?: Options<GetApiPartnersDepartmentLoansData>) => [
    createQueryKey("getApiPartnersDepartmentLoans", options)
];

export const getApiPartnersDepartmentLoansOptions = (options?: Options<GetApiPartnersDepartmentLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersDepartmentLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersDepartmentLoansQueryKey(options)
}); };

export const getApiPartnersUserLoansQueryKey = (options?: Options<GetApiPartnersUserLoansData>) => [
    createQueryKey("getApiPartnersUserLoans", options)
];

export const getApiPartnersUserLoansOptions = (options?: Options<GetApiPartnersUserLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersUserLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersUserLoansQueryKey(options)
}); };

export const postApiPartnersInvitePartnerUserQueryKey = (options?: Options<PostApiPartnersInvitePartnerUserData>) => [
    createQueryKey("postApiPartnersInvitePartnerUser", options)
];

export const postApiPartnersInvitePartnerUserOptions = (options?: Options<PostApiPartnersInvitePartnerUserData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersInvitePartnerUser({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersInvitePartnerUserQueryKey(options)
}); };

export const postApiPartnersInvitePartnerUserMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersInvitePartnerUserResponse, AxiosError<PostApiPartnersInvitePartnerUserError>, Options<PostApiPartnersInvitePartnerUserData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersInvitePartnerUser({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersCreateDepartmentQueryKey = (options?: Options<PostApiPartnersCreateDepartmentData>) => [
    createQueryKey("postApiPartnersCreateDepartment", options)
];

export const postApiPartnersCreateDepartmentOptions = (options?: Options<PostApiPartnersCreateDepartmentData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersCreateDepartment({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersCreateDepartmentQueryKey(options)
}); };

export const postApiPartnersCreateDepartmentMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersCreateDepartmentResponse, AxiosError<PostApiPartnersCreateDepartmentError>, Options<PostApiPartnersCreateDepartmentData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersCreateDepartment({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersReferBorrowerQueryKey = (options?: Options<PostApiPartnersReferBorrowerData>) => [
    createQueryKey("postApiPartnersReferBorrower", options)
];

export const postApiPartnersReferBorrowerOptions = (options?: Options<PostApiPartnersReferBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersReferBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersReferBorrowerQueryKey(options)
}); };

export const postApiPartnersReferBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersReferBorrowerResponse, AxiosError<PostApiPartnersReferBorrowerError>, Options<PostApiPartnersReferBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersReferBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersBorrowersQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersBorrowers", options)
];

export const getApiPartnersBorrowersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersBorrowers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersBorrowersQueryKey(options)
}); };

export const getApiPartnersLoanPartnersQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersLoanPartners", options)
];

export const getApiPartnersLoanPartnersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersLoanPartners({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersLoanPartnersQueryKey(options)
}); };

export const getApiPartnersLoansQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersLoans", options)
];

export const getApiPartnersLoansOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersLoansQueryKey(options)
}); };

export const getApiPartnersSupervisorListLoansQueryKey = (options?: Options<GetApiPartnersSupervisorListLoansData>) => [
    createQueryKey("getApiPartnersSupervisorListLoans", options)
];

export const getApiPartnersSupervisorListLoansOptions = (options?: Options<GetApiPartnersSupervisorListLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersSupervisorListLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersSupervisorListLoansQueryKey(options)
}); };

export const postApiPartnersSupervisorUpdatePartnerRoleQueryKey = (options?: Options<PostApiPartnersSupervisorUpdatePartnerRoleData>) => [
    createQueryKey("postApiPartnersSupervisorUpdatePartnerRole", options)
];

export const postApiPartnersSupervisorUpdatePartnerRoleOptions = (options?: Options<PostApiPartnersSupervisorUpdatePartnerRoleData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersSupervisorUpdatePartnerRole({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersSupervisorUpdatePartnerRoleQueryKey(options)
}); };

export const postApiPartnersSupervisorUpdatePartnerRoleMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersSupervisorUpdatePartnerRoleResponse, AxiosError<PostApiPartnersSupervisorUpdatePartnerRoleError>, Options<PostApiPartnersSupervisorUpdatePartnerRoleData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersSupervisorUpdatePartnerRole({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersSupervisorListBorrowersQueryKey = (options?: Options<GetApiPartnersSupervisorListBorrowersData>) => [
    createQueryKey("getApiPartnersSupervisorListBorrowers", options)
];

export const getApiPartnersSupervisorListBorrowersOptions = (options?: Options<GetApiPartnersSupervisorListBorrowersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersSupervisorListBorrowers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersSupervisorListBorrowersQueryKey(options)
}); };

export const getApiPartnersSupervisorListUsersQueryKey = (options?: Options<GetApiPartnersSupervisorListUsersData>) => [
    createQueryKey("getApiPartnersSupervisorListUsers", options)
];

export const getApiPartnersSupervisorListUsersOptions = (options?: Options<GetApiPartnersSupervisorListUsersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersSupervisorListUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersSupervisorListUsersQueryKey(options)
}); };

export const getApiPartnersListGroupLoansQueryKey = (options?: Options<GetApiPartnersListGroupLoansData>) => [
    createQueryKey("getApiPartnersListGroupLoans", options)
];

export const getApiPartnersListGroupLoansOptions = (options?: Options<GetApiPartnersListGroupLoansData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersListGroupLoans({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersListGroupLoansQueryKey(options)
}); };

export const postApiPartnersDeleteQueryKey = (options?: Options<PostApiPartnersDeleteData>) => [
    createQueryKey("postApiPartnersDelete", options)
];

export const postApiPartnersDeleteOptions = (options?: Options<PostApiPartnersDeleteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersDelete({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersDeleteQueryKey(options)
}); };

export const postApiPartnersDeleteMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersDeleteResponse, AxiosError<PostApiPartnersDeleteError>, Options<PostApiPartnersDeleteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersDelete({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersUpdateQueryKey = (options?: Options<PostApiPartnersUpdateData>) => [
    createQueryKey("postApiPartnersUpdate", options)
];

export const postApiPartnersUpdateOptions = (options?: Options<PostApiPartnersUpdateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersUpdate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUpdateQueryKey(options)
}); };

export const postApiPartnersUpdateInfiniteQueryKey = (options?: Options<PostApiPartnersUpdateData>): QueryKey<Options<PostApiPartnersUpdateData>> => [
    createQueryKey("postApiPartnersUpdate", options, true)
];

export const postApiPartnersUpdateInfiniteOptions = (options?: Options<PostApiPartnersUpdateData>) => { return infiniteQueryOptions<PostApiPartnersUpdateResponse, AxiosError<PostApiPartnersUpdateError>, InfiniteData<PostApiPartnersUpdateResponse>, QueryKey<Options<PostApiPartnersUpdateData>>, string | Pick<QueryKey<Options<PostApiPartnersUpdateData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PostApiPartnersUpdateData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === "object" ? pageParam : {
            body: {
                startDate: pageParam
            }
        };
        const { data } = await postApiPartnersUpdate({
            ...options,
            ...queryKey[0],
            body: {
                ...queryKey[0].body as any,
                ...page.body as any
            },
            headers: {
                ...queryKey[0].headers,
                ...page.headers
            },
            path: {
                ...queryKey[0].path,
                ...page.path
            },
            query: {
                ...queryKey[0].query,
                ...page.query
            },
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUpdateInfiniteQueryKey(options)
}); };

export const postApiPartnersUpdateMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersUpdateResponse, AxiosError<PostApiPartnersUpdateError>, Options<PostApiPartnersUpdateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersUpdate({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersCreateQueryKey = (options?: Options<PostApiPartnersCreateData>) => [
    createQueryKey("postApiPartnersCreate", options)
];

export const postApiPartnersCreateOptions = (options?: Options<PostApiPartnersCreateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersCreate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersCreateQueryKey(options)
}); };

export const postApiPartnersCreateInfiniteQueryKey = (options?: Options<PostApiPartnersCreateData>): QueryKey<Options<PostApiPartnersCreateData>> => [
    createQueryKey("postApiPartnersCreate", options, true)
];

export const postApiPartnersCreateInfiniteOptions = (options?: Options<PostApiPartnersCreateData>) => { return infiniteQueryOptions<PostApiPartnersCreateResponse, AxiosError<PostApiPartnersCreateError>, InfiniteData<PostApiPartnersCreateResponse>, QueryKey<Options<PostApiPartnersCreateData>>, string | Pick<QueryKey<Options<PostApiPartnersCreateData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<PostApiPartnersCreateData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === "object" ? pageParam : {
            body: {
                startDate: pageParam
            }
        };
        const { data } = await postApiPartnersCreate({
            ...options,
            ...queryKey[0],
            body: {
                ...queryKey[0].body as any,
                ...page.body as any
            },
            headers: {
                ...queryKey[0].headers,
                ...page.headers
            },
            path: {
                ...queryKey[0].path,
                ...page.path
            },
            query: {
                ...queryKey[0].query,
                ...page.query
            },
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersCreateInfiniteQueryKey(options)
}); };

export const postApiPartnersCreateMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersCreateResponse, AxiosError<PostApiPartnersCreateError>, Options<PostApiPartnersCreateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersCreate({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersAddUserToPartnerQueryKey = (options?: Options<PostApiPartnersAddUserToPartnerData>) => [
    createQueryKey("postApiPartnersAddUserToPartner", options)
];

export const postApiPartnersAddUserToPartnerOptions = (options?: Options<PostApiPartnersAddUserToPartnerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersAddUserToPartner({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersAddUserToPartnerQueryKey(options)
}); };

export const postApiPartnersAddUserToPartnerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersAddUserToPartnerResponse, AxiosError<PostApiPartnersAddUserToPartnerError>, Options<PostApiPartnersAddUserToPartnerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersAddUserToPartner({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersRemoveUserFromPartnerQueryKey = (options?: Options<PostApiPartnersRemoveUserFromPartnerData>) => [
    createQueryKey("postApiPartnersRemoveUserFromPartner", options)
];

export const postApiPartnersRemoveUserFromPartnerOptions = (options?: Options<PostApiPartnersRemoveUserFromPartnerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersRemoveUserFromPartner({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersRemoveUserFromPartnerQueryKey(options)
}); };

export const postApiPartnersRemoveUserFromPartnerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersRemoveUserFromPartnerResponse, AxiosError<PostApiPartnersRemoveUserFromPartnerError>, Options<PostApiPartnersRemoveUserFromPartnerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersRemoveUserFromPartner({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersSupervisorAddLoanToPartnerQueryKey = (options?: Options<PostApiPartnersSupervisorAddLoanToPartnerData>) => [
    createQueryKey("postApiPartnersSupervisorAddLoanToPartner", options)
];

export const postApiPartnersSupervisorAddLoanToPartnerOptions = (options?: Options<PostApiPartnersSupervisorAddLoanToPartnerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersSupervisorAddLoanToPartner({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersSupervisorAddLoanToPartnerQueryKey(options)
}); };

export const postApiPartnersSupervisorAddLoanToPartnerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersSupervisorAddLoanToPartnerResponse, AxiosError<PostApiPartnersSupervisorAddLoanToPartnerError>, Options<PostApiPartnersSupervisorAddLoanToPartnerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersSupervisorAddLoanToPartner({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersSupervisorRemoveLoanFromPartnerQueryKey = (options?: Options<PostApiPartnersSupervisorRemoveLoanFromPartnerData>) => [
    createQueryKey("postApiPartnersSupervisorRemoveLoanFromPartner", options)
];

export const postApiPartnersSupervisorRemoveLoanFromPartnerOptions = (options?: Options<PostApiPartnersSupervisorRemoveLoanFromPartnerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersSupervisorRemoveLoanFromPartner({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersSupervisorRemoveLoanFromPartnerQueryKey(options)
}); };

export const postApiPartnersSupervisorRemoveLoanFromPartnerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersSupervisorRemoveLoanFromPartnerResponse, AxiosError<PostApiPartnersSupervisorRemoveLoanFromPartnerError>, Options<PostApiPartnersSupervisorRemoveLoanFromPartnerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersSupervisorRemoveLoanFromPartner({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersSupervisorAddBorrowerQueryKey = (options?: Options<PostApiPartnersSupervisorAddBorrowerData>) => [
    createQueryKey("postApiPartnersSupervisorAddBorrower", options)
];

export const postApiPartnersSupervisorAddBorrowerOptions = (options?: Options<PostApiPartnersSupervisorAddBorrowerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersSupervisorAddBorrower({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersSupervisorAddBorrowerQueryKey(options)
}); };

export const postApiPartnersSupervisorAddBorrowerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersSupervisorAddBorrowerResponse, AxiosError<PostApiPartnersSupervisorAddBorrowerError>, Options<PostApiPartnersSupervisorAddBorrowerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersSupervisorAddBorrower({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersSupervisorRemoveBorrowerFromPartnerQueryKey = (options?: Options<PostApiPartnersSupervisorRemoveBorrowerFromPartnerData>) => [
    createQueryKey("postApiPartnersSupervisorRemoveBorrowerFromPartner", options)
];

export const postApiPartnersSupervisorRemoveBorrowerFromPartnerOptions = (options?: Options<PostApiPartnersSupervisorRemoveBorrowerFromPartnerData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersSupervisorRemoveBorrowerFromPartner({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersSupervisorRemoveBorrowerFromPartnerQueryKey(options)
}); };

export const postApiPartnersSupervisorRemoveBorrowerFromPartnerMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersSupervisorRemoveBorrowerFromPartnerResponse, AxiosError<PostApiPartnersSupervisorRemoveBorrowerFromPartnerError>, Options<PostApiPartnersSupervisorRemoveBorrowerFromPartnerData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersSupervisorRemoveBorrowerFromPartner({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersCreatePartnerGroupQueryKey = (options?: Options<PostApiPartnersCreatePartnerGroupData>) => [
    createQueryKey("postApiPartnersCreatePartnerGroup", options)
];

export const postApiPartnersCreatePartnerGroupOptions = (options?: Options<PostApiPartnersCreatePartnerGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersCreatePartnerGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersCreatePartnerGroupQueryKey(options)
}); };

export const postApiPartnersCreatePartnerGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersCreatePartnerGroupResponse, AxiosError<PostApiPartnersCreatePartnerGroupError>, Options<PostApiPartnersCreatePartnerGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersCreatePartnerGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersUpdatePartnerGroupQueryKey = (options?: Options<PostApiPartnersUpdatePartnerGroupData>) => [
    createQueryKey("postApiPartnersUpdatePartnerGroup", options)
];

export const postApiPartnersUpdatePartnerGroupOptions = (options?: Options<PostApiPartnersUpdatePartnerGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersUpdatePartnerGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersUpdatePartnerGroupQueryKey(options)
}); };

export const postApiPartnersUpdatePartnerGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersUpdatePartnerGroupResponse, AxiosError<PostApiPartnersUpdatePartnerGroupError>, Options<PostApiPartnersUpdatePartnerGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersUpdatePartnerGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersDeletePartnerGroupQueryKey = (options?: Options<PostApiPartnersDeletePartnerGroupData>) => [
    createQueryKey("postApiPartnersDeletePartnerGroup", options)
];

export const postApiPartnersDeletePartnerGroupOptions = (options?: Options<PostApiPartnersDeletePartnerGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersDeletePartnerGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersDeletePartnerGroupQueryKey(options)
}); };

export const postApiPartnersDeletePartnerGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersDeletePartnerGroupResponse, AxiosError<PostApiPartnersDeletePartnerGroupError>, Options<PostApiPartnersDeletePartnerGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersDeletePartnerGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiPartnersAssignPartnerToGroupQueryKey = (options?: Options<PostApiPartnersAssignPartnerToGroupData>) => [
    createQueryKey("postApiPartnersAssignPartnerToGroup", options)
];

export const postApiPartnersAssignPartnerToGroupOptions = (options?: Options<PostApiPartnersAssignPartnerToGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiPartnersAssignPartnerToGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiPartnersAssignPartnerToGroupQueryKey(options)
}); };

export const postApiPartnersAssignPartnerToGroupMutation = () => { const mutationOptions: UseMutationOptions<PostApiPartnersAssignPartnerToGroupResponse, AxiosError<PostApiPartnersAssignPartnerToGroupError>, Options<PostApiPartnersAssignPartnerToGroupData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiPartnersAssignPartnerToGroup({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiPartnersGetPartnerGroupsQueryKey = (options?: Options) => [
    createQueryKey("getApiPartnersGetPartnerGroups", options)
];

export const getApiPartnersGetPartnerGroupsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersGetPartnerGroups({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersGetPartnerGroupsQueryKey(options)
}); };

export const getApiPartnersGetPartnerGroupQueryKey = (options?: Options<GetApiPartnersGetPartnerGroupData>) => [
    createQueryKey("getApiPartnersGetPartnerGroup", options)
];

export const getApiPartnersGetPartnerGroupOptions = (options?: Options<GetApiPartnersGetPartnerGroupData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiPartnersGetPartnerGroup({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPartnersGetPartnerGroupQueryKey(options)
}); };

export const postApiReferralsUploadReferralFilesQueryKey = (options?: Options) => [
    createQueryKey("postApiReferralsUploadReferralFiles", options)
];

export const postApiReferralsUploadReferralFilesOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsUploadReferralFiles({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsUploadReferralFilesQueryKey(options)
}); };

export const postApiReferralsUploadReferralFilesMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsUploadReferralFilesResponse, AxiosError<PostApiReferralsUploadReferralFilesError>, Options> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsUploadReferralFiles({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiReferralsDownloadReferralPackageQueryKey = (options?: Options<GetApiReferralsDownloadReferralPackageData>) => [
    createQueryKey("getApiReferralsDownloadReferralPackage", options)
];

export const getApiReferralsDownloadReferralPackageOptions = (options?: Options<GetApiReferralsDownloadReferralPackageData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiReferralsDownloadReferralPackage({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiReferralsDownloadReferralPackageQueryKey(options)
}); };

export const postApiReferralsSpecialistSubmitReferralQueryKey = (options?: Options<PostApiReferralsSpecialistSubmitReferralData>) => [
    createQueryKey("postApiReferralsSpecialistSubmitReferral", options)
];

export const postApiReferralsSpecialistSubmitReferralOptions = (options?: Options<PostApiReferralsSpecialistSubmitReferralData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsSpecialistSubmitReferral({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsSpecialistSubmitReferralQueryKey(options)
}); };

export const postApiReferralsSpecialistSubmitReferralMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsSpecialistSubmitReferralResponse, AxiosError<PostApiReferralsSpecialistSubmitReferralError>, Options<PostApiReferralsSpecialistSubmitReferralData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsSpecialistSubmitReferral({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiReferralsSubmitReferralQueryKey = (options?: Options<PostApiReferralsSubmitReferralData>) => [
    createQueryKey("postApiReferralsSubmitReferral", options)
];

export const postApiReferralsSubmitReferralOptions = (options?: Options<PostApiReferralsSubmitReferralData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsSubmitReferral({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsSubmitReferralQueryKey(options)
}); };

export const postApiReferralsSubmitReferralMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsSubmitReferralResponse, AxiosError<PostApiReferralsSubmitReferralError>, Options<PostApiReferralsSubmitReferralData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsSubmitReferral({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiReferralsSetLoanAppReferralQueryKey = (options?: Options<PostApiReferralsSetLoanAppReferralData>) => [
    createQueryKey("postApiReferralsSetLoanAppReferral", options)
];

export const postApiReferralsSetLoanAppReferralOptions = (options?: Options<PostApiReferralsSetLoanAppReferralData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsSetLoanAppReferral({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsSetLoanAppReferralQueryKey(options)
}); };

export const postApiReferralsSetLoanAppReferralMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsSetLoanAppReferralResponse, AxiosError<PostApiReferralsSetLoanAppReferralError>, Options<PostApiReferralsSetLoanAppReferralData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsSetLoanAppReferral({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiReferralsUpdateReferralStateQueryKey = (options?: Options<PostApiReferralsUpdateReferralStateData>) => [
    createQueryKey("postApiReferralsUpdateReferralState", options)
];

export const postApiReferralsUpdateReferralStateOptions = (options?: Options<PostApiReferralsUpdateReferralStateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsUpdateReferralState({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsUpdateReferralStateQueryKey(options)
}); };

export const postApiReferralsUpdateReferralStateMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsUpdateReferralStateResponse, AxiosError<PostApiReferralsUpdateReferralStateError>, Options<PostApiReferralsUpdateReferralStateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsUpdateReferralState({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiReferralsUpdateReferralQueryKey = (options?: Options<PostApiReferralsUpdateReferralData>) => [
    createQueryKey("postApiReferralsUpdateReferral", options)
];

export const postApiReferralsUpdateReferralOptions = (options?: Options<PostApiReferralsUpdateReferralData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsUpdateReferral({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsUpdateReferralQueryKey(options)
}); };

export const postApiReferralsUpdateReferralMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsUpdateReferralResponse, AxiosError<PostApiReferralsUpdateReferralError>, Options<PostApiReferralsUpdateReferralData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsUpdateReferral({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiReferralsUpdateReferralDashboardNoteQueryKey = (options?: Options<PostApiReferralsUpdateReferralDashboardNoteData>) => [
    createQueryKey("postApiReferralsUpdateReferralDashboardNote", options)
];

export const postApiReferralsUpdateReferralDashboardNoteOptions = (options?: Options<PostApiReferralsUpdateReferralDashboardNoteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiReferralsUpdateReferralDashboardNote({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiReferralsUpdateReferralDashboardNoteQueryKey(options)
}); };

export const postApiReferralsUpdateReferralDashboardNoteMutation = () => { const mutationOptions: UseMutationOptions<PostApiReferralsUpdateReferralDashboardNoteResponse, AxiosError<PostApiReferralsUpdateReferralDashboardNoteError>, Options<PostApiReferralsUpdateReferralDashboardNoteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiReferralsUpdateReferralDashboardNote({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiReferralsGetAllReferralsQueryKey = (options?: Options) => [
    createQueryKey("getApiReferralsGetAllReferrals", options)
];

export const getApiReferralsGetAllReferralsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiReferralsGetAllReferrals({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiReferralsGetAllReferralsQueryKey(options)
}); };

export const getApiReferralsGetReferralsForLenderQueryKey = (options?: Options) => [
    createQueryKey("getApiReferralsGetReferralsForLender", options)
];

export const getApiReferralsGetReferralsForLenderOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiReferralsGetReferralsForLender({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiReferralsGetReferralsForLenderQueryKey(options)
}); };

export const getApiTemplatesEvaluateWithDefaultTemplateQueryKey = (options?: Options<GetApiTemplatesEvaluateWithDefaultTemplateData>) => [
    createQueryKey("getApiTemplatesEvaluateWithDefaultTemplate", options)
];

export const getApiTemplatesEvaluateWithDefaultTemplateOptions = (options?: Options<GetApiTemplatesEvaluateWithDefaultTemplateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiTemplatesEvaluateWithDefaultTemplate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTemplatesEvaluateWithDefaultTemplateQueryKey(options)
}); };

export const postApiTemplatesRecommendGenericLoanTypeQueryKey = (options?: Options<PostApiTemplatesRecommendGenericLoanTypeData>) => [
    createQueryKey("postApiTemplatesRecommendGenericLoanType", options)
];

export const postApiTemplatesRecommendGenericLoanTypeOptions = (options?: Options<PostApiTemplatesRecommendGenericLoanTypeData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesRecommendGenericLoanType({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesRecommendGenericLoanTypeQueryKey(options)
}); };

export const postApiTemplatesRecommendGenericLoanTypeMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesRecommendGenericLoanTypeResponse, AxiosError<PostApiTemplatesRecommendGenericLoanTypeError>, Options<PostApiTemplatesRecommendGenericLoanTypeData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesRecommendGenericLoanType({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiTemplatesEvaluateRsgDashboardQueryKey = (options?: Options) => [
    createQueryKey("getApiTemplatesEvaluateRsgDashboard", options)
];

export const getApiTemplatesEvaluateRsgDashboardOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiTemplatesEvaluateRsgDashboard({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTemplatesEvaluateRsgDashboardQueryKey(options)
}); };

export const getApiTemplatesEvaluateWithTemplateQueryKey = (options?: Options<GetApiTemplatesEvaluateWithTemplateData>) => [
    createQueryKey("getApiTemplatesEvaluateWithTemplate", options)
];

export const getApiTemplatesEvaluateWithTemplateOptions = (options?: Options<GetApiTemplatesEvaluateWithTemplateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiTemplatesEvaluateWithTemplate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTemplatesEvaluateWithTemplateQueryKey(options)
}); };

export const getApiTemplatesListQueryKey = (options?: Options) => [
    createQueryKey("getApiTemplatesList", options)
];

export const getApiTemplatesListOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiTemplatesList({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTemplatesListQueryKey(options)
}); };

export const getApiTemplatesTemplateMapQueryKey = (options?: Options) => [
    createQueryKey("getApiTemplatesTemplateMap", options)
];

export const getApiTemplatesTemplateMapOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiTemplatesTemplateMap({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTemplatesTemplateMapQueryKey(options)
}); };

export const postApiTemplatesValidateCustomMetricFormulaQueryKey = (options?: Options<PostApiTemplatesValidateCustomMetricFormulaData>) => [
    createQueryKey("postApiTemplatesValidateCustomMetricFormula", options)
];

export const postApiTemplatesValidateCustomMetricFormulaOptions = (options?: Options<PostApiTemplatesValidateCustomMetricFormulaData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesValidateCustomMetricFormula({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesValidateCustomMetricFormulaQueryKey(options)
}); };

export const postApiTemplatesValidateCustomMetricFormulaMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesValidateCustomMetricFormulaResponse, AxiosError<PostApiTemplatesValidateCustomMetricFormulaError>, Options<PostApiTemplatesValidateCustomMetricFormulaData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesValidateCustomMetricFormula({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiTemplatesCustomMetricsQueryKey = (options?: Options) => [
    createQueryKey("getApiTemplatesCustomMetrics", options)
];

export const getApiTemplatesCustomMetricsOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiTemplatesCustomMetrics({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiTemplatesCustomMetricsQueryKey(options)
}); };

export const postApiTemplatesCreateCustomMetricQueryKey = (options?: Options<PostApiTemplatesCreateCustomMetricData>) => [
    createQueryKey("postApiTemplatesCreateCustomMetric", options)
];

export const postApiTemplatesCreateCustomMetricOptions = (options?: Options<PostApiTemplatesCreateCustomMetricData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesCreateCustomMetric({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesCreateCustomMetricQueryKey(options)
}); };

export const postApiTemplatesCreateCustomMetricMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesCreateCustomMetricResponse, AxiosError<PostApiTemplatesCreateCustomMetricError>, Options<PostApiTemplatesCreateCustomMetricData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesCreateCustomMetric({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiTemplatesUpdateCustomMetricQueryKey = (options?: Options<PostApiTemplatesUpdateCustomMetricData>) => [
    createQueryKey("postApiTemplatesUpdateCustomMetric", options)
];

export const postApiTemplatesUpdateCustomMetricOptions = (options?: Options<PostApiTemplatesUpdateCustomMetricData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesUpdateCustomMetric({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesUpdateCustomMetricQueryKey(options)
}); };

export const postApiTemplatesUpdateCustomMetricMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesUpdateCustomMetricResponse, AxiosError<PostApiTemplatesUpdateCustomMetricError>, Options<PostApiTemplatesUpdateCustomMetricData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesUpdateCustomMetric({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiTemplatesDeleteCustomMetricQueryKey = (options?: Options<PostApiTemplatesDeleteCustomMetricData>) => [
    createQueryKey("postApiTemplatesDeleteCustomMetric", options)
];

export const postApiTemplatesDeleteCustomMetricOptions = (options?: Options<PostApiTemplatesDeleteCustomMetricData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesDeleteCustomMetric({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesDeleteCustomMetricQueryKey(options)
}); };

export const postApiTemplatesDeleteCustomMetricMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesDeleteCustomMetricResponse, AxiosError<PostApiTemplatesDeleteCustomMetricError>, Options<PostApiTemplatesDeleteCustomMetricData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesDeleteCustomMetric({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiTemplatesCreateQueryKey = (options?: Options<PostApiTemplatesCreateData>) => [
    createQueryKey("postApiTemplatesCreate", options)
];

export const postApiTemplatesCreateOptions = (options?: Options<PostApiTemplatesCreateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesCreate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesCreateQueryKey(options)
}); };

export const postApiTemplatesCreateMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesCreateResponse, AxiosError<PostApiTemplatesCreateError>, Options<PostApiTemplatesCreateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesCreate({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiTemplatesUpdateQueryKey = (options?: Options<PostApiTemplatesUpdateData>) => [
    createQueryKey("postApiTemplatesUpdate", options)
];

export const postApiTemplatesUpdateOptions = (options?: Options<PostApiTemplatesUpdateData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesUpdate({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesUpdateQueryKey(options)
}); };

export const postApiTemplatesUpdateMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesUpdateResponse, AxiosError<PostApiTemplatesUpdateError>, Options<PostApiTemplatesUpdateData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesUpdate({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const postApiTemplatesDeleteQueryKey = (options?: Options<PostApiTemplatesDeleteData>) => [
    createQueryKey("postApiTemplatesDelete", options)
];

export const postApiTemplatesDeleteOptions = (options?: Options<PostApiTemplatesDeleteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiTemplatesDelete({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiTemplatesDeleteQueryKey(options)
}); };

export const postApiTemplatesDeleteMutation = () => { const mutationOptions: UseMutationOptions<PostApiTemplatesDeleteResponse, AxiosError<PostApiTemplatesDeleteError>, Options<PostApiTemplatesDeleteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiTemplatesDelete({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiUsersAllQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersAll", options)
];

export const getApiUsersAllOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersAll({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersAllQueryKey(options)
}); };

export const postApiUsersStartResetPasswordQueryKey = (options?: Options<PostApiUsersStartResetPasswordData>) => [
    createQueryKey("postApiUsersStartResetPassword", options)
];

export const postApiUsersStartResetPasswordOptions = (options?: Options<PostApiUsersStartResetPasswordData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiUsersStartResetPassword({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiUsersStartResetPasswordQueryKey(options)
}); };

export const postApiUsersStartResetPasswordMutation = () => { const mutationOptions: UseMutationOptions<PostApiUsersStartResetPasswordResponse, AxiosError<PostApiUsersStartResetPasswordError>, Options<PostApiUsersStartResetPasswordData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiUsersStartResetPassword({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiUsersCheckPasswordResetTokenQueryKey = (options?: Options<GetApiUsersCheckPasswordResetTokenData>) => [
    createQueryKey("getApiUsersCheckPasswordResetToken", options)
];

export const getApiUsersCheckPasswordResetTokenOptions = (options?: Options<GetApiUsersCheckPasswordResetTokenData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersCheckPasswordResetToken({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersCheckPasswordResetTokenQueryKey(options)
}); };

export const postApiUsersResetPasswordQueryKey = (options?: Options<PostApiUsersResetPasswordData>) => [
    createQueryKey("postApiUsersResetPassword", options)
];

export const postApiUsersResetPasswordOptions = (options?: Options<PostApiUsersResetPasswordData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiUsersResetPassword({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiUsersResetPasswordQueryKey(options)
}); };

export const postApiUsersResetPasswordMutation = () => { const mutationOptions: UseMutationOptions<PostApiUsersResetPasswordResponse, AxiosError<PostApiUsersResetPasswordError>, Options<PostApiUsersResetPasswordData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiUsersResetPassword({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiUsersNotificationsQueryKey = (options?: Options<GetApiUsersNotificationsData>) => [
    createQueryKey("getApiUsersNotifications", options)
];

export const getApiUsersNotificationsOptions = (options?: Options<GetApiUsersNotificationsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersNotifications({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersNotificationsQueryKey(options)
}); };

export const postApiUsersDismissAllNotificationsQueryKey = (options?: Options<PostApiUsersDismissAllNotificationsData>) => [
    createQueryKey("postApiUsersDismissAllNotifications", options)
];

export const postApiUsersDismissAllNotificationsOptions = (options?: Options<PostApiUsersDismissAllNotificationsData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiUsersDismissAllNotifications({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiUsersDismissAllNotificationsQueryKey(options)
}); };

export const postApiUsersDismissAllNotificationsMutation = () => { const mutationOptions: UseMutationOptions<PostApiUsersDismissAllNotificationsResponse, AxiosError<PostApiUsersDismissAllNotificationsError>, Options<PostApiUsersDismissAllNotificationsData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiUsersDismissAllNotifications({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiUsersUserHistoryQueryKey = (options?: Options<GetApiUsersUserHistoryData>) => [
    createQueryKey("getApiUsersUserHistory", options)
];

export const getApiUsersUserHistoryOptions = (options?: Options<GetApiUsersUserHistoryData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersUserHistory({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersUserHistoryQueryKey(options)
}); };

export const getApiUsersGetFullAuditExportQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersGetFullAuditExport", options)
];

export const getApiUsersGetFullAuditExportOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersGetFullAuditExport({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersGetFullAuditExportQueryKey(options)
}); };

export const getApiUsersUserLendersQueryKey = (options?: Options<GetApiUsersUserLendersData>) => [
    createQueryKey("getApiUsersUserLenders", options)
];

export const getApiUsersUserLendersOptions = (options?: Options<GetApiUsersUserLendersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersUserLenders({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersUserLendersQueryKey(options)
}); };

export const getApiUsersUserBackgroundCheckQueryKey = (options?: Options<GetApiUsersUserBackgroundCheckData>) => [
    createQueryKey("getApiUsersUserBackgroundCheck", options)
];

export const getApiUsersUserBackgroundCheckOptions = (options?: Options<GetApiUsersUserBackgroundCheckData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersUserBackgroundCheck({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersUserBackgroundCheckQueryKey(options)
}); };

export const postApiUsersUserUpdateBackgroundCheckQueryKey = (options?: Options<PostApiUsersUserUpdateBackgroundCheckData>) => [
    createQueryKey("postApiUsersUserUpdateBackgroundCheck", options)
];

export const postApiUsersUserUpdateBackgroundCheckOptions = (options?: Options<PostApiUsersUserUpdateBackgroundCheckData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiUsersUserUpdateBackgroundCheck({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiUsersUserUpdateBackgroundCheckQueryKey(options)
}); };

export const postApiUsersUserUpdateBackgroundCheckMutation = () => { const mutationOptions: UseMutationOptions<PostApiUsersUserUpdateBackgroundCheckResponse, AxiosError<PostApiUsersUserUpdateBackgroundCheckError>, Options<PostApiUsersUserUpdateBackgroundCheckData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiUsersUserUpdateBackgroundCheck({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiUsersUserBorrowersQueryKey = (options?: Options<GetApiUsersUserBorrowersData>) => [
    createQueryKey("getApiUsersUserBorrowers", options)
];

export const getApiUsersUserBorrowersOptions = (options?: Options<GetApiUsersUserBorrowersData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersUserBorrowers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersUserBorrowersQueryKey(options)
}); };

export const getApiUsersPartnerContextQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersPartnerContext", options)
];

export const getApiUsersPartnerContextOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersPartnerContext({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersPartnerContextQueryKey(options)
}); };

export const getApiUsersLenderContextQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersLenderContext", options)
];

export const getApiUsersLenderContextOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersLenderContext({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersLenderContextQueryKey(options)
}); };

export const getApiUsersBorrowerContextQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersBorrowerContext", options)
];

export const getApiUsersBorrowerContextOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersBorrowerContext({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersBorrowerContextQueryKey(options)
}); };

export const getApiUsersMeQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersMe", options)
];

export const getApiUsersMeOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersMe({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersMeQueryKey(options)
}); };

export const postApiUsersUpdateProfileQueryKey = (options?: Options<PostApiUsersUpdateProfileData>) => [
    createQueryKey("postApiUsersUpdateProfile", options)
];

export const postApiUsersUpdateProfileOptions = (options?: Options<PostApiUsersUpdateProfileData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiUsersUpdateProfile({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiUsersUpdateProfileQueryKey(options)
}); };

export const postApiUsersUpdateProfileMutation = () => { const mutationOptions: UseMutationOptions<PostApiUsersUpdateProfileResponse, AxiosError<PostApiUsersUpdateProfileError>, Options<PostApiUsersUpdateProfileData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiUsersUpdateProfile({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };

export const getApiUsersGetSpecialistUsersQueryKey = (options?: Options) => [
    createQueryKey("getApiUsersGetSpecialistUsers", options)
];

export const getApiUsersGetSpecialistUsersOptions = (options?: Options) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersGetSpecialistUsers({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersGetSpecialistUsersQueryKey(options)
}); };

export const getApiUsersUserActivityQueryKey = (options?: Options<GetApiUsersUserActivityData>) => [
    createQueryKey("getApiUsersUserActivity", options)
];

export const getApiUsersUserActivityOptions = (options?: Options<GetApiUsersUserActivityData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await getApiUsersUserActivity({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiUsersUserActivityQueryKey(options)
}); };

export const postApiUsersInviteQueryKey = (options?: Options<PostApiUsersInviteData>) => [
    createQueryKey("postApiUsersInvite", options)
];

export const postApiUsersInviteOptions = (options?: Options<PostApiUsersInviteData>) => { return queryOptions({
    queryFn: async ({ queryKey }) => {
        const { data } = await postApiUsersInvite({
            ...options,
            ...queryKey[0],
            throwOnError: true
        });
        return data;
    },
    queryKey: postApiUsersInviteQueryKey(options)
}); };

export const postApiUsersInviteMutation = () => { const mutationOptions: UseMutationOptions<PostApiUsersInviteResponse, AxiosError<PostApiUsersInviteError>, Options<PostApiUsersInviteData>> = {
    mutationFn: async (options) => {
        const { data } = await postApiUsersInvite({
            ...options,
            throwOnError: true
        });
        return data;
    }
}; return mutationOptions; };